import { ChildOrThirdPaxValidation, ClientMainValidation, FirstPaxValidation, FormPaxesReservationData, formPaxesReservationData, getValidationsForIndex, OnlyTransportValidation, PaxEmpty, paxEmpty, PaxValidationConfig, routes, RoutesAPI, SecondPaxValidation, Titles, titles, ValidateFormFirstPaxes, ValidateFormOnlyTransport, ValidateFormSecondPaxes, ValidateFormThirdOrChildren } from './form-paxes-reservation-data';
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef,
  OnDestroy,
  QueryList,
  ViewChildren,
  HostListener,
  ChangeDetectorRef,
  AfterViewInit,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormArray, FormControl, AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";
import { RestService } from "../../../shared/rest.service";
import { NavigationExtras, Router } from "@angular/router";
import {  BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { BsDatepickerConfig, BsDatepickerDirective, BsLocaleService } from "ngx-bootstrap/datepicker";
import { DatePipe } from "@angular/common";
import * as moment from "moment";
import { ItineraryService } from "../../../shared/itinerary.service";
import { UserService } from "../../../pages/com.usblick.common/auth/user.service";
import { setting } from "../../../../../setting";
import { Observable, Subject, Subscription } from "rxjs";
import { NgxSpinnerService } from "ngx-spinner";
import { ClientData, clientData } from './client-data';
import { HttpErrorResponse } from '@angular/common/http';
import { FormPaxesReservationService } from './form-paxes-reservation.service';
import { debounceTime, distinctUntilChanged, map, startWith } from 'rxjs/operators';
import { cleanString, normalizeText } from 'utils/helpers';
import { ConfirmationModalComponent } from 'app/shared/modals/confirmation-modal/confirmation-modal.component';
import { NotificationService } from '../../../shared/notifications/notification.service'

interface ValidationResult {
  isValid: boolean;
  missingFields: { field: string, message: string }[];
  passengerIndex: number;
  passengerType: string;
}

@Component({
  selector: "usb-form-paxes-reservation",
  templateUrl: "./form-paxes-reservation.component.html",
  styleUrls: ["./form-paxes-reservation.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DatePipe],
})
export class FormPaxesReservationComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy{
  @ViewChildren("document_number_child", { read: ElementRef }) documentNumberChild: QueryList<ElementRef>;
  @ViewChildren("document_number", { read: ElementRef }) documentNumber: QueryList<ElementRef>;
  @ViewChildren("email_children", { read: ElementRef }) emailChildren: QueryList<ElementRef>;
  @ViewChildren("address_children", { read: ElementRef }) addressChildren: QueryList<ElementRef>;
  @ViewChildren("city_children", { read: ElementRef }) cityChildren: QueryList<ElementRef>;
  @ViewChildren("typeDocumentChild", { read: ElementRef }) typeDocumentChildren: QueryList<ElementRef>;
  @ViewChildren("countryChild", { read: ElementRef }) countryChildren: QueryList<ElementRef>;
  @ViewChildren("stateChild", { read: ElementRef }) stateChildren: QueryList<ElementRef>;
  @ViewChildren("phoneChild", { read: ElementRef }) phoneChildren: QueryList<ElementRef>;
  @ViewChildren("phoneCode", { read: ElementRef }) phoneCode: QueryList<ElementRef>;
  @ViewChildren("document_type_id", { read: ElementRef }) document_type_id: QueryList<ElementRef>;
  @ViewChild('selectClient') selectClient: QueryList<ElementRef>;
  @ViewChild("emailInput") emailInput: ElementRef;
  @ViewChild("startDateDp", { static: false }) startDateDp?: BsDatepickerDirective;
  @HostListener("window:scroll")
  onScrollEvent() {
    this.startDateDp?.hide();
  }
  @Input() formPaxesReservationData: FormPaxesReservationData;
  @Input() adults: any;
  @Input() children: any;
  @Input() formSended: boolean;
  @Input() permitedConfiguration: boolean;
  @Input() paxes: any = [];
  @Input() from: string;
  @Input() paxNumber: Number;
  @Input() itineraryId: any;
  @Input() step: string;
  @Input() itineraryItems: any = [];
  @Input() itineraryTotal: any;
  @Input() clientOwner: any;
  @Input() itinerary: any;
  @Input() clientSelecFormPaxes: any[];
  @Input() currencies: any[];
  @Input() currencyAgency: any;
  @Input() totalPasajeros: any;
  @Input() countries: any[];
  @Input() typeAction: any; // Puede ser 'New', true, false
  @Input() fromAssociates: boolean = false;
  @Input() mainClient: any;
  @Input() clients: any[];
  @Input() clientAssociatedArr: any[];
  @Input() index: number;
  @Input() associateClient: any;
  @Input() associateClientIndex: number;
  @Input() paxesReload: any[] = [];
  @Input() onlyTransports!: boolean;

  @Output() _loading = new EventEmitter<any>(); // emit() abre el loader, emit(false) lo cierra
  // Errores devueltos por update/paxlist: { [paxIndex]: { [field]: { message, value } } }
  serverPaxErrors: { [index: number]: { [field: string]: { message: string; value: any } } } = {};
  // Último pedido de ciudades por pax (getCitiesData), para descartar respuestas viejas
  citiesRequestId: { [index: number]: number } = {};
  @Output() numberPositionChanged = new EventEmitter<number>();
  @Output() clientSelectedArr = new EventEmitter<any[]>();
  @Output() confirmResult = new EventEmitter<boolean>();
  @Output() valueQtyPaxModified = new EventEmitter<any>();
  @Output() reloadPaxlist = new EventEmitter<any>();


  selectedIsCountry: any[] = [];
  selectedIsState: any[] = [];
  selectedIsCity: any[] = [];
  phone_code: any[] = [];
  phone_2_code: any[] = [];
  isPhoneValidating: boolean[] = [];
  editDataPax: boolean[] = [];

  associatedClients: any[] = [];

  // public formPaxesReservationData: FormPaxesReservationData = formPaxesReservationData;
  public clientData: ClientData = clientData;
  public paxEmpty: PaxEmpty = paxEmpty;



  public dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  public childDatepickerConfig: Partial<BsDatepickerConfig> = {
    dateInputFormat: 'DD/MM',
    showWeekNumbers: true,

  };


  public _form: FormGroup;

  private countriesSubscription: Subscription;
  private stateByCountrySubscription: Subscription;

  loadedClientInfoForm: boolean = false;

  showDropdown = false;
  selectedCountryName = '';
  filteredCountries = [];
  stateFiltered = [];
  citiesFiltered = [];
  namesPaxes: string[] = [];


  titles: Titles[] = titles;

  data: any;
  // typeAction: string;
  // fromAssociates: boolean;
  // index: number;
  // mainClient: any;
  // clientAssociatedArr: any[] = [];
  // clients: any[] = [];
  // associateClient: any;
  // associateClientIndex: number;
  firstCharge: boolean = true;
  selectedClientAssociated: boolean = false;
  selectClientFormPaxes: boolean = false;
  getClientsSettingAppBooking: any;

  appLoading: boolean = true;
  dataClientBefore: boolean = false;
  private intervalId: any;
  newClientSelectedList: any;
  formStyles: { backgroundColor: string, pointerEvents: string }[] = [];
  countryCheck: boolean[];
  stateCheck: boolean[];
  cityCheck: boolean[];
  phoneCodeCheck: boolean[];
  phoneCode2Check: boolean[];
  filteredClientAssociated: any[] = [];
  clientSearchControls: FormControl[] = [];
  filteredClients: Observable<any[]>[] = [];
  clientsVerifyExists: any[] = [];
  currentDate: Date = new Date();
  filteredClientsAssociated: any[] = [];
  associatedFilterView: boolean[] = [];
    bsModal?: BsModalRef;
    config = {
      animated: true,
      keyboard: true,
      backdrop: 'static',
      ignoreBackdropClick: true,
    };

  currentDateChild: any;

  private routes: RoutesAPI = routes;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  private verifyExistSubject = new Subject<{text: any, type: string, index: number}>();

  constructor(
    private fb: FormBuilder,
    public _restService: RestService,
    private router: Router,
    private _itineraryService: ItineraryService,
    public userService: UserService,
    private localeService: BsLocaleService,
    public ngxSpinner: NgxSpinnerService,
    private notificationService: NotificationService,
    private cdRef: ChangeDetectorRef,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private cdr: ChangeDetectorRef,
    private formPaxesService: FormPaxesReservationService
  ) {

    this.data = {};
    this.selectedIsCity = [];
    this.selectedIsCountry = [];
    this.selectedIsState = [];
    this.phone_code = [];
    this.phone_2_code = [];
    this.clientData.states = []
    // this.getCountries();
    this.getRelationShip();
    this.getClients();
    this.checkOwner();
    this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
    this.clientData.styleFormDisable = false;
    this.clientData.checkboxChecked = false;


    this.selectedClientAssociated = false;

        this.verifyExistSubject
      .pipe(
        debounceTime(500),
        distinctUntilChanged((prev, curr) =>
          prev.text === curr.text &&
          prev.type === curr.type &&
          prev.index === curr.index
        )
      )
      .subscribe(({text, type, index}) => {
        this.performVerifyExist(text, type, index);
      });

  }


ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['paxesReload']) {
        const currentValue = changes['paxesReload'].currentValue;

        if (Array.isArray(currentValue) && currentValue.length > 0) {
            const paxesArray = this._form?.get('paxes') as FormArray;

            if (!paxesArray) return;

            // Recorrer y actualizar solo clientId
            for (let i = 0; i < paxesArray.length && i < currentValue.length; i++) {
                const formGroup = paxesArray.at(i) as FormGroup;
                const paxData = currentValue[i];

                if (paxData && paxData.clientId) {
                    const currentClientId = formGroup.get('clientId')?.value;

                    if (currentClientId !== paxData.clientId) {
                        formGroup.get('clientId')?.setValue(paxData.clientId);
                        formGroup.get('clientSelected')?.setValue(paxData.clientId);
                    }
                }
            }

        }
    }
}

  verifyExistWithDebounce(text: any, type: string, index: number): void {
  this.verifyExistSubject.next({text, type, index});
}

performVerifyExist(text: any, type: string, index: number): void {

  const paxesArray = this._form.get('paxes') as FormArray;
  const formGroupAtIndex = paxesArray.at(index) as FormGroup;
  const clientSelected = formGroupAtIndex.get('clientSelected')?.value;
  const documentType = formGroupAtIndex.get('document_type_id').value;
  const email = formGroupAtIndex.get('email').value;
  const documentNumber = formGroupAtIndex.get('document_number').value;


  if (type === 'type_document' && formGroupAtIndex.get('document_number').value) {
    formGroupAtIndex.get('document_number').setValue(null);
    return;
  }

  if (clientSelected) {
    this.clientsVerifyExists[index] = this.formPaxesReservationData.clientsAssociated.find(c => c.id === clientSelected);
  }

  // Inicializar posición si no existe
  if (!this.validDataForm[index]) {
    this.validDataForm[index] = { document_number: null, email: null, type: null };
  }

  if (text !== undefined && text !== '') {
    switch (type) {
      case 'full':
        this.validDataForm[index].document_number = text.document_number;
        this.validDataForm[index].email = text.email;
        this.validDataForm[index].type = documentType;
        break;
      case 'email':
        this.validDataForm[index].email = email;
        break;
      case 'type_document':
        this.validDataForm[index].type = documentType;
        break;
      case 'document_number':
        this.validDataForm[index].document_number = documentNumber;
        break;
    }

    if (this.validDataForm &&
      this.validDataForm[index] &&
      this.validDataForm[index].email &&
      this.validDataForm[index].type &&
      this.validDataForm[index].document_number) {

      if (this.clientsVerifyExists &&
        this.clientsVerifyExists[index]) {
        const verified = this.verifyClientData(this.clientsVerifyExists[index], documentType, email, documentNumber);

        if (verified) {
          return;
        }
      }

      this._restService.doPost('app', 'checkClient', this.validDataForm[index])
        .subscribe({
          next: (responseCheck: any) => {
        if (responseCheck) {
          if (responseCheck.exist === false) {
            if(!this.data.typeAction) {


                  const paxesArray = this._form.get('paxes') as FormArray;
                  const formGroupAtIndex = paxesArray.at(index) as FormGroup;

                  if(formGroupAtIndex) {
                            const documentNumberControl = formGroupAtIndex.get('document_number');
                            if(documentNumberControl && documentNumberControl.value > 0) {
                              documentNumberControl.setErrors(null);

                        }

                          const emailControl = formGroupAtIndex.get('email');
                          if(emailControl && emailControl.value !== null) {
                            emailControl.setErrors(null);

                      }

            }
          }
          } else {

              const paxesArray = this._form.get('paxes') as FormArray;
              const formGroupAtIndex = paxesArray.at(index) as FormGroup;
              const documentNumberControl = formGroupAtIndex.get('document_number');
              const emailControl = formGroupAtIndex.get('email');
              const typePaxValue = formGroupAtIndex.get('type');
              const customErrors = { 'customErrorKey': true };
              const clientId = this.formPaxesReservationData.paxList[index]?.clientId;

              if(moment(responseCheck.client.birth_date).isBefore(this.formPaxesReservationData.minDateAdult)) {
                if(typePaxValue.value === 'adult') {
                    if(responseCheck.client?.id === clientId) {
                      if(formGroupAtIndex) {
                        if(documentNumberControl && responseCheck.client?.document_number == documentNumberControl.value) {
                          documentNumberControl.setErrors(null);
                          // return;

                        }
                        if(emailControl && responseCheck.client?.email === emailControl.value) {
                          emailControl.setErrors(null);
                          // return;
                        }
                      }
                    } else {
                      if(formGroupAtIndex) {


                          if(documentNumberControl && responseCheck.client?.document_number == documentNumberControl.value) {
                            documentNumberControl.setErrors(customErrors);

                          }
                          if(emailControl && responseCheck.client?.email === emailControl.value) {
                            emailControl.setErrors(customErrors);
                          }

                      }
                    }
                  }

                    if(!this.data.typeAction && responseCheck.client?.id !== clientId ) {
                      const url = `clients/${responseCheck.client?.id}`;
                      this._restService.doGet("app", url).subscribe({
                        next: (res: any) => {
                              if(res?.data) {
                                const associate = res.data;

                                  if(
                                    !this.firstCharge && associate &&
                                    (responseCheck?.client?.document_number === associate.document_number &&
                                    responseCheck?.client?.email === associate.email) &&
                                    formGroupAtIndex.get('clientSelected').value !== associate.id
                                    ) {

                                        const clientInfo = `
                                                              Cliente existente encontrado:<br>
                                                              <strong>Nombre:</strong> ${associate.first_name} ${associate.last_name}<br>
                                                              <strong>Email:</strong> ${associate.email}<br>
                                                              <strong>${associate.document_type_id === 4 ? 'DNI' : 'Pasaporte'}:</strong> ${associate.document_number}
                                                            `;
                                     this.notificationService.info(clientInfo, 'Cliente ya existe en la lista');

                                      if(typePaxValue.value === 'adult') {
                                        if(formGroupAtIndex) {
                                          if(documentNumberControl && responseCheck.client?.document_number == documentNumberControl.value) {
                                            documentNumberControl.setErrors(customErrors);

                                          }
                                          if(emailControl && responseCheck.client?.email === emailControl.value) {
                                            emailControl.setErrors(customErrors);
                                          }
                                        }
                                      } else {
                                        if(formGroupAtIndex) {
                                          if(documentNumberControl && responseCheck.client?.document_number == documentNumberControl.value) {
                                            documentNumberControl.setErrors(null);

                                          }
                                          if(emailControl && responseCheck.client?.email === emailControl.value) {
                                            emailControl.setErrors(null)
                                          }
                                        }
                                      }
                                      return;
                                    }  else {
                                        if(documentNumberControl && responseCheck.client?.document_number == documentNumberControl.value) {
                                            documentNumberControl.setErrors(null);

                                          }
                                          if(emailControl && responseCheck.client?.email === emailControl.value) {
                                            emailControl.setErrors(null)
                                          }
                                    }

                                  this.firstCharge = false;

                              };
                        },
                        error: (error: HttpErrorResponse) => {
                          // console.log(error);
                        }
                  })
              }



              }
          }
        }
      },
      error: (error: HttpErrorResponse) => {
        // console.log(error);
      }
        });
    }

    this.enterInputDocument(index);
  }
}

async ngOnInit() {
    if(this.typeAction === 'Edit' || this.typeAction === 'New'){
      this.formPaxesReservationData = formPaxesReservationData;
      this.appLoading = false;
      this.loadedClientInfoForm = true;
    }

  try {
    // 1. Configuración básica
    this.localeService.use("es");

    // 2. Inicializar datos básicos
    await this.initializeBasicData();
    // 3. Inicializar formulario SOLO si tenemos los datos necesarios
    if (this.shouldInitializeForm()) {
      await this.initializeForm();
    }

  } catch (error) {
    console.error('Error in ngOnInit:', error);
    this.appLoading = false;
  }
}


initializeBasicData(): Promise<void> {
  return new Promise((resolve) => {

    this.formPaxesReservationData.countries = [];
    this.formPaxesReservationData.states = [];
    this.formPaxesReservationData.countries = this.countries;

    if(this.formPaxesReservationData.countries && this.formPaxesReservationData.countries.length > 0) {
      this.filteredCountries = this.formPaxesReservationData.countries;
    }


    this.dpConfig = this.formPaxesReservationData.dpConfig || {};
    this.dpConfig.dateInputFormat = "DD-MM-YYYY";
    this.dpConfig.showWeekNumbers = true;



    const currentDate = new Date();

    // Para adultos: mayores de 18 años
    this.formPaxesReservationData.minDateAdult = new Date(
      currentDate.getFullYear() - 18,
      currentDate.getMonth(),
      currentDate.getDate()
    );

    this.formPaxesReservationData.maxDateAdult = new Date(
      currentDate.getFullYear() - 99,
      currentDate.getMonth(),
      currentDate.getDate()
    );

    // Para niños: menores de 17 años (0 a 17 años)
    // Fecha MÁXIMA (la más reciente) = HOY
    this.formPaxesReservationData.maxDateChild = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate()
    );

    // Fecha MÍNIMA (la más antigua) = 17 años atrás
    this.currentDateChild = new Date(
      currentDate.getFullYear() - 17,
      currentDate.getMonth(),
      currentDate.getDate()
    );



    this.formPaxesReservationData.getClientsSettingAppBooking = this.getClientsSettingAppBooking;

    if (this.getClientsSettingAppBooking?.clients_setting_app_booking?.bookingFlow_sidebar) {
      try {
        this.formPaxesReservationData.styleSidebar = JSON.parse(
          this.getClientsSettingAppBooking.clients_setting_app_booking.bookingFlow_sidebar
        );
      } catch (e) {
        this.formPaxesReservationData.styleSidebar = {};
      }
    }

    // Inicializar data
    this.data = {
      typeAction: this.typeAction,
      fromAssociates: this.fromAssociates,
      index: this.index,
      mainClient: this.mainClient,
      clients: this.clients,
      clientAssociatedArr: this.clientAssociatedArr,
      assosiateClient: this.associateClient
    };

    if (this.associateClientIndex) {
      this.data.index = this.associateClientIndex;
    }

    if (this.data.typeAction) {

      // Configuración para modo edición/creación
      this.countryCheck = Array(1).fill(false);
      this.stateCheck = Array(1).fill(false);
      this.cityCheck = Array(1).fill(false);
      this.phoneCodeCheck = Array(1).fill(false);
      this.phoneCode2Check = Array(1).fill(false);
      this.editDataPax = Array(1).fill(true);
      this.clientData.styleFormDisable = false;
      this.selectClientFormPaxes = false;
      this.loadingFormClient();
      this.getDocumentTypesList();
      this.getCountries();

    } else {
      // Configuración para modo reserva
      if (this.paxes?.length) {
        this.countryCheck = Array(this.paxes.length).fill(false);
        this.stateCheck = Array(this.paxes.length).fill(false);
        this.cityCheck = Array(this.paxes.length).fill(false);
        this.phoneCodeCheck = Array(this.paxes.length).fill(false);
        this.phoneCode2Check = Array(this.paxes.length).fill(false);
        this.associatedFilterView = Array(this.paxes.length).fill(false);
        this.associatedFilterView[0] = true;
      }
      this.getCountries();
      this.selectClientFormPaxes = true;
      this.clientData.type = 'adult';
      this.clientData.clientAssociated = true;

      const existsClientOwnerId = this.formPaxesReservationData.clientIdArr?.find(c => c === this.clientOwner.id);
      if (!existsClientOwnerId) {
        this.formPaxesReservationData.clientIdArr = this.formPaxesReservationData.clientIdArr || [];
        this.formPaxesReservationData.clientIdArr.push(this.clientOwner.id);
      }

      this.formPaxesReservationData.numberDocumentClient = [];

      if (this.itinerary?.paxList != null) {
        this.formPaxesReservationData.paxList = this.itinerary.paxList;
      } else {
        this.formPaxesReservationData.paxList = [];
      }


      // Verificar conductor adicional
      this.itineraryItems?.forEach((item) => {
        if (item.categoryName == "RENT-A-CAR") {
          if (this.paxes?.length < 2 && item?.additionalDriver) {
            let holder = "";
            this.paxes.push({
              title: "Adult " + 2 + holder,
              type: "adult",
              number: 2,
            });
          }
        }
      });


      this.data.fromAssociates = false;
      this.clientData.typeAction = undefined;
      this.checkAmountPaxes();
    }

    resolve();
  });
}

shouldInitializeForm(): boolean {
  // Verificar que todos los datos necesarios estén disponibles
  return !this.data.typeAction &&
         this.paxes?.length > 0 &&
         this.formPaxesReservationData?.countries?.length > 0;
}

async initializeForm() {
  try {
    // Verificar que tenemos todos los datos necesarios
    if (!this.paxes || this.paxes.length === 0) {
      console.warn('No paxes data available');
      this.appLoading = false;
      return;
    }
    if (!this.formPaxesReservationData?.paxList) {
      this.formPaxesReservationData.paxList = [];
    }

     // ✅ VALIDAR CONSISTENCIA DE PAX (AGREGAR AQUÍ)
    this.validateAndFixPaxConsistency();

    // 1. Construir estructura del formulario
    this.buildFormStructure();

    // 2. Cargar datos adicionales
    if (this._form) {
      await this.loadAdditionalData();
      this.getAssociatedClients();
    }

    // 3. Marcar como completo
    this.markAsComplete();

    // 4. Inicializar controles de búsqueda
    if (this._form) {
      this.initializeSearchControls();
      this.startInterval();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }

  } catch (error) {
    console.error('Error initializing form:', error);
    this.appLoading = false;
    this.cdRef.detectChanges();
  }
}


/**
 * ✅ Validar y corregir consistencia entre paxes guardados y configuración actual
 * Solo limpia los datos inconsistentes, mantiene los válidos
 */
private validateAndFixPaxConsistency(): void {
  const savedPaxes = this.formPaxesReservationData.paxList || [];
  const expectedPaxes = this.paxes || [];

  // Si no hay paxes guardados, no hay nada que validar
  if (savedPaxes.length === 0) {
    return;
  }

  // Crear un nuevo array limpio
  const cleanedPaxes: any[] = [];
  let needsCleanup = false;

  for (let i = 0; i < expectedPaxes.length; i++) {

    if(i === 0) {
      return;
    }

    const expectedType = expectedPaxes[i]?.type;
    const savedPax = savedPaxes[i];
    const savedType = savedPax?.type;

    // Si el tipo coincide, mantener los datos
    if (savedType === expectedType) {
      cleanedPaxes.push(savedPax);
    } else {
      // Si no coincide, poner datos vacíos para este índice
      console.warn(`Inconsistencia en índice ${i}: tipo guardado=${savedType}, esperado=${expectedType}`);
      cleanedPaxes.push({ type: expectedType }); // Datos vacíos con el tipo correcto
      needsCleanup = true;
    }
  }

  // Si había inconsistencias, reemplazar con los datos limpiados
  if (needsCleanup) {
    console.warn('Limpiando datos inconsistentes, manteniendo los válidos');
    this.formPaxesReservationData.paxList = cleanedPaxes;
  }
}

markAsComplete() {
  this.loadedClientInfoForm = true;
  this.appLoading = false;

  // Forzar actualización de vista
  this.cdRef.detectChanges();
}

buildFormStructure() {
  try {
    // Verificar datos esenciales
    if (!this.paxes || this.paxes.length === 0) {
      console.warn('No paxes to build form');
      return;
    }

    if (!this.fb) {
      console.warn('FormBuilder not available');
      return;
    }

    // Crear formulario principal
    this._form = this.fb.group({
      paxes: this.fb.array([])
    });

    // Inicializar arrays auxiliares
    this.generateEditDataPaxes();

    // Verificar y crear datos vacíos si es necesario
    this.verifiedCreateFormEmpty();

    // Obtener referencia al FormArray
    const guest = this._form.get("paxes") as FormArray;

    // Crear controles para cada pax
    this.paxes.forEach((pax, index) => {
      try {
        // ✅ Pasar el tipo esperado a createPaxFormGroup
        const formGroup = this.createPaxFormGroup(index, pax.type);
        if (formGroup) {
          guest.push(formGroup);
        }
      } catch (error) {
        console.error(`Error creating form group for pax ${index}:`, error);
        guest.push(this.createEmptyFormGroup(index));
      }
    });


    if(this.formPaxesReservationData.paxList[0].phone_code) {
      this.formPaxesReservationData.phone_code_parent = this.formPaxesReservationData.paxList[0].phone_code;
    }

    if(this.formPaxesReservationData.paxList[0].country_id) {
      this.formPaxesReservationData.country_parent = this.formPaxesReservationData.paxList[0].country_id;
    }

    if(this.formPaxesReservationData.paxList[0].state_id) {
      this.formPaxesReservationData.state_parent = this.formPaxesReservationData.paxList[0].state_id;
    }

    if(this.formPaxesReservationData.paxList[0].city) {
      this.formPaxesReservationData.city_parent = this.formPaxesReservationData.paxList[0].city;
    }

    // Aplicar validaciones
    this.applyValidationsByPaxType();

  } catch (error) {
    console.error('Error building form structure:', error);
  }
}

createPaxFormGroup(index: number, expectedType?: string): FormGroup | null {
  try {
    if (!this.paxes || index >= this.paxes.length) {
      return this.createEmptyFormGroup(index);
    }

    const paxData = this.itinerary.paxList[index] || {};
    const expectedPaxType = expectedType || this.paxes[index]?.type || 'adult';
    const savedPaxType = paxData.type;

    const paxAge = this.paxes[index]?.age;
    const useSavedData = (savedPaxType === expectedPaxType);

    if (!useSavedData && savedPaxType) {
      console.warn(`Ignorando datos guardados para índice ${index}: tipo=${savedPaxType} vs esperado=${expectedPaxType}`);
    }

    const paxType = expectedPaxType;
    let sourceData: any;
    if (index === 0 && paxType === 'adult') {
      sourceData = paxData;
    } else {
      sourceData = useSavedData ? paxData : { type: paxType };
    }

    // ✅ Procesar fecha de nacimiento
    let birthDate: string | null = null;

    if (paxType === 'adult') {
      // Para adultos: usar fecha guardada o generar por defecto
      const savedBirthDate = sourceData.birth_date;
      const hasValidBirthDate = savedBirthDate &&
                                normalizeText(savedBirthDate) !== normalizeText('Invalid date') &&
                                normalizeText(savedBirthDate) !== normalizeText('Fecha inválida');

      if (hasValidBirthDate) {
        birthDate = savedBirthDate;
      } else {
        // Adulto: fecha por defecto (50 años atrás)
        const minDate = new Date(this.formPaxesReservationData.minDateAdult);
        minDate.setFullYear(minDate.getFullYear() - 50);
        const day = String(minDate.getDate()).padStart(2, '0');
        const month = String(minDate.getMonth() + 1).padStart(2, '0');
        const year = minDate.getFullYear();
        birthDate = `${day}-${month}-${year}`;
      }

      // Adulto con edad cotizada en asistencia: conservar día/mes y forzar el año
      if (this.hasFixedAge(index)) {
        birthDate = moment(this.getFixedAgeBirthDate(index, hasValidBirthDate ? savedBirthDate : null)).format('YYYY-MM-DD');
      }
    }
      else if (paxType === 'children') {
        // ✅ Usar la arrivalDate específica guardada en el pax
        const arrivalDate = this.paxes[index]?.arrivalDate;

        if (paxAge !== null && paxAge !== undefined && !isNaN(paxAge) && arrivalDate) {
          birthDate = this.getBirthDateFromAge(paxAge, arrivalDate);

        } else if (!arrivalDate) {
          console.warn(`⚠️ Niño ${index}: sin fecha de llegada específica`);
          const currentDate = new Date();
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, '0');
          const day = String(currentDate.getDate()).padStart(2, '0');
          birthDate = `${year}-${month}-${day}`;
        } else {
          const currentDate = new Date();
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, '0');
          const day = String(currentDate.getDate()).padStart(2, '0');
          birthDate = `${year}-${month}-${day}`;
        }

}


    const firstPaxData = this.formPaxesReservationData.paxList[0] || {};

    // ✅ Convertir birthDate a Date solo si no es null
    let parsedBirthDate: Date | null = null;
    if (birthDate) {
      parsedBirthDate = this.parseDateStringToDate(birthDate);
    }

    const fbGroup = this.fb.group({
      gender: [sourceData.gender || null],
      title: [sourceData.title || null],
      first_name: [sourceData.first_name || null],
      last_name: [sourceData.last_name || null],
      birth_date: [parsedBirthDate || null],
      document_type_id: [sourceData.document_type_id || null],
      document_number: [sourceData.document_number || null],
      email: [sourceData.email || firstPaxData.email || null],
      phone: [sourceData.phone || firstPaxData.phone || null],
      phone_code: [sourceData.phone_code || firstPaxData.phone_code || null],
      phone_code_selected: [sourceData.phone_code || firstPaxData.phone_code || null],
      phone_2: [sourceData.phone_2 || firstPaxData.phone_2 || null],
      phone_2_code: [sourceData.phone_2_code || firstPaxData.phone_2_code || null],
      country_id: [sourceData.country_id || firstPaxData.country_id || null],
      state_id: [sourceData.state_id || firstPaxData.state_id || null],
      city: [sourceData.city || firstPaxData.city || null],
      address: [sourceData.address || firstPaxData.address || null],
      postal_code: [sourceData.postal_code || null],
      relation_ship: [sourceData.relation_ship_catalogue_id || 7 || null],
      idUnique: [this.getRandom()],
      type: [paxType],
      clientSelected: [[]],
      clientId: [sourceData.clientId || null],
      paxOptional: [sourceData.paxOptional],
    });

    // ✅ Forzar actualización del valor después de crear el grupo (solo si hay fecha)
    if (birthDate && parsedBirthDate) {
      setTimeout(() => {
        const birthControl = fbGroup.get('birth_date');
        if (birthControl && birthControl.value !== parsedBirthDate) {
          birthControl.setValue(parsedBirthDate);
          birthControl.updateValueAndValidity();

        }
      }, 0);
    }

    this.inputValueName(index);

    return fbGroup;

  } catch (error) {
    return this.createEmptyFormGroup(index);
  }
}
/**
 * Convierte una edad a fecha de nacimiento basada en la fecha de llegada específica
 * @param age - Edad del niño en años
 * @param arrivalDate - Fecha de llegada del item específico
 * @returns Fecha de nacimiento como string en formato YYYY-MM-DD
 */
getBirthDateFromAge(age: number, arrivalDate: Date): string {
  if (!arrivalDate || isNaN(arrivalDate.getTime())) {
    console.error('❌ Fecha de llegada inválida para calcular edad');
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const birthDate = new Date(arrivalDate);
  birthDate.setFullYear(arrivalDate.getFullYear() - age);

  // ✅ CORRECCIÓN: Si la fecha es inválida (ej: 29/02 en año no bisiesto), ajustar al 28/02
  if (birthDate.getMonth() !== arrivalDate.getMonth()) {
    // La fecha no existe, ir al último día del mes anterior
    birthDate.setDate(0);
  }

  const year = birthDate.getFullYear();
  const month = String(birthDate.getMonth() + 1).padStart(2, '0');
  const day = String(birthDate.getDate()).padStart(2, '0');

  const result = `${year}-${month}-${day}`;
  return result;
}

/**
 * Indica si el pax tiene una edad cotizada fija (niños, o adultos cuando hay asistencia),
 * en cuyo caso solo se puede elegir día y mes de nacimiento.
 */
hasFixedAge(index: number): boolean {
  const pax = this.paxes?.[index];
  return pax?.age !== null && pax?.age !== undefined && !isNaN(pax.age) && !!pax.arrivalDate;
}

/**
 * Fecha de nacimiento para un pax con edad fija.
 * Si se pasa una fecha (p. ej. la del cliente), conserva su día y mes y fuerza el año
 * para que la edad a la fecha de referencia sea exactamente la cotizada.
 * Sin fecha válida, usa el mismo cálculo que los niños (getBirthDateFromAge).
 */
getFixedAgeBirthDate(index: number, sourceDate?: any): Date {
  const pax = this.paxes[index];
  const source: Date | null = sourceDate instanceof Date
    ? sourceDate
    : (typeof sourceDate === 'string' ? this.parseDateStringToDate(sourceDate) : null);

  if (source && !isNaN(source.getTime()) && pax.arrivalDateString) {
    const [refYear, refMonth, refDay] = pax.arrivalDateString.split('-').map(Number);
    const month = source.getMonth();
    const day = source.getDate();
    // Rango válido (igual que getChildMinDate/getChildMaxDate): si el cumpleaños ya
    // pasó o es el mismo día de referencia, ya cumplió la edad ese año; si no, nació un año antes.
    const birthdayPassed = month < refMonth - 1 || (month === refMonth - 1 && day <= refDay);
    const year = refYear - pax.age - (birthdayPassed ? 0 : 1);

    let result = new Date(year, month, day, 12, 0, 0);
    // 29/02 en un año no bisiesto
    if (result.getMonth() !== month) {
      result = new Date(year, month, 28, 12, 0, 0);
    }

    // Cumpleaños justo en la referencia: ese día queda fuera del rango (ver getChildMaxDate),
    // se usa la fecha máxima permitida (el día anterior)
    const maxDate = this.getChildMaxDate(pax.age, pax.arrivalDate, pax.arrivalDateString);
    if (maxDate && result > moment(maxDate).endOf('day').toDate()) {
      const max = moment(maxDate);
      result = new Date(max.year(), max.month(), max.date(), 12, 0, 0);
    }

    return result;
  }

  return this.parseDateStringToDate(this.getBirthDateFromAge(pax.age, pax.arrivalDate));
}

private parseDateStringToDate(dateStr: string): Date | null {
  if (!dateStr) return null;

  // Si ya es formato dd-MM-yyyy
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
    const [day, month, year] = dateStr.split('-');
    return new Date(Number(year), Number(month) - 1, Number(day), 12, 0, 0); // Mediodía para evitar problemas de zona
  }

  // Si es formato yyyy-MM-dd
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [year, month, day] = dateStr.split('-');
    return new Date(Number(year), Number(month) - 1, Number(day), 12, 0, 0);
  }

  // Último intento con Date.parse
  const date = new Date(dateStr);
  return !isNaN(date.getTime()) ? date : null;
}

// Método fallback para crear grupo vacío
createEmptyFormGroup(index: number): FormGroup {
  return this.fb.group({
    gender: [null],
    title: [null],
    first_name: [null],
    last_name: [null],
    birth_date: [null],
    document_type_id: [null],
    document_number: [null],
    email: [null],
    phone: [null],
    phone_code: [null],
    phone_code_selected: [null],
    phone_2: [null],
    phone_2_code: [null],
    country_id: [null],
    state_id: [null],
    city: [null],
    address: [null],
    postal_code: [null],
    relation_ship: [7],
    idUnique: [this.getRandom()],
    type: [this.paxes?.[index]?.type || 'adult'],
    clientSelected: [[]],
    clientId:[null],
    paxOptional: [false],
  });
}

verifiedCreateFormEmpty(): void {
  if (!this.formPaxesReservationData?.paxList) {
    this.formPaxesReservationData.paxList = [];
  }

  if (!this.paxes || this.paxes.length === 0) {
    return;
  }

  const difference = this.paxes.length - this.formPaxesReservationData.paxList.length;

  if (difference <= 0) {
    return;
  }

  const firstPaxData = this.formPaxesReservationData.paxList.length > 0
    ? this.formPaxesReservationData.paxList[0]
    : {};

  for (let i = 0; i < difference; i++) {
    const paxIndexInPaxes = this.formPaxesReservationData.paxList.length + i;

    if (paxIndexInPaxes >= this.paxes.length) {
      console.warn(`Pax index ${paxIndexInPaxes} out of bounds in paxes array`);
      continue;
    }

    const paxType = this.paxes[paxIndexInPaxes]?.type || 'adult';
    const isAdult = paxType === 'adult';

    let birthDate = null;
    if (isAdult) {
      // Adulto: 18 años hacia atrás
      const minDate = new Date(this.formPaxesReservationData.minDateAdult);

      // Restar 50 años en lugar de 18
      minDate.setFullYear(minDate.getFullYear() - 50);

      const day = String(minDate.getDate()).padStart(2, '0');
      const month = String(minDate.getMonth() + 1).padStart(2, '0');
      const year = minDate.getFullYear();
      birthDate = `${day}-${month}-${year}`;
    } else {
      // ✅ NIÑO: Usar FECHA ACTUAL (hoy), no la máxima de 17 años
      const currentDate = new Date();
      const day = String(currentDate.getDate()).padStart(2, '0');
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const year = currentDate.getFullYear();
      birthDate = `${day}-${month}-${year}`;
    }

    const emptyPax: PaxEmpty = {
      gender: null,
      title: null,
      first_name: null,
      last_name: null,
      birth_date: birthDate,
      document_type_id: null,
      document_number: null,
      email: firstPaxData.email || null,
      phone: firstPaxData.phone || null,
      phone_code: firstPaxData.phone_code || null,
      phone_code_selected: firstPaxData.phone_code || null,
      phone_2: firstPaxData.phone_2 || null,
      phone_2_code: firstPaxData.phone_2_code || null,
      country_id: firstPaxData.country_id || null,
      state_id: firstPaxData.state_id || null,
      city: firstPaxData.city || null,
      address: firstPaxData.address || null,
      relation_ship: 7,
      idUnique: this.getRandom(),
      type: paxType,
      clientSelected: [],
      paxOptional: false,
      clientId: null,
      document_type_number: null,
      phone_2_code_selected: firstPaxData.phone_2_code || null,
      postal_code: null,
      relation_ship_catalogue_id: 7
    };

    this.formPaxesReservationData.paxList.push({ ...emptyPax });

    if (!this.formPaxesReservationData.states) {
        this.formPaxesReservationData.states = [];
      }
      if (!this.formPaxesReservationData.states[i]) {
        this.formPaxesReservationData.states[i] = { states: [] };
    }

        if (!this.formPaxesReservationData.cities) {
        this.formPaxesReservationData.cities = [];
      }
      if (!this.formPaxesReservationData.cities[i]) {
        this.formPaxesReservationData.cities[i] = { cities: [] };
    }


  }
}

  private initializeSearchControls() {
  const paxesCount = this._form.get('paxes')?.value.length || 0;

  for (let i = 0; i < paxesCount; i++) {
    // Crear control de búsqueda separado
    const searchControl = new FormControl('');
    this.clientSearchControls[i] = searchControl;

    // Configurar filtrado para el autocomplete
    this.filteredClients[i] = searchControl.valueChanges.pipe(
      startWith(''),
      map(value => this.filterClients(value, i))
    );
  }
}

async loadAdditionalData() {
  // Cargar datos en paralelo para todos los paxes
  const promises = this.paxes.map((_, index) =>
    this.loadPaxData(index)
  );

  await Promise.all(promises);
}

async loadPaxData(index: number) {
  const faControl = this.getPaxControl(index);

  // Ejecutar operaciones en paralelo cuando sea posible
  const operations = [];

  if (faControl) {
      // ✅ Validación segura para country_id
      const countryIdFromForm = faControl.get('country_id')?.value;
      const currentPax = this.formPaxesReservationData.paxList?.[index];
      const firstPax = this.formPaxesReservationData.paxList?.[0];
      const countryIdFromPaxList = currentPax?.country_id;
      const countryIdFromFirstPax = firstPax?.country_id;
      const paxType = faControl.get('type')?.value;

      const hasCountryId = (countryIdFromForm !== undefined && countryIdFromForm !== null) ||
                           countryIdFromPaxList ||
                           countryIdFromFirstPax;

      if (hasCountryId && paxType) {
          const finalCountryId = countryIdFromForm || countryIdFromPaxList || countryIdFromFirstPax;
          operations.push(this.getCountriesData(index, true, finalCountryId, paxType));
      }

      // ✅ Validación segura para phone_code
      const phoneCodeFromForm = faControl.get('phone_code')?.value;
      const phoneCodeFromPaxList = currentPax?.phone_code;
      const phoneCodeFromFirstPax = firstPax?.phone_code;

      const hasPhoneCode = phoneCodeFromForm || phoneCodeFromPaxList || phoneCodeFromFirstPax;

      if (hasPhoneCode) {
          const finalPhoneCode = phoneCodeFromForm || phoneCodeFromPaxList || phoneCodeFromFirstPax;
          operations.push(this.changePhoneCode(index, finalPhoneCode, 'phone_code'));
      }

      await Promise.all(operations);

      // Verificar existencia con debounce
      this.debouncedVerifyExist(index);
  }
}

// Usar debounce para evitar múltiples llamadas
debouncedVerifyExist = this.debounce((index: number) => {
  const faControl = this.getPaxControl(index);
  const documentValue = faControl.get('document_number').value;
  const emailValue = faControl.get('email').value;

  if (documentValue && emailValue) {
    this.verifyExist({email: emailValue, document_number: documentValue}, 'full', index);
  } else if (documentValue) {
    this.verifyExist(documentValue, 'document_number', index);
  } else if (emailValue) {
    this.verifyExist(emailValue, 'email', index);
  }
}, 500);

debounce(func: Function, wait: number) {
  let timeout: any;
  return (...args: any[]) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

private getPaxControl(index: number): any {
    return (<FormArray>this._form.controls["paxes"]).at(index);
}

private filterClients(value: string, paxIndex: number): any[] {
  if (!value) {
    if(typeof value === 'string' && value.trim() === '') {
      return this.getAvailableClientsForPax(paxIndex);
    }
    if(typeof value === 'number') {
      return this.getAvailableClientsForPax(paxIndex);
    }
  }

  const filterValue = (value).toString().toLowerCase().trim();
  return this.getAvailableClientsForPax(paxIndex).filter(client =>
    client.first_name?.toLowerCase().includes(filterValue) ||
    client.last_name?.toLowerCase().includes(filterValue) ||
    client.email?.toLowerCase().includes(filterValue) ||
    client.document_number?.toLowerCase().includes(filterValue) ||
    client.id?.toString().toLowerCase().includes(filterValue)
  );
}

  ngAfterViewInit(): void {
    setTimeout(() => {

      this.checkOwner();
      this.updateInputClasses(true);
      this.cdr.detectChanges();
    }, 0);
  }

  ngOnDestroy(): void {
    if (this.formPaxesReservationData.booleanSelectCountries == true) {
      this.countriesSubscription.unsubscribe();
    }
    //  this.associateClientSubscription.unsubscribe();

    if (this.formPaxesReservationData.booleanSelectState == true) {
      this.stateByCountrySubscription.unsubscribe();
    }

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  startInterval() {
    // Ejecuta la función cada 1 minuto y 30 segundos (90,000 ms)
    this.intervalId = setInterval(() => {
      this.notificationService.info(`autoguardado iniciado`);
      this._onSubmit(true);
    }, 90000);
  }

  //** ------------------------------------------------------------------- */

//** -------------=== Índice de funciones del componente ===------------ */

//** -------------=== Formulario de pasajeros de reserva ===------------ */

// ** SETEAR FORMULARIO DE PASAJEROS **
// setForm()

// ** VALIDA USUARIO DE ITINERARIO Y HACE SOLICITUD DE LOS CLIENTES Y ASOCIADOS **
// checkOwner()
// getClients()
// getAssociateClient()
// selectClientFunction(client: any, i: any)
// setClient(client: any, i: any)
// toStr(client: string)
// resetClient(i: any)
// verifyClientExist(i: any)

// ** LISTADO DE PAISES Y ESTADOS **
// getCountries(i?: number, setting?: boolean, client?: any)
// getStates(i: any, setting?: boolean, client?: any, country_id?: any)

// ** LISTADO DE RELACIONES **
// getRelationShip()

// ** VALIDACIÓN FORMULARIO Y BOTON CONTINUAR **
// checkProductConfirm(event: any)
// isFormValid()
// validateEmail(email: any)
// blockInvalidKeys(evenet: any)

// ** COPIA INPUT DE HOLDER A NIÑOS (EMAIL, DIRECCIÓN, CIUDAD, TIPO DE DOCUMENTO, PAÍS Y ESTADO) **
// onEmailParent(value: string)
// onAddressParent(value: string)
// onCityParent(value: string)
// onChangeTypeDocumentParent(value: string)
// onChangeCountrytParent(value: string)
// onChangeStateParent(value: string)

// ** UTILS FORMULARIO **
// getPhoneCode(code: any, type: any, i: any)
// setRelationShip(value: any)
// getRandom()

// ** SUBMIT FORMULARIO PASAJEROS **
// _onSubmit(event: Event)
//  processPaxesData()
// formatPaxesData(paxesData: any[])
// goReservation(paxes: any)
// _payload(item: any, paxes: any)
// setAdditionalInfo(item: any, paxes: any)
// makeReserve(payload: any, item: any, paxes: any)
// setPaxesReserve(pax: any, insurance: boolean = false)
// saveReservation(reserve: any)
// confirmationRedirect(reservationId: number)

//** -------------=== Formulario de cliente ===------------ */

// ** SETEAR DATOS PARA FORMULARIO DE PASAJEROS **
// setDataClientNew(clientData: any)
// setDataClientNewAssociated(clientData: any)
// setDataClientEdit(clientData: any)

// ** SETEAR FORMULARIO DE CLIENTE **
// setFormClient()

// ** SETEAR DATOS PARA FORMULARIO DE CLIENTE (EDITAR) **
// setEditForm()

// ** SETEAR DATOS PARA FORMULARIO DE CLIENTE ASOCIADO POR SELECTOR - EXISTENTES(CREAR) **
// associatedSelectFilter()
// toggleSelect(checkbox)
// clientSelect(clientId)

// ** SETEAR DATOS PARA FORMULARIO DE CLIENTE ASOCIADO (EDITAR) **
// setEditAssosiateForm()
// associatedAge(birth_date)
// getRelationShipAssociated(age)
// changeDateClientAssociated(date)

//** ------------------------------------------------------------------- */

//** -------------=== Formulario de pasajeros de reserva ===------------ */



private parseDateString(dateStr: any): Date | null {
  if (!dateStr) return null;

  // Si ya es Date, devolverlo
  if (dateStr instanceof Date) return dateStr;

  // Intentar diferentes formatos
  const formats = [
    'YYYY-MM-DD',  // 1995-09-23
    'DD-MM-YYYY',  // 23-09-1995
    'YYYY-DD-MM'   // 1995-23-09
  ];

  const momentDate = moment(dateStr, formats);
  return momentDate.isValid() ? momentDate.toDate() : null;
}

generateEditDataPaxes(): void {

this.editDataPax = Array(this.paxes.length).fill(false);

this.paxes.forEach((pax, index) => {
  if (index === 0) {
    this.editDataPax[index] = true;
  }
  if (index === 1 && pax.type !== 'children') {
    this.editDataPax[index] = true;
  }
  // Los demás índices se mantienen en false
});

};

private applyValidationsByPaxType() {
  const paxesArray = this._form.get("paxes") as FormArray;

  paxesArray.controls.forEach((control: FormGroup, index) => {
    const paxType = this.formPaxesReservationData.paxList[index]?.type ? this.formPaxesReservationData.paxList[index]?.type : this.paxes[index].type;

    const isFirstPax = index === 0;
    const isSecondPax = index === 1;
    const isChild = paxType === 'children';

    Object.keys(control.controls).forEach(key => {
      const ctrl = control.get(key);
      if (ctrl) {
        ctrl.clearValidators();
        ctrl.setErrors(null);
        ctrl.updateValueAndValidity({ emitEvent: false });
      }
    });

    if(this.onlyTransports) {
      if(isFirstPax) {
         control.get('title').setValidators([Validators.required]);
        control.get('first_name')?.setValidators([Validators.required,Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]);
        control.get('last_name')?.setValidators([Validators.required,Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]);
        control.get('email')?.setValidators([Validators.required, Validators.email, this.validateEmail.bind(this)]);
        control.get('phone')?.setValidators([Validators.required, Validators.pattern(/^\d{6,}$/)]);
        control.get('phone_code')?.setValidators([Validators.required]);
        control.get('country_id')?.setValidators([Validators.required, this.selectedTypeHeadValidForm(index, 'country')]);

      } else {

          control.get('first_name')?.clearValidators();
         control.get('last_name')?.clearValidators();
         control.get('title')?.clearValidators();
          control.get('gender')?.clearValidators();
          control.get('gender')?.clearValidators();
          control.get('document_type_id')?.clearValidators();
          control.get('document_number')?.clearValidators();
          control.get('email')?.clearValidators();
          control.get('phone')?.clearValidators();
          control.get('phone_code')?.clearValidators();
          control.get('country_id')?.setValidators([Validators.required, this.selectedTypeHeadValidForm(index, 'country')]);
          control.get('state_id')?.clearValidators();
          control.get('city')?.clearValidators();
          control.get('address')?.clearValidators();
          control.get('relation_ship')?.clearValidators();
      }

    } else {
       // 🔹 1er Pax (Adulto) - TODOS los campos obligatorios
        if (isFirstPax && !this.onlyTransports) {
          control.get('gender').setValidators([Validators.required]);
          control.get('title').setValidators([Validators.required]);
          control.get('first_name').setValidators([Validators.required,Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]);
          control.get('last_name').setValidators([Validators.required,Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]);
          control.get('birth_date').setValidators([Validators.required]);
          control.get('document_type_id').setValidators([Validators.required]);
          control.get('document_number').setValidators([Validators.required, this.nonNegativeValidator(), this.documentMinLengthValidator()]);
          control.get('email').setValidators([Validators.required, Validators.email, this.validateEmail.bind(this)]);
          control.get('phone').setValidators([Validators.required, Validators.pattern(/^\d{6,}$/)]);
          control.get('phone_code').setValidators([Validators.required]);
          control.get('city').setValidators([Validators.required]);
          control.get('relation_ship').setValidators([Validators.required]);
        }



        // 🔹 2do Pax (Adulto) - Campos básicos obligatorios
        else if (isSecondPax && !isChild) {
          control.get('gender').setValidators([Validators.required]);
          control.get('title').setValidators([Validators.required]);
          control.get('first_name').setValidators([Validators.required,Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]);
          control.get('last_name').setValidators([Validators.required,Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]);
          control.get('birth_date').setValidators([Validators.required]);
          control.get('document_type_id').setValidators([Validators.required]);
          control.get('document_number').setValidators([Validators.required, this.nonNegativeValidator(), this.documentMinLengthValidator()]);
          control.get('phone').setValidators([Validators.required, Validators.pattern(/^\d{6,}$/)]);
          control.get('phone_code').setValidators([Validators.required]);

          // Campos opcionales para 2do Pax
          control.get('email').clearValidators();
          // control.get('phone').clearValidators();
          // control.get('phone_code').clearValidators();
          control.get('country_id').setValidators([Validators.required, this.selectedTypeHeadValidForm(index, 'country')]);
          control.get('state_id').clearValidators();
          control.get('city').clearValidators();
          control.get('address').clearValidators();
          control.get('relation_ship').clearValidators();
        }

        // 🔹 3er Pax o Niños - Solo nombre y fecha obligatorios
        else if (isChild || index >= 2) {
          control.get('gender').setValidators([Validators.required]);
          control.get('title').setValidators([Validators.required]);
          control.get('first_name').setValidators([Validators.required,Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]);
          control.get('last_name').setValidators([Validators.required,Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]);
          control.get('birth_date').setValidators([Validators.required]);
          control.get('document_type_id').setValidators([Validators.required]);
          control.get('document_number').setValidators([Validators.required, this.nonNegativeValidator(), this.documentMinLengthValidator()]);
          control.get('phone').setValidators([Validators.required, Validators.pattern(/^\d{6,}$/)]);
          control.get('phone_code').setValidators([Validators.required]);
          control.get('country_id').setValidators([Validators.required, this.selectedTypeHeadValidForm(index, 'country')]);

          // Limpiar validaciones de otros campos
          control.get('gender').clearValidators();
          control.get('document_type_id').clearValidators();
          control.get('document_number').clearValidators();
          control.get('email').clearValidators();
          // control.get('phone').clearValidators();
          // control.get('phone_code').clearValidators();
          // control.get('country_id').clearValidators();
          // control.get('state_id').clearValidators();
          // control.get('city').clearValidators();
          control.get('address').clearValidators();
          control.get('relation_ship').clearValidators();
        }
    }

    // Actualizar validaciones
    Object.keys(control.controls).forEach(key => {
      control.get(key).updateValueAndValidity();
    });
  });
}

nonNegativeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    return value !== null && value < 0 ? { nonNegative: true } : null;
  };
}

documentMinLengthValidator(minLength: number = 5): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return null;
    }
    return String(value).length < minLength ? { minLengthDocument: true } : null;
  };
}

disableControlsIfNeeded(control: FormGroup, index: number) {
  const documentNumberControl = control.get("document_number");
  const documentTypeIdControl = control.get("document_type_id");

  const requiredValidator = (control: AbstractControl): ValidationErrors | null => {
    return control.value ? null : { required: true };
  };

  documentNumberControl.setValidators([requiredValidator]);
  documentTypeIdControl.setValidators([requiredValidator]);

if (documentNumberControl.value !== null && documentTypeIdControl.value !== null) {
  documentNumberControl.clearValidators();
  documentTypeIdControl.clearValidators();
  documentNumberControl.updateValueAndValidity({ emitEvent: false });
  documentTypeIdControl.updateValueAndValidity({ emitEvent: false });
  // Añadir lógica adicional para que se comporten como deshabilitados visualmente si es necesario
} else {
  documentNumberControl.setValidators([requiredValidator]);
  documentTypeIdControl.setValidators([requiredValidator]);
  documentNumberControl.updateValueAndValidity({ emitEvent: false });
  documentTypeIdControl.updateValueAndValidity({ emitEvent: false });
}

let formValue = this._form.getRawValue();
formValue.document_number = documentNumberControl.value;
formValue.document_type_id = documentTypeIdControl.value;


}
private payloadValid = {
  email: null,
  type: null,
  document_number: null
}
private validDataForm: any[] = [];

verifyExist(text: any, type: string, index: number): void {



const paxesArray = this._form.get('paxes') as FormArray;
const formGroupAtIndex = paxesArray.at(index) as FormGroup;
const clientSelected = formGroupAtIndex.get('clientSelected')?.value;
const documentType = formGroupAtIndex.get('document_type_id').value;
const email = formGroupAtIndex.get('email').value;
const documentNumber = formGroupAtIndex.get('document_number').value;


   if(type === 'type_document' && formGroupAtIndex.get('document_number').value) {
    formGroupAtIndex.get('document_number').setValue(null);
    return;
   }

  if(clientSelected) {
    this.clientsVerifyExists[index] = this.formPaxesReservationData.clientsAssociated.find(c => c.id === clientSelected);
  }

    // Inicializar posición si no existe
    if (!this.validDataForm[index]) {
      this.validDataForm[index] = { document_number: null, email: null, type: null };
    }

  if(text !== undefined && text !== '') {

    switch (type) {
      case 'full':
        this.validDataForm[index].document_number = text.document_number;
        this.validDataForm[index].email = text.email;
         this.validDataForm[index].type = documentType;
        break;
      case 'email':
        this.validDataForm[index].email = email
        break;
      case 'type_document':
        this.validDataForm[index].type = documentType;
        break;
      case 'document_number':
        this.validDataForm[index].document_number = documentNumber;
        break;
    }

    // this.validDataForm[index] = this.payloadValid;
if(this.validDataForm &&
    this.validDataForm[index] &&
    this.validDataForm[index].email &&
    this.validDataForm[index].type &&
    this.validDataForm[index].document_number) {

        if(this.clientsVerifyExists &&
          this.clientsVerifyExists[index]
        ) {
          const verified = this.verifyClientData(this.clientsVerifyExists[index], documentType, email, documentNumber);

          if(verified){
            return;
          }
        }
  this._restService.doPost('app', 'checkClient', this.validDataForm[index])
    .subscribe({
      next: (responseCheck: any) => {
        if (responseCheck) {
          if (responseCheck.exist === false) {
            if(!this.data.typeAction) {


                  const paxesArray = this._form.get('paxes') as FormArray;
                  const formGroupAtIndex = paxesArray.at(index) as FormGroup;

                  if(formGroupAtIndex) {
                            const documentNumberControl = formGroupAtIndex.get('document_number');
                            if(documentNumberControl && documentNumberControl.value > 0) {
                              documentNumberControl.setErrors(null);

                        }

                          const emailControl = formGroupAtIndex.get('email');
                          if(emailControl && emailControl.value !== null) {
                            emailControl.setErrors(null);

                      }

            }
          }
          } else {

              const paxesArray = this._form.get('paxes') as FormArray;
              const formGroupAtIndex = paxesArray.at(index) as FormGroup;
              const documentNumberControl = formGroupAtIndex.get('document_number');
              const emailControl = formGroupAtIndex.get('email');
              const typePaxValue = formGroupAtIndex.get('type');
              const customErrors = { 'customErrorKey': true };
              const clientId = this.formPaxesReservationData.paxList[index]?.clientId;

              if(moment(responseCheck.client.birth_date).isBefore(this.formPaxesReservationData.minDateAdult)) {
                if(typePaxValue.value === 'adult') {
                    if(responseCheck.client?.id === clientId) {
                      if(formGroupAtIndex) {
                        if(documentNumberControl && responseCheck.client?.document_number == documentNumberControl.value) {
                          documentNumberControl.setErrors(null);
                          // return;

                        }
                        if(emailControl && responseCheck.client?.email === emailControl.value) {
                          emailControl.setErrors(null);
                          // return;
                        }
                      }
                    } else {
                      if(formGroupAtIndex) {


                          if(documentNumberControl && responseCheck.client?.document_number == documentNumberControl.value) {
                            documentNumberControl.setErrors(customErrors);

                          }
                          if(emailControl && responseCheck.client?.email === emailControl.value) {
                            emailControl.setErrors(customErrors);
                          }

                      }
                    }
                  }

                    if(!this.data.typeAction && responseCheck.client?.id !== clientId ) {
                      const url = `clients/${responseCheck.client?.id}`;
                      this._restService.doGet("app", url).subscribe({
                        next: (res: any) => {
                              if(res?.data) {
                                const associate = res.data;

                                  if(
                                    !this.firstCharge && associate &&
                                    (responseCheck?.client?.document_number === associate.document_number &&
                                    responseCheck?.client?.email === associate.email) &&
                                    formGroupAtIndex.get('clientSelected').value !== associate.id
                                    ) {

                                        const clientInfo = `
                                                              Cliente existente encontrado:<br>
                                                              <strong>Nombre:</strong> ${associate.first_name} ${associate.last_name}<br>
                                                              <strong>Email:</strong> ${associate.email}<br>
                                                              <strong>${associate.document_type_id === 4 ? 'DNI' : 'Pasaporte'}:</strong> ${associate.document_number}
                                                            `;
                                     this.notificationService.info(clientInfo, 'Cliente ya existe en la lista');
                                      if(typePaxValue.value === 'adult') {
                                        if(formGroupAtIndex) {
                                          if(documentNumberControl && responseCheck.client?.document_number == documentNumberControl.value) {
                                            documentNumberControl.setErrors(customErrors);

                                          }
                                          if(emailControl && responseCheck.client?.email === emailControl.value) {
                                            emailControl.setErrors(customErrors);
                                          }
                                        }
                                      } else {
                                        if(formGroupAtIndex) {
                                          if(documentNumberControl && responseCheck.client?.document_number == documentNumberControl.value) {
                                            documentNumberControl.setErrors(null);

                                          }
                                          if(emailControl && responseCheck.client?.email === emailControl.value) {
                                            emailControl.setErrors(null)
                                          }
                                        }
                                      }
                                      return;
                                    }  else {
                                        if(documentNumberControl && responseCheck.client?.document_number == documentNumberControl.value) {
                                            documentNumberControl.setErrors(null);

                                          }
                                          if(emailControl && responseCheck.client?.email === emailControl.value) {
                                            emailControl.setErrors(null)
                                          }
                                    }

                                  this.firstCharge = false;

                              };
                        },
                        error: (error: HttpErrorResponse) => {
                          // console.log(error);
                        }
                  })
              }



              }
          }
        }
      },
      error: (error: HttpErrorResponse) => {
        // console.log(error);
      }
    });
}


      this.enterInputDocument(index);
  }
}

verifyClientData(client: any, documentType: any, email: string, documentNumber: string): boolean {

  const verifiedClient = client.document_number === documentNumber &&
                         client.document_type_id === documentType &&
                         client.email === email;
  if(verifiedClient) {
    return true;
  }
}

updateInputClasses(firstCharge: boolean) {
  if (firstCharge === true && !this.data.typeAction) {
    // Asegúrate de que las referencias estén disponibles
    if (this.document_type_id && this.documentNumber && this.documentNumberChild) {

      // Iterar sobre document_type_id
      this.document_type_id.forEach((inputElement: ElementRef, index: number) => {
        const element = inputElement.nativeElement;
        const controlDocumentType = this._form.get(`paxes.${index}.document_type_id`);
        const controlDocumentNumber = this._form.get(`paxes.${index}.document_number`);
        const controlDocumentNumberChild = this._form.get(`paxes.${index}.document_number_child`);

        // 🔹 VERIFICAR SI DEBE TENER VALIDACIÓN
        const shouldValidate = this.shouldValidateField(index, 'document_type_id');

        if (!shouldValidate) {
          // 🔹 Si NO debe validar, remover clases y estilos
          element.classList.remove('is-invalid', 'is-valid');
          element.style.backgroundColor = '';
          element.style.color = '';
          element.style.pointerEvents = '';
          return; // 🔹 Salir temprano
        }

        // 🔹 Solo continuar si DEBE validar
        if (controlDocumentType && controlDocumentType.value !== null &&
            (controlDocumentNumber && controlDocumentNumber.value !== null ||
             controlDocumentNumberChild && controlDocumentNumberChild.value !== null)) {
          element.classList.remove('is-invalid');
          element.classList.add('is-valid');
          if (controlDocumentType.disabled) {
            element.style.backgroundColor = '#d4edda';
            element.style.color = '#000000';
            element.style.pointerEvents = 'none';
          }
          this.dataClientBefore = true;
        } else {
          element.classList.remove('is-valid');
          element.classList.add('is-invalid');
        }
      });

      // Iterar sobre document_number
      this.documentNumber.forEach((inputElement: ElementRef, index: number) => {
        const element = inputElement.nativeElement;
        const controlDocumentType = this._form.get(`paxes.${index}.document_type_id`);
        const controlDocumentNumber = this._form.get(`paxes.${index}.document_number`);

        // 🔹 VERIFICAR SI DEBE TENER VALIDACIÓN
        const shouldValidate = this.shouldValidateField(index, 'document_number');

        if (!shouldValidate) {
          element.classList.remove('is-invalid', 'is-valid');
          element.style.backgroundColor = '';
          element.style.color = '';
          element.style.pointerEvents = '';
          return;
        }

        if (controlDocumentNumber && controlDocumentNumber.value !== null) {
          element.classList.remove('is-invalid');
          element.classList.add('is-valid');
          if (controlDocumentNumber.disabled) {
            element.style.backgroundColor = '#d4edda';
            element.style.color = '#000000';
            element.style.pointerEvents = 'none';
          }
          this.dataClientBefore = true;
        } else {
          element.classList.remove('is-valid');
          element.classList.add('is-invalid');
          this.dataClientBefore = false;
        }
      });

      // Iterar sobre document_number_child
      this.documentNumberChild.forEach((inputElement: ElementRef, index: number) => {
        const element = inputElement.nativeElement;
        const controlDocumentType = this._form.get(`paxes.${index}.document_type_id`);
        const controlDocumentNumberChild = this._form.get(`paxes.${index}.document_number`);

        // 🔹 VERIFICAR SI DEBE TENER VALIDACIÓN
        const shouldValidate = this.shouldValidateField(index, 'document_number_child');

        if (!shouldValidate) {
          element.classList.remove('is-invalid', 'is-valid');
          element.style.backgroundColor = '';
          element.style.color = '';
          element.style.pointerEvents = '';
          return;
        }

        if (controlDocumentNumberChild && controlDocumentNumberChild.value !== null) {
          element.classList.remove('is-invalid');
          element.classList.add('is-valid');
          if (controlDocumentNumberChild.disabled) {
            element.style.backgroundColor = '#d4edda';
            element.style.color = '#000000';
            element.style.pointerEvents = 'none';
          }
          this.dataClientBefore = true;
        } else {
          element.classList.remove('is-valid');
          element.classList.add('is-invalid');
          this.dataClientBefore = false;
        }
      });
    }
    this.formPaxesReservationData.paxList.forEach((pax: any, index: number) => {
      this.enterInputDocument(index);
    });
  }
}

// 🔹 Función para saber si un campo debe tener validación
private shouldValidateField(index: number, fieldName: string): boolean {
  // Si es onlyTransports y NO es el primer pasajero, NO debe validar
  if (this.onlyTransports && index !== 0) {
    return false;
  }

  const config = this.getValidationConfig(index);
  return !!config[fieldName];
}

enterInputDocument(i: number) {


  if (!this._form) {
    return;
  }

  const paxesArray = <FormArray>this._form.controls["paxes"];
  const currentPax = paxesArray.at(i)?.value;
  const currentType = currentPax?.type;


  // Solo validar adultos
  if (currentType !== 'adult') {
    return;
  }

  const currentDocumentNumber = paxesArray.at(i)?.get('document_number')?.value;

  // ✅ Validar duplicado por documento (solo entre adultos, excluyendo el actual)
  if (currentDocumentNumber) {

    const hasDuplicateDocument = paxesArray.controls.some((control, idx) => {
      const pax = control.value;
      const isDuplicate = idx !== i &&
                          pax.type === 'adult' &&
                          pax.document_number === currentDocumentNumber;

      if (isDuplicate) {
      }
      return isDuplicate;
    });

    const docControl = paxesArray.at(i)?.get('document_number');

    if (hasDuplicateDocument) {
      docControl?.setErrors({ duplicateErrorKey: true });
    } else if (docControl?.errors?.duplicateErrorKey) {
      delete docControl.errors.duplicateErrorKey;
      docControl?.setErrors(docControl.errors);
    }

    // ✅ FORZAR ACTUALIZACIÓN DEL FORMULARIO
    docControl?.updateValueAndValidity({ emitEvent: true });
    this.cdr?.detectChanges(); // Si tienes ChangeDetectorRef
  }

}



  //** VALIDA USUARIO DE ITINERARIO Y TRAE LOS HACE SOLICITUD DE LOS CLIENTES ASOCIADOS */
  checkOwner() {
    this.getAssociateClient();
    // // console.log("clientOwner", this.clientOwner);
    // // console.log("paxes", this.paxes);
    // // console.log("paxes paxList", this.formPaxesReservationData.paxList);
    // // console.log("itinerary", this.itinerary);
    // // console.log("this.userService.itineraryActive[0]", this.userService.itineraryActive[0]);
  }

   /**
 * Obtiene la lista de clientes asociados a la agencia actual.
 *
 * Realiza una solicitud HTTP para obtener los clientes asociados a la agencia actual
 * y procesa la respuesta para extraer los números de documento de los clientes y
 * los paxes de sus itinerarios, almacenándolos en el array numberDocumentClient.
 */
getClients(): void {
  // Construye la URL para la solicitud HTTP utilizando el ID de la agencia del usuario actual
  const url = 'clients?agency_id=' + this.userService._agencyID;

  // Realiza una solicitud GET al servicio REST para obtener los clientes
  this._itineraryService._restService.doGet_('app', url).subscribe({
    next: (resp: any) => {
      this.formPaxesReservationData.clientArr = resp; // Almacena la respuesta en el array clientArr
      // Verifica si se obtuvieron clientes en la respuesta
      if(this.formPaxesReservationData.clientArr.length > 0) {
        // Recorre cada cliente en el array clientArr
        this.formPaxesReservationData.clientArr.forEach((client: any, index: number) => {
          // Verifica si el cliente tiene itinerarios asociados
          // // console.log(client)
          if(client.itineraries.length > 0) {
            // Si el cliente tiene itinerarios, recorre cada itinerario
            client.itineraries.forEach((items: any) => {
              // Parsea la lista de paxes del itinerario a un objeto JSON
              const paxList = JSON.parse(items.paxList);
              // Recorre cada pax en la lista de paxes
              // // console.log(typeof paxList, 'paxlist: ',paxList)

              if (paxList !== null) {
                paxList.forEach((paxes) => {
                  // // console.log(paxes.document_number); // Imprime el número de documento del pax en la consola
                  // Agrega el número de documento del pax al array numberDocumentClient
                  this.formPaxesReservationData.numberDocumentClient.push({
                    index: index,
                    client_id: Number(paxes.clientId) ? Number(paxes.clientId) : null,
                    document_number: Number(paxes.document_number) ? Number(paxes.document_number) : null
                  });
                });
              }

            });
          } else {
            // Si el cliente no tiene itinerarios, agrega su número de documento al array numberDocumentClient
            this.formPaxesReservationData.numberDocumentClient.push({
              index: index,
              client_id: Number(client.clientId) ? Number(client.clientId) : null,
              document_number: Number(client.document_number) ? Number(client.document_number) : null
            });
          }
        });
      }
    }
  });
}

/**
 * Verifica si debe mostrar el selector de clientes asociados
 * @param i - Índice del pasajero
 * @returns boolean indicando si debe mostrar el componente
 */
shouldShowClientSelector(i: number): boolean {

  const result = this.formPaxesReservationData?.booleanHeadline &&
                 this.selectClientFormPaxes &&
                 this.formPaxesReservationData?.clientsAssociated &&
                 this.formPaxesReservationData.clientsAssociated.length > 0;

  return result || false;
}

disableBraveAutofill(input: HTMLInputElement): void {
  // Brave a veces requiere múltiples intentos
  setTimeout(() => {
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocomplete', 'new-password');
    input.setAttribute('readonly', 'true');
    setTimeout(() => {
      input.removeAttribute('readonly');
    }, 10);
  }, 0);
}

  getAssociateClient() {
    if(this.clientOwner &&  this.clientOwner.id) {
        this._itineraryService._restService
        .doGet("app", "clients?all_ages=true&agency_id=")
        .subscribe(
          (response: any) => {
            if(Array.isArray(response.data)) {


            if (response.data.length > 0) {
              this.formPaxesReservationData.booleanHeadline = true;
              this.formPaxesReservationData.clientsAssociated = response.data;

                this.formPaxesReservationData.paxList.forEach((pax: any, index) => {
                  if(pax?.clientId) {
                    this.selectClientFunction(pax.clientId, index, true);
                  }

                   const faControl = (<FormArray>this._form.controls["paxes"]).at(index);
                   const client = this.formPaxesReservationData.clientsAssociated.find(c => c.associated_id === pax.clientId);
                  if(client) {
                    if(faControl) {
                        faControl.get('clientSelected')?.setValue(client?.client_id);
                    }

                    this.formPaxesReservationData.clientIdArr[index] = client.client_id ? client.client_id : null;
                    this.formPaxesReservationData.documentNumberPaxlistArrAux[index] = client.document_number ? client.document_number : null;
                    this.formPaxesReservationData.clientsAssociated[index].selected = true;
                    this.formPaxesReservationData.clientsAssociated[index].paxSelected = client.client_id  ? client.client_id : null;
                    this.verifyClientExist(index);

                  } else {
                    this.formPaxesReservationData.clientIdArr[index] = null;
                       this.formPaxesReservationData.clientsAssociated.forEach((element) => {
                  element.selected = false;
                  element.paxSelect = null;
                });
                  }

                })



            } else {
            }
            }
          },
          (err) => {
            // console.log("No existe informacion, clientes!");
          }
        );

        if(this.clientSelecFormPaxes.length > 2) {
          this.clientSelecFormPaxes.forEach((client: any, index: number) => {
            const selectToManipulate = this.selectClient.toArray()[index];
            const indexSelect = index + 1;
            if(selectToManipulate) {
              selectToManipulate.nativeElement.selectedIndex = client[indexSelect];
            }
          });
        };
    // } else {
    //   this.formPaxesReservationData.booleanHeadline = true;
    }

  }

listAssociatedAge(birth_date: string): number {
  if (!birth_date) return 0;

  const birthDate = new Date(birth_date);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  // Si aún no ha cumplido años este año, restar 1
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
}

selectClientFunction(clientId: any, i: any, paxInternal?: boolean) {


  if(clientId) {
    const faControl = (<FormArray>this._form.controls["paxes"]).at(i);
    const clientSelected: any[] = [null];

     const paxesList = !this.associatedFilterView[i] ? this.formPaxesReservationData.clientsAssociated : this.associatedClients;

    // Busca el cliente seleccionado en la lista de clientes asociados
    let clientAux = paxesList.find(
      (element) => Number(element.id) == Number(clientId)
    );
    if (!clientAux) return;
    clientSelected.push(clientAux);
    this.clientSelectedArr.emit(clientSelected);

    if(!paxInternal) {
      // Establece el cliente seleccionado en el formulario de paxes
      this.setClient(clientAux, i);

          // ✅ BUSCAR Y DESELECCIONAR CUALQUIER CLIENTE PREVIO EN ESTE MISMO PAX
    paxesList.forEach(client => {
      if (client.paxSelect === i && client.id !== clientAux.id) {
        client.selected = false;
        client.paxSelect = null;
      }
    });
    }


    // ✅ MARCAR EL NUEVO CLIENTE COMO SELECCIONADO
    clientAux.selected = true;
    clientAux.paxSelect = i;

    if(!paxInternal) {


      if(!this.formPaxesReservationData.paxList[i]) {
          // Crear nuevo objeto de pasajero
          const newPax = {
            ...this.paxEmpty,
            birth_date: clientAux.birth_date,
            type: clientAux.type,
            paxOptional: clientAux.paxOptional ? true : false
          };

          // Agregar a la lista de pasajeros
          this.formPaxesReservationData.paxList.push(newPax);
      }
      // Actualizar datos del pax
      this.formPaxesReservationData.paxList[i].state_id = clientAux.state_id;
      this.formPaxesReservationData.paxList[i].city = clientAux.city;
      this.getCountriesData(i, false, clientAux.country_id);
      this.changeState(i, clientAux.state_id);
      this.changeCity(i, clientAux.city);
      if(clientAux.phone_code) {
        this.changePhoneCode(i, clientAux.phone_code, 'phone_code');
      }
    }

    // ✅ FORZAR ACTUALIZACIÓN DE FILTROS
    this.forceFilterUpdate();

    if(i === 0) {
      this.getAssociatedClients();
    }

    if(i > 0 && faControl) {
      faControl.get('relation_ship')?.setValue(7);
      this.getVerifiedAssociated(this.formPaxesReservationData.paxList[0].clientId, i);
    }
  }
}

getAssociatedClients(autoSave?: boolean): void {
  const faControl = (<FormArray>this._form.controls["paxes"]).at(0);
  const ownerId = faControl.get('clientId')?.value;

  this._itineraryService._restService
  .doGet("app", "clients/associates/" + ownerId)
  .subscribe({
    next: (res: any) => {
      if(res.data && Array.isArray(res.data) && res.data.length > 0) {
        this.associatedClients = res.data;
        this.associatedFilterView.fill(true);
        this.associatedFilterView[0] = false;
        if(autoSave) {
          return;
        }

        if(this.paxes.length > 1) {
            this.handleResultsAssociated();
        }
      } else {
        this.associatedClients = [];
        this.associatedFilterView.fill(false);
      }
    },
    error: (error: HttpErrorResponse) => {
      console.log(error);
    }
  });
}

handleResultsAssociated(): void {
    const nonHolderPaxes = this.paxes.filter((_, index) => index > 0);
    const associatedAdults = this.associatedClients.filter(c => c.type === 'adult');
    const associatedChildren = this.associatedClients.filter(c => c.type === 'children');
    const totalAdultNonHolder = nonHolderPaxes.filter(p => p.type === 'adult').length;
    const totalChildrenNonHolder = nonHolderPaxes.filter(p => p.type === 'children').length;

    if (totalAdultNonHolder === associatedAdults.length && totalChildrenNonHolder === associatedChildren.length) {
        let adultCounter = 0;
        let childCounter = 0;

        for (let i = 1; i < this.paxes.length; i++) {
            const pax = this.paxes[i];

            if (pax.type === 'adult') {
                const clientToAssign = associatedAdults[adultCounter];
                if (clientToAssign?.id) {
                    this.selectClientFunction(clientToAssign.id, i, false);
                }
                adultCounter++;
            }
            else if (pax.type === 'children') {
                let clientToAssign = associatedChildren[childCounter];
                if (pax.age && associatedChildren.length > 0) {
                    const ageMatch = associatedChildren.find(c => c.age === pax.age);
                    if (ageMatch) {
                        clientToAssign = ageMatch;
                    }
                }
                if (clientToAssign?.id) {
                    this.selectClientFunction(clientToAssign.id, i, false);
                }
                childCounter++;
            }
        }
    }
}
/**
 * Calcula la cantidad de pasajeros de un tipo específico según su edad
 * @param type - Tipo de pasajero ('adult' o 'children')
 * @returns Cantidad de pasajeros que cumplen con el tipo según su edad
 */
qtyFilterPaxesType(type: string): number {
  if (!this.associatedClients || this.associatedClients.length === 0) {
    return 0;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  let count = 0;

  for (const client of this.associatedClients) {
    if (!client.birth_date) {
      // Si no tiene fecha de nacimiento, asumir adulto
      if (type === 'adult') count++;
      continue;
    }

    // Parsear la fecha de nacimiento
    let birthDate: Date | null = null;

    if (typeof client.birth_date === 'string') {
      const parts = client.birth_date.split('-');
      if (parts.length === 3) {
        // Formato YYYY-MM-DD
        birthDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
      } else {
        birthDate = new Date(client.birth_date);
      }
    } else if (client.birth_date instanceof Date) {
      birthDate = new Date(client.birth_date);
    }

    if (!birthDate || isNaN(birthDate.getTime())) {
      console.warn('Fecha inválida:', client.birth_date);
      if (type === 'adult') count++;
      continue;
    }

    // Calcular edad
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }


    // Contar según el tipo
    if (type === 'adult' && age >= 18) {
      count++;
    } else if (type === 'children' && age < 18) {
      count++;
    }
  }

  return count;
}


  getVerifiedAssociated(clientId: number, index: number) {
    if(this.clientOwner &&  this.clientOwner.id) {
      const faControl = (<FormArray>this._form.controls["paxes"]).at(0);
      const ownerId = faControl.get('clientId')?.value;
      this._itineraryService._restService
        .doGet("app", "clients/associates/" + ownerId)
        .subscribe(
          (response: any) => {
            if(Array.isArray(response.data)) {


            if (response.data.length > 0) {
              const faControl = (<FormArray>this._form.controls["paxes"]).at(index);
              const documentNumber = faControl.get('document_number')?.value;

              if(documentNumber) {

                const associatesFilter = response.data.find(c => Number(c.document_number) === Number(documentNumber));
                if(associatesFilter && associatesFilter?.relation_ship_catalogue_id) {

                   faControl.get('relation_ship')?.setValue(associatesFilter?.relation_ship_catalogue_id);

                } else {
                  faControl.get('relation_ship')?.setValue(7);
                }

              } else {
                 faControl.get('relation_ship')?.setValue(7);
              }

            } else {
               faControl.get('relation_ship')?.setValue(7);
            }
            } else {
               faControl.get('relation_ship')?.setValue(7);
            }
          },
          (err) => {
            console.log("No existe informacion, clientes!");
          }
        );

    }

  }

private getAvailableClientsForPax(paxIndex: number): any[] {
  if (!this.formPaxesReservationData.clientsAssociated) {
    return [];
  }

  // Obtener el tipo de pasajero actual
  const currentPaxType = this._form.value.paxes[paxIndex]?.type;
  const paxesList = !this.associatedFilterView[paxIndex] ? this.formPaxesReservationData.clientsAssociated : this.associatedClients;

  const filteredClients = paxesList.map(client => {
    const clientAge = this.listAssociatedAge(client.birth_date);
    let isAvailable = true;
    let selectedInCurrentPax = false;

    // ✅ VERIFICAR SI EL CLIENTE ESTÁ SELECCIONADO EN ALGÚN OTRO PAX
    for (let i = 0; i < this._form.value.paxes.length; i++) {
      const pax = this._form.value.paxes[i];
      // Verificar si este pax tiene un cliente seleccionado Y coincide con el cliente actual
      if (pax.clientSelected && Number(pax.clientSelected) === Number(client.id)) {
        isAvailable = false;
        if (i === paxIndex) {
          selectedInCurrentPax = true;
        }
        break;
      }
    }

    // ✅ VERIFICAR RESTRICCIONES DE EDAD SEGÚN EL TIPO DE PASAJERO
    if (currentPaxType === 'adult') {
      // Para adultos: mostrar solo clientes con 18 años o más
      if (clientAge < 18) {
        isAvailable = false;
      }
    } else if (currentPaxType === 'children') {
      // Para niños: mostrar solo clientes menores de 18 años
      if (clientAge >= 18) {
        isAvailable = false;
      }

      if(this.paxes[paxIndex].age !== clientAge) {
        isAvailable = false;
      }

    }

    const clientData = {
      ...client,
      age: clientAge,
      selected: !isAvailable,
      paxSelect: selectedInCurrentPax ? paxIndex : null,
      available: isAvailable
    };



    return clientData;
  }).filter(client =>
    // ✅ MOSTRAR SOLO:
    // - Clientes disponibles PARA ESTE TIPO DE PAX
    // - O el cliente seleccionado en este pax específico (aunque no cumpla edad)
    client.available || (client.selected && client.paxSelect === paxIndex)
  );


  return filteredClients;
}

/**
 * Verifica si un cliente está disponible para selección
 */
isClientAvailable(client: any, currentPaxIndex: number): boolean {
  return !client.selected || client.paxSelect === currentPaxIndex;
}





getStyles(i: number, input?: string) {
  if(input === 'relation_ship') {
    return {
      'height': this.data.typeAction ? '35px' : '42px',
      ...this.formStyles[i]
    };
  }

  if(this.onlyTransports) {
     return {
      'height': this.data.typeAction ? '35px' : '42px',
      'background-color': 'white',
       ...this.formStyles[i]
     }
  }


  if(!this.typeAction) {
    if(input === 'phone' || input === 'phone_code' || input === 'phone_2' || input === 'phone_2_code') {

        const paxesArray = this._form.get('paxes') as FormArray;
        const control = paxesArray.at(i);

      if(this.itineraryItems.some(c => c.category_id === 8)) {

        if(i === 1 && control.value.type !== 'adult') {
          return {
              'height': this.data.typeAction ? '35px' : '42px',
              'background-color': '#e9ecef',
              'pointer-events': 'none',
              ...this.formStyles[i]
            };
        }

        if(i > 1) {

          return {
              'height': this.data.typeAction ? '35px' : '42px',
              'background-color': '#e9ecef',
              'pointer-events': 'none',
              ...this.formStyles[i]
            };
        }
      }
    }
  }

  return {
    'height': this.data.typeAction ? '35px' : '42px',
    'background-color': this.clientData.styleFormDisable ? '#e9ecef' : 'white',
    'pointer-events': this.clientData.styleFormDisable ? 'none' : 'all',
    ...this.formStyles[i]
  };
}


productTransferInItinerary(index: number): boolean {

        const paxesArray = this._form.get('paxes') as FormArray;
        const control = paxesArray.at(index);

    const hasCategory8 = this.itineraryItems.some(c => c.category_id === 8);

    if (!hasCategory8) {
        return false;
    }

    // Si tiene category_id === 8
    if (index > 1) {
        return true;
    }

    if (index === 1) {
        const paxType = control.value?.type;

        return paxType !== 'adult';
    }

}


/**
 * Establece la información del cliente en el formulario de paxes.
 * @param client Información del cliente a establecer.
 * @param i Índice del formulario de paxes al que se aplicarán los cambios.
 */
/**
 * Actualiza la fecha de nacimiento con setTimeout para forzar el refresh del datepicker
 */
private updateBirthDateWithDelay(control: any, date: Date, delay: number = 100): void {
  control.setValue(date);
  control.markAsTouched();

  setTimeout(() => {
    control.setValue(date, { emitEvent: true });
    control.updateValueAndValidity({ emitEvent: true });
    this.cdr?.detectChanges();
  }, delay);
}


setClient(client: any, i: any) {
  const faControl = (<FormArray>this._form.controls["paxes"]).at(i);
  const birthControl = faControl["controls"]["birth_date"];
  const paxType = this.paxes?.[i]?.type;
  const paxAge = this.paxes?.[i]?.age;

  // Asignar valores básicos
  faControl["controls"]["title"].setValue(client.title);
  faControl["controls"]["gender"].setValue(client.gender);
  faControl["controls"]["first_name"].setValue(client.first_name);
  faControl["controls"]["last_name"].setValue(client.last_name);

  // ✅ MANEJO DE FECHA DE NACIMIENTO
  if (paxType === 'children') {
    // 👶 PARA NIÑOS: Usar arrivalDate y edad predefinida
    const arrivalDate = this.paxes[i]?.arrivalDate;

    if (paxAge !== null && paxAge !== undefined && !isNaN(paxAge) && arrivalDate) {
      const birthDateStr = this.getBirthDateFromAge(paxAge, arrivalDate);
      const [year, month, day] = birthDateStr.split('-').map(Number);
      const correctDate = new Date(Date.UTC(year, month - 1, day, 12, 0, 0));
      birthControl.setValue(correctDate);
    } else {
      birthControl.setValue(null);
    }
    birthControl.updateValueAndValidity({ emitEvent: true });

  } else if (this.hasFixedAge(i)) {
    // 👨 ADULTO CON EDAD COTIZADA EN ASISTENCIA: día/mes del cliente, año forzado
    birthControl.setValue(this.getFixedAgeBirthDate(i, client.birth_date));
    birthControl.markAsTouched();
    birthControl.updateValueAndValidity({ emitEvent: true });

  } else {
    // 👨 PARA ADULTOS: Usar fecha del cliente o maxDateAdult por defecto
    const birthDateMoment = moment(client.birth_date, ['YYYY-MM-DD', 'DD-MM-YYYY', 'YYYY-DD-MM']);

    if (birthDateMoment.isValid()) {
      let birthDate = birthDateMoment.toDate();
      birthDate = new Date(birthDate.getFullYear(), birthDate.getMonth(), birthDate.getDate());
      birthControl.setValue(birthDate);
    } else {
      // Si no hay fecha válida del cliente, usar maxDateAdult (18 años atrás)
      const maxDateAdult = this.formPaxesReservationData?.maxDateAdult;
      if (maxDateAdult) {
        birthControl.setValue(maxDateAdult);
      } else {
        // Fallback: 18 años atrás desde hoy
        const defaultAdultDate = new Date();
        defaultAdultDate.setFullYear(defaultAdultDate.getFullYear() - 18);
        birthControl.setValue(defaultAdultDate);
      }
    }
    birthControl.markAsTouched();
    birthControl.updateValueAndValidity({ emitEvent: true });
  }

  const clientId = this.getClientIdSelect(client, i);

  // Resto de asignaciones...
  faControl["controls"]["country_id"].setValue(client.country_id);
  faControl["controls"]["state_id"].setValue(client.state_id);
  faControl["controls"]["document_type_id"].setValue(client.document_type_id);
  faControl["controls"]["document_number"].setValue(client.document_number);
  faControl["controls"]["email"].setValue(client.email ? client.email : "");
  faControl["controls"]["phone"].setValue(client.phone ? client.phone : "");
  faControl["controls"]["phone_code"].setValue(client.phone_code ? client.phone_code : "");
  faControl["controls"]["phone_2"].setValue(client.phone_2 ? client.phone_2 : "");
  faControl["controls"]["phone_2_code"].setValue(client.phone_2_code ? client.phone_2_code : "");
  faControl["controls"]["address"].setValue(client.address ? client.address : "");
  faControl["controls"]["postal_code"].setValue(client.postal_code ? client.postal_code : "");
  faControl["controls"]["relation_ship"].setValue(client.relation_ship_catalogue_id ? client.relation_ship_catalogue_id : 7);
  faControl["controls"]["city"].setValue(client.city ? client.city : "");
  faControl["controls"]["clientSelected"].setValue(clientId ? clientId : "");
  faControl["controls"]['paxOptional'].setValue(client.paxOptional ? true : false);
  if(client.id) {
    faControl["controls"]["clientId"].setValue(clientId ? clientId : "");
  }

  setTimeout(() => {
    this._form.updateValueAndValidity({ emitEvent: true });
    this.cdr?.detectChanges();
  }, 200);

  const document_number = faControl["controls"]["document_number"].value;
  this.consultClientId(document_number, i);
  this.onPhoneBlur(i);
}

getClientIdSelect(client, i): number {

  if(!client) {
    return 0;
  }

  const extractId = !this.associatedFilterView[i] ? client.id : client.client_id;

  if(!extractId) {
    return 0;
  }

  return extractId;

}


  toStr(client: string) {
    return client.toString();
  }

  prueba: boolean = true;

resetClient(i: any, adult: any) {

    const items = this.itinerary.items.some(c => c.status_id === 2);
    const itemsQuote = this.itinerary.items.filter(c => c.status_id !== 5).every(c => c.status_id === 1);

    const paxesArray = this._form?.get('paxes') as FormArray;
    if (!paxesArray) return;

    // Verificar si hay al menos un clientId en otros paxes (excluyendo índice 0)
    let hasClientIdInOtherPaxes = false;
    for (let j = 1; j < paxesArray.length; j++) { // ✅ desde 1, excluyendo el primero
        const formGroup = paxesArray.at(j) as FormGroup;
        const currentClientId = formGroup.get('clientId')?.value;
        if (currentClientId && currentClientId > 0) {
            hasClientIdInOtherPaxes = true;
            break;
        }
    }

    // Caso: producto reservado y es el titular
    if (items && i === 0) {
        this.notificationService.info('No se puede modificar el cliente titular porque el file ya tiene al menos un producto reservado.');
        return;
    }

    // Caso: cotización y es el titular
    if (itemsQuote && i === 0) {
        if (hasClientIdInOtherPaxes) {
            // Abrir modal
            const initialState: ModalOptions = {
                initialState: {
                    icon: 'assets/icons/itinerary-detail/04-01.svg',
                    title: 'Eliminar información',
                    message: 'Esta acción eliminará la información de los demás formularios <br /> ¿Está seguro de eliminar la información cargada?'
                }
            };

            const modalConfig: any = {
                ...initialState,
                ...this.config,
            };

            this.bsModal = this.modalService.show(ConfirmationModalComponent, modalConfig);

            const confirmSubscription = this.bsModal?.content?.confirmResult?.subscribe((result: boolean) => {

              if (result) {
                    // ✅ Reiniciar TODOS los formularios (excepto el primero/índice 0)
                    for (let j = 0; j < paxesArray.length; j++) {
                        this.resetForm(j, this.paxes[j]);
                    }
                }
                confirmSubscription.unsubscribe();
            });
            return;
        } else {
            // No hay otros clientes, resetear solo el actual
            this.resetForm(i, adult);
        }
        return;
    }

    // Caso normal (no es titular)
    this.resetForm(i, adult);
}
resetForm(i: number, adult: any): void {

    const errorCustom = { 'customErrorBirthDate': true };

    // Resetear estados de validación
    this.countryCheck[i] = false;
    this.stateCheck[i] = false;
    this.cityCheck[i] = false;
    this.phoneCodeCheck[i] = false;

    // Resetear el select
    const select = document.getElementById("my-select-" + i) as HTMLSelectElement | null;
    if (select != null) {
      select.selectedIndex = 0;
    }

    // ✅ BUSCAR Y LIBERAR EL CLIENTE SELECCIONADO EN ESTE PAX
    let clientSelectedFound = this.formPaxesReservationData.clientsAssociated?.find(
      (element) => element.paxSelect == i
    );

    if (clientSelectedFound) {
      let clientFoundIndexNew = this.formPaxesReservationData.clientsAssociated.indexOf(clientSelectedFound);
      this.formPaxesReservationData.clientsAssociated[clientFoundIndexNew].selected = false;
      this.formPaxesReservationData.clientsAssociated[clientFoundIndexNew].paxSelect = null;
    }

    const faControl = (<FormArray>this._form.controls["paxes"]).at(i);

    // ✅ CALCULAR FECHA DE NACIMIENTO PARA NIÑOS
    let defaultBirthDate = null;

    if (adult.type === 'adult') {
      defaultBirthDate = this.hasFixedAge(i) ? this.getFixedAgeBirthDate(i) : this.formPaxesReservationData.minDateAdult;
    } else if (adult.type === 'children') {
      // ✅ Usar SOLO arrivalDate (objeto Date)
      const paxAge = this.paxes[i]?.age;
      const arrivalDate = this.paxes[i]?.arrivalDate;

      if (paxAge !== null && paxAge !== undefined && arrivalDate) {
        // Calcular fecha de nacimiento usando arrivalDate y edad
        const birthYear = arrivalDate.getFullYear() - paxAge;
        const birthMonth = arrivalDate.getMonth();
        const birthDay = arrivalDate.getDate();

        // Crear fecha usando UTC para evitar problemas de zona horaria
        defaultBirthDate = new Date(Date.UTC(birthYear, birthMonth, birthDay, 12, 0, 0));


      } else {
        defaultBirthDate = this.formPaxesReservationData.maxDateChild;
      }
    }

    // Resetear todos los controles del formulario
    const controlsToReset = {
      "title": null,
      "gender": null,
      "first_name": null,
      "last_name": null,
      "birth_date": defaultBirthDate,
      "document_type_id": null,
      "document_number": null,
      "email": null,
      "phone": null,
      "relation_ship": null,
      "country_id": null,
      "state_id": null,
      "city": null,
      "address": null,
      "postal_code": null,
      "phone_code": null,
      "phone_code_selected": null,
      "phone_2_code_selected": null,
      "phone_2": null,
      "phone_2_code": null,
      "clientSelected": null,
      "clientId": null
    };

    // ✅ LIMPIAR EL CONTROL DE BÚSQUEDA
    if (this.clientSearchControls[i]) {
      this.clientSearchControls[i].setValue('', { emitEvent: true });
    }

    if (this.validDataForm[i]) {
      this.validDataForm[i] = { email: null, document_number: null, document_type_id: null };
    }

    Object.keys(controlsToReset).forEach(controlName => {
      if (faControl["controls"][controlName]) {
        faControl["controls"][controlName].setValue(controlsToReset[controlName]);
      }
    });

    // ✅ SI ES NIÑO Y TIENE EDAD (O ADULTO CON EDAD DE ASISTENCIA), LIMPIAR ERRORES
    if ((adult.type === 'children' && this.paxes[i]?.age) || (adult.type === 'adult' && this.hasFixedAge(i))) {
      const birthControl = faControl["controls"]["birth_date"];
      birthControl.setErrors(null);
      birthControl.updateValueAndValidity({ emitEvent: true });
    } else {
      faControl["controls"]["birth_date"].setErrors(errorCustom);
    }

    faControl["controls"]["birth_date"].markAsUntouched();

    setTimeout(() => {
      ['country_id', 'state_id', 'city', 'phone_code', 'phone_2_code'].forEach(control => {
        if (faControl.get(control)) {
          faControl.get(control).setValue(null);
        }
      });
    }, 10);

    if (this.formPaxesReservationData.paxList[i]) {
      this.formPaxesReservationData.paxList[i].country_id = null;
      this.formPaxesReservationData.paxList[i].state_id = null;
      this.formPaxesReservationData.paxList[i].city = null;
    }

    this.formStyles[i] = {
      backgroundColor: 'white',
      pointerEvents: 'all'
    };

    // ✅ FORZAR ACTUALIZACIÓN DE LOS FILTROS
    this.forceFilterUpdate();

    // ✅ FORZAR REFRESCO DEL FORMULARIO
    setTimeout(() => {
      this._form?.updateValueAndValidity();
      this.cdr?.detectChanges();
    }, 50);
}

/**
 * Fuerza la actualización de todos los filtros de clientes
 */
private forceFilterUpdate(): void {
  // Forzar actualización de todos los controles de búsqueda
  this.clientSearchControls.forEach((control, index) => {
    if (control) {
      const currentValue = control.value;
      control.setValue('', { emitEvent: false });
      setTimeout(() => {
        control.setValue(currentValue, { emitEvent: true });
      }, 0);
    }
  });
}

verifyClientExist(i: any): boolean {
  // console.log(this.formPaxesReservationData.clientsAssociated)
  return this.formPaxesReservationData.clientsAssociated.some(
    client => client.paxSelect === i && client.selected
  );
}

getDocumentTypesList(i?: number): void {

  this._itineraryService._restService.doGet(routes.app, routes.document_type)
    .subscribe({
      next: (res: any) => {
        if(res && res.length > 0) {
          this.formPaxesReservationData.documentTypes = res;
          this.formPaxesReservationData.documentTypes = this.formPaxesReservationData.documentTypes.filter(c => c.id === 4 || c.id === 5);
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    })
}



  //* LISTADO DE PAISES Y ESTADOS *//


  getCountries(): void {
     this.countriesSubscription = this._itineraryService._restService.doGet(routes.app, routes.countries).subscribe({
      next: (res: any) => {
        this.formPaxesReservationData.countries = res["Countrys"];
        this.filteredCountries = this.formPaxesReservationData.countries;

         this.filteredCountries =  this.filteredCountries.map((country: any) => ({
              ...country,
              displayValue: `${country.country_name} (+${country.phone_code})`
            }));
        if(this.typeAction === 'Edit') {
          if(this.associateClient) {
            this.getCountriesData(0, false, this.clientData.assosiateClient.country_id);
            this.changeCity(0, Number(this.clientData.assosiateClient.city));
          } else {
            this.getCountriesData(0, true, this.clientData?.mainClient?.country_id);
            this.changeCity(0, Number(this.clientData?.mainClient?.city));
          }

          this.changePhoneCode(0, this.phone_code[0], 'phone_code');
          this.changePhoneCode(0, this.phone_2_code[0], 'phone_2_code');
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error)
      }
     })
  }

 /**
 * Obtiene la lista de países desde el servicio de itinerario.
 * También puede actualizar los controles del formulario con la información del país si se proporciona un cliente.
 *
 * @param i (Opcional) El índice del pasajero en el formulario de pasajeros.
 * @param setting (Opcional) Indica si se debe configurar el formulario con la información del país.
 * @param client (Opcional) El objeto cliente del cual obtener el país.
 */
  getCountriesData(i?: number, setting?: boolean, countryId?: any, type?: string): void {

    if(this.formPaxesReservationData.countries && this.formPaxesReservationData.countries.length === 0) {
       this.countriesSubscription = this._itineraryService._restService.doGet(routes.app, routes.countries)
    // .pipe(takeUntil(this._unsubscribeAll))
    .subscribe({
      next: (response: any) => {
          // this.formPaxesReservationData.booleanSelectCountries = faControl.touched;
          const faControl = (<FormArray>this._form.controls["paxes"]).at(i);
          // if(!setting) {
            this.formPaxesReservationData.countries = response["Countrys"];
            this.filteredCountries = this.formPaxesReservationData.countries;
            // console.log(this.filteredCountries)
            this.filteredCountries =  this.filteredCountries.map((country: any) => ({
              ...country,
              displayValue: `${country.country_name} (+${country.phone_code})`
            }));
            this.loadedClientInfoForm = true;
            this.appLoading = false;



            // if(!this.data?.typeAction) {
            //   this.onPhoneBlur(i);
            // }

          // } else {
            let country;
            if(faControl?.value?.country_id > 0 && setting) {
               country = this.filteredCountries.find(c => c.country_code === faControl.value.country_id);
            }
            if(countryId) {
               country = this.filteredCountries.find(c => c.country_code === countryId);
               if(!country) {
                country = this.filteredCountries.find(c => c.country_name === countryId);
               }
            }
              if(country && country.country_name) {
                if(this.data.typeAction) {

                  faControl['controls']['country_id'].setValue(country.country_name);
                  this.selectedIsCountry[0] = country.country_name;
                  if(this.data.fromAssociates === true && (this.data.typeAction === 'Edit' || this.selectedClientAssociated )) {
                    this.getStatesData(i, country.country_code)
                  } else {
                    this.getStatesData(i);
                  }
                } else {

                  faControl['controls']['country_id'].setValue(country.country_name);
                  this.selectedIsCountry[i] = country.country_name;
                  if(type === 'child' || type === 'children' || faControl?.value?.type === 'children') {
                    this.countryCheck[i] = true;
                    this.formPaxesReservationData.country_parent = country.country_name;
                  }

                  this.getStatesData(i, countryId, countryId, type);
                }
              }
          // }
              // if(setting && this.filteredCountries && this.filteredCountries.length > 0) {

              let phone_code_data;
              if(!this.data.typeAction) {
                if(!this.formPaxesReservationData.paxList[i].phone_code) {
                  this.formPaxesReservationData.paxList.push(this.formPaxesReservationData.paxList[0].phone_code);
                }
                if (this.formPaxesReservationData.paxList[i]?.phone_code) {
                  const phoneCodeValue = this.formPaxesReservationData.paxList[i].phone_code;
                  // Verifica si el valor es un número puro
                  if (!isNaN(Number(phoneCodeValue))) {
                    phone_code_data = this.filteredCountries.find(c => c.phone_code === phoneCodeValue);

                  } else {
                    faControl['controls']['phone_code'].setValue(phoneCodeValue);
                    this.phone_code[i] = phoneCodeValue;
                  }
                } else {
                  phone_code_data = this.filteredCountries.find(c => c.displayValue === this.formPaxesReservationData.paxList[i]?.displayValue);
                }

                if(i === 0 && !this.data.typeAction) {
                  this.formPaxesReservationData.paxList.forEach((pax: any, index: number) => {
                    if (pax.type === 'children') {
                      const phoneParent = this.formPaxesReservationData.paxList[0].phone_code;

                      if(phoneParent) {
                        if (!isNaN(Number(phoneParent))) {
                          phone_code_data = this.filteredCountries.find(c => c.phone_code === phoneParent);
                        } else {
                          phone_code_data = this.filteredCountries.find(c => c.displayValue === phoneParent);
                        }

                      }

                      this._form.get(['paxes', index, 'phone_code'])?.setValue(phone_code_data.displayValue);
                      this._form.get(['paxes', index, 'phone_code'])?.updateValueAndValidity();
                      this.phoneCodeCheck[index] = true;
                    }
                  });
                }
              }
              else if(this.data.typeAction && this.data.typeAction !== 'New')
              {
                phone_code_data = this.filteredCountries.find(c => c.displayValue === this.formPaxesReservationData?.paxList[0]?.phone_code);
              }

              if(phone_code_data) {
                faControl['controls']['phone_code'].setValue(phone_code_data.displayValue);
                this.phone_code[i] = phone_code_data.displayValue;

              }

              // Si se encuentran los códigos telefónicos en la lista de países, actualiza los controles del formulario con esos códigos
              if(this.clientData.checkboxChecked === true && faControl.get('document_number').value !== null) {
                this.clientData.styleFormDisable = true;
                this.cdRef.detectChanges();
              }
              else {
                this.clientData.styleFormDisable = false;
                 this.cdRef.detectChanges();
               }

               if(this.typeAction) {
                this.onPhoneBlur(i)
               }
      },
      error: (error: HttpErrorResponse) => {
        // console.log(error);
      }
    })
    // this.countriesSubscription.unsubscribe();
    } else {


      const faControl = (<FormArray>this._form.controls["paxes"]).at(i);


       this.filteredCountries = this.formPaxesReservationData.countries;
            this.filteredCountries =  this.filteredCountries.map((country: any) => ({
              ...country,
              displayValue: `${country.country_name} (+${country.phone_code})`
            }));
            this.loadedClientInfoForm = true;
            this.appLoading = false;


            // if(!this.data?.typeAction) {
            //   this.onPhoneBlur(i);
            // }
            if(!faControl) {
              return;
            }

          // } else {
            let country;
            if(faControl?.value?.country_id > 0 && setting) {
               country = this.filteredCountries.find(c => c.country_code === faControl.value.country_id);
            }
            if(countryId) {
               country = this.filteredCountries.find(c => c.country_code === countryId);
               if(!country) {
                country = this.filteredCountries.find(c => c.country_name === countryId);
               }
            }
            // console.log(country)
              if(country && country.country_name) {
                if(this.data.typeAction) {

                  faControl['controls']['country_id'].setValue(country.country_name);
                  this.selectedIsCountry[0] = country.country_name;
                  if(this.data.fromAssociates === true && (this.data.typeAction === 'Edit' || this.selectedClientAssociated )) {
                    this.getStatesData(i, country.country_code)
                  } else {
                    this.getStatesData(i);
                  }
                } else {

                  faControl['controls']['country_id'].setValue(country.country_name);
                  this.selectedIsCountry[i] = country.country_name;
                  if(type === 'child' || type === 'children' || this.paxes[i].type === 'children') {
                    this.countryCheck[i] = true;
                    this.formPaxesReservationData.country_parent = country.country_name;
                  }

                  this.getStatesData(i, countryId, countryId,  this.paxes[i].type);
                }
              }
          // }
              // if(setting && this.filteredCountries && this.filteredCountries.length > 0) {

              let phone_code_data;
if (!this.data.typeAction) {
    // ✅ Validación segura para paxList
    if (!this.formPaxesReservationData.paxList) {
        this.formPaxesReservationData.paxList = [];
    }

    // ✅ Verificar que exista paxList[0] antes de acceder
    if (!this.formPaxesReservationData.paxList[0]) {
        this.formPaxesReservationData.paxList[0] = {};
    }

    // ✅ Validar antes de usar paxList[i]
    if (i >= this.formPaxesReservationData.paxList.length) {
        this.formPaxesReservationData.paxList[i] = {};
    }

    if (!this.formPaxesReservationData.paxList[i].phone_code) {
        // ✅ Asegurar que paxList[0].phone_code existe antes de usarlo
        const defaultPhoneCode = this.formPaxesReservationData.paxList[0]?.phone_code || null;
        if (defaultPhoneCode) {
            this.formPaxesReservationData.paxList.push(defaultPhoneCode);
        } else {
            this.formPaxesReservationData.paxList[i].phone_code = null;
        }
    }

    if (this.formPaxesReservationData.paxList[i]?.phone_code) {
        const phoneCodeValue = this.formPaxesReservationData.paxList[i].phone_code;

        // ✅ Verificar si filteredCountries existe
        if (!this.filteredCountries) {
            this.filteredCountries = [];
        }

        // Verifica si el valor es un número puro
        if (!isNaN(Number(phoneCodeValue))) {
            phone_code_data = this.filteredCountries.find(c => c?.phone_code === phoneCodeValue);
            if (phone_code_data) {
                // Procesar phone_code_data
            }
        } else {
            if (faControl && faControl['controls'] && faControl['controls']['phone_code']) {
                faControl['controls']['phone_code'].setValue(phoneCodeValue);
                if (!this.phone_code) this.phone_code = [];
                this.phone_code[i] = phoneCodeValue;
            }
        }
    }
}
              else if(this.data.typeAction && this.data.typeAction !== 'New')
              {
                phone_code_data = this.filteredCountries.find(c => c.displayValue === this.formPaxesReservationData?.paxList[0]?.phone_code);
              }

              if(phone_code_data) {
                faControl['controls']['phone_code'].setValue(phone_code_data.displayValue);
                this.phone_code[i] = phone_code_data.displayValue;

              }

              // Si se encuentran los códigos telefónicos en la lista de países, actualiza los controles del formulario con esos códigos
              if(this.clientData.checkboxChecked === true && faControl.get('document_number').value !== null) {
                this.clientData.styleFormDisable = true;
                this.cdRef.detectChanges();
              }
              else {
                this.clientData.styleFormDisable = false;
                 this.cdRef.detectChanges();
               }

               if(this.typeAction) {
                this.onPhoneBlur(i)
               }
    }





}



loadingFormClient(): void {
  switch (this.data.typeAction) {
    case 'New':

      this.selectedIsCity = [];
      this.selectedIsCountry = [];
      this.selectedIsState = [];
      this.clientData.mainClient = [];
      this.clientData.assosiateClient = [];
      if(this.data.fromAssociates === false) {
        this.setDataClientNew(this.data);
      } else {
        this.setDataClientNewAssociated(this.data);
        this.loadedClientInfoForm = true;
      }
      this.loadedClientInfoForm = true;
      this.ngxSpinner.hide();
      break;
    case 'Edit':
      this.setDataClientEdit(this.data);
      this.loadedClientInfoForm = true;
  }
}

changeState(index: number, country_id: any) {

  const faControl = (<FormArray>this._form.controls["paxes"]).at(index);
  let country;
  if(country_id) {
    country = country_id
  } else {
    let countryFilter;
    countryFilter = this.filteredCountries.find(c => c.country_name === faControl.value.country_id);
    if(countryFilter) {
      country = countryFilter.country_code;
    } else {
      countryFilter = faControl.value.country_id;
      country = countryFilter;

    }
  }
  if(country) {
    faControl.get('country_id').setErrors(null);
    this.countryCheck[index] = true;
  }
}

getStatesData(i: any, country_id?: number, client?: any, type?: string): void {
  this.selectedIsState[i] = [];
  this.selectedIsCity[i] = [];
  const faControl = (<FormArray>this._form.controls["paxes"]).at(i);
  if(faControl.value.country_id || country_id) {
    let country;
    if(country_id) {
      country = country_id
    } else {
      let countryFilter;
      countryFilter = this.filteredCountries.find(c => c.country_name === faControl.value.country_id);
      if(countryFilter) {
        country = countryFilter.country_code;
      } else {
        countryFilter = faControl.value.country_id;
        country = countryFilter;

      }
    }
    if(country) {
      faControl.get('country_id').setErrors(null);
      this.countryCheck[i] = true;
    }

    if(typeof country === 'number') {
      country = this.filteredCountries.find(c => c.destination_id === country).country_code;
    }

    if(country.length > 2) {
      country = this.filteredCountries.find(c => c.country_name === country).country_code;
    }

    this.stateByCountrySubscription = this.formPaxesService.getStates(country).subscribe({
             next: (response: any) => {
                response = response.destinations;
                this.stateFiltered = response;
                let state;
                if(this.data.typeAction) {
                  this.clientData.states = this.stateFiltered;
                    if(this.clientData.assosiateClient && this.clientData.assosiateClient?.state_id > 0) {
                      state =  this.stateFiltered.find(c => c.destination_id ===  this.clientData.assosiateClient.state_id);
                    }
                    if(this.clientData.mainClient && this.clientData.mainClient?.state_id > 0 && this.clientData.typeAction === 'Edit') {
                      state =  this.stateFiltered.find(c => c.destination_id ===  this.clientData.mainClient.state_id);
                    }
                    if(this.newClientSelectedList?.state_id > 0 && this.selectedClientAssociated) {
                      state =  this.stateFiltered.find(c => c.destination_id ===  this.newClientSelectedList.state_id);

                    }
                    if(!state) {
                      state =  this.stateFiltered.find(c => c.destination_id ===  Number(faControl.value.state_id));
                    }
                } else {
                  // Asignar por índice (no push): las respuestas llegan async y en cualquier orden;
                  // con push las regiones de un pax podían quedar en el índice de otro.
                  if(!this.formPaxesReservationData.states[i]) {
                    this.formPaxesReservationData.states[i] = {states: response};
                  } else {
                    this.formPaxesReservationData.states[i].states = response;
                  }
                  if(this.formPaxesReservationData?.paxList[i]?.state_id) {
                    state = this.formPaxesReservationData?.states[i]?.states.find(c => c.destination_id === this.formPaxesReservationData?.paxList[i]?.state_id);

                  }
                  if(type === 'children' || type === 'child' || this.paxes[i].type === 'children') {
                    state = this.formPaxesReservationData?.states[0]?.states.find(c => c.destination_id === this.formPaxesReservationData?.paxList[0]?.state_id);

                  }
                }
                if(response && response.length > 0) {
                  if(state) {
                    faControl.get('state_id').setValue(state.destination_name);
                    this.selectedIsState[i] = state.destination_name;
                    if(this.data.typeAction) {
                      if(this.data.typeAction === 'Edit' || this.selectedClientAssociated) {
                        this.getCitiesData(i, state.destination_id);
                      } else {
                        this.getCitiesData(i);
                      }
                    } else {
                      this.getCitiesData(i, state.destination_id);
                    }
                  }
                }
            },
            error: (error: HttpErrorResponse) => {
              // console.log(error);
            }
    });



  }

}

  countrySelectedValidForm(index: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!this.countryCheck[index]) {
        return { countryNotSelected: true }; // Devuelve un error si el país no está seleccionado
      }
      return null; // Devuelve `null` si no hay errores
    };
  }

  selectedTypeHeadValidForm(index: number, input: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (input === 'country' && !this.countryCheck[index]) {
        return { countryNotSelected: true }; // Devuelve un error si el país no está seleccionado
      }
      if (input === 'state' && !this.stateCheck[index]) {
        return { stateNotSelected: true }; // Devuelve un error si el país no está seleccionado
      }
      if (input === 'city' && !this.cityCheck[index]) {
        return { cityNotSelected: true }; // Devuelve un error si el país no está seleccionado
      }
      // if (input === 'phone_code' && !this.phoneCodeCheck[index]) {
      //   return { phoneCodeNotSelected: true }; // Devuelve un error si el país no está seleccionado
      // }
      // if (input === 'phone_code_2' && !this.phoneCode2Check[index]) {
      //   return { phoneCode2NotSelected: true }; // Devuelve un error si el país no está seleccionado
      // }
      return null; // Devuelve `null` si no hay errores
    };
  }

  getCitiesData(i, state?, children?): void {
    const faControl = (<FormArray>this._form.controls["paxes"]).at(i);

    let state_id;
    if(state > 0) {
      state_id = state;
    } else {

      if(!faControl.value.state_id) {
        return;
      }
      // Buscar primero en las regiones del propio pax (las de su typeahead): stateFiltered es
      // compartido y queda con la última respuesta de getStates, que puede ser de otro pax.
      const statesOfPax = this.formPaxesReservationData?.states?.[i]?.states || [];
      const stateData = statesOfPax.find(c => c.destination_name === faControl.value.state_id)
        || (this.stateFiltered || []).find(c => c.destination_name === faControl.value.state_id);

      if(!stateData || !stateData.destination_id) {
        return;
      }
      state_id = stateData.destination_id;
    }

    if(state_id) {
      faControl.get('state_id').setErrors(null);
      this.stateCheck[i] = true;
    }

    // Si el usuario cambia de región antes de que llegue una respuesta anterior, esa respuesta
    // vieja no debe pisar las ciudades de la región nueva.
    const requestId = (this.citiesRequestId[i] || 0) + 1;
    this.citiesRequestId[i] = requestId;

    this._itineraryService._restService
    .doGet(routes.app, routes.cities + state_id )
    .subscribe({
      next: (res: any) => {
        if(requestId !== this.citiesRequestId[i]) {
          return;
        }
        if(this.data.typeAction === 'Edit' || this.data.typeAction === 'New') {
          this.citiesFiltered = res.cities;
        } else {

            this.formPaxesReservationData.cities[i] = {cities: res.cities};
        }
        if(state || this.selectedClientAssociated === true) {
          let stateData;

            if((this.data.typeAction && this.data.typeAction === 'Edit')) {
              if(this.data.fromAssociates === true && this.data.typeAction === 'Edit') {
                stateData = this.citiesFiltered.find(c => c.city_id === Number(this.clientData.assosiateClient.city));
              } else {
                if(this.selectedClientAssociated === true) {
                  stateData = this.citiesFiltered.find(c => c.city_id === faControl.value.city);
                } else {
                  stateData = this.citiesFiltered.find(c => c.city_id === Number(this.clientData.mainClient.city));
                }
              }
              if(stateData) {
                faControl.get('city').setValue(stateData.city_name);
                this.selectedIsCity[0] = stateData.city_name;
              }
          } else {
            if(this.selectedClientAssociated === true){
              if(Number(this.newClientSelectedList.city) > 0 && this.selectedClientAssociated) {
                stateData =  this.citiesFiltered.find(c => c.city_id ===  Number(this.newClientSelectedList.city));
              }
            } else {
              if(children === 'children' || children === 'child' ||  this.paxes[i].type === 'children') {

               if (this.formPaxesReservationData.paxList[0]?.city) {
                    const cityId = Number(this.formPaxesReservationData.paxList[0].city);
                    stateData = this.formPaxesReservationData?.cities[0]?.cities?.find(c => c.city_id === cityId);
                }

             } else {
                // Fallback: usar la ciudad del niño mismo
                if (this.formPaxesReservationData.paxList[i]?.city) {
                    const cityId = Number(this.formPaxesReservationData.paxList[i].city);
                    stateData = this.formPaxesReservationData?.cities[i]?.cities?.find(c => c.city_id === cityId);
                }
            }
          }
            if(stateData) {
              faControl.get('city').setValue(stateData.city_name);
              this.changeCity(i, stateData.city_name);
              this.selectedIsCity[i] = stateData.city_name;
            }
          }
        }
      },
      error: (error: HttpErrorResponse) => {
        // console.log(error);
      }
    })
  }

  changeCity(index: number, cityData?: any): void {
    const faControl = (<FormArray>this._form.controls["paxes"]).at(index);
    let city;
    if(typeof cityData === 'number' && Number(cityData) > 0) {
      city = cityData;

    } else {
      let cityFind;
      const cityName = faControl.value.city;
      const paxType = faControl.get('type')?.value ?? this.paxes?.[index]?.type;

      // Primero las ciudades del propio pax (las de su typeahead); citiesFiltered es compartido
      // (formulario de clientes) y puede tener las de otro pax.
      if(!this.data.typeAction) {
        const citiesOfPax = this.formPaxesReservationData?.cities?.[index]?.cities || [];
        cityFind = citiesOfPax.find(c => c.city_name === cityName);
      }

      if(!cityFind && this.citiesFiltered) {
        cityFind = this.citiesFiltered.find(c => c.city_name === cityName);
      }

      if(!cityFind && paxType === 'children') {

        if(this.formPaxesReservationData.cities && this.formPaxesReservationData.cities.length > 0 && this.formPaxesReservationData.cities[0]?.cities) {
            cityFind = this.formPaxesReservationData.cities[0].cities.find(c => c.city_id === this.formPaxesReservationData.paxList[0].city);
        }
      }

      city = cityFind;

    }
    if(city) {
      faControl.get('city').setErrors(null);
      this.cityCheck[index] = true;
    }
  }





  changePhoneCode(index: number, phoneCodeData?: any, type?: any): void {

    const faControl = (<FormArray>this._form.controls["paxes"]).at(index);
    let phoneCodeValue;
    let countryName;
    let countryId;
    let codeParent;

    if(type === 'phone_code') {
      phoneCodeValue = faControl.get('phone_code')?.value ? faControl.get('phone_code').value : null; // Obtener el valor de phone_code

      if(index > 0 && !phoneCodeValue) {
        codeParent = this.formPaxesReservationData.paxList[0].phone_code;
      }
      if(phoneCodeValue && typeof phoneCodeValue === 'number') {
        countryId = phoneCodeValue
      }
      if(phoneCodeValue && typeof phoneCodeValue === 'string') {
        countryName = phoneCodeValue ? phoneCodeValue.split(' ')[0] : null; // Dividir por espacio y
      }

      if(phoneCodeValue && phoneCodeValue.phone_code) {
        countryId = phoneCodeValue.country_code;
      }
    }
    if(type === 'phone_2_code') {
      phoneCodeValue = faControl.get('phone_2_code').value ? faControl.get('phone_2_code').value : null; // Obtener el valor de phone_code
      if(phoneCodeValue && typeof phoneCodeValue === 'number') {
        countryId = phoneCodeValue
      }
      if(phoneCodeValue && typeof phoneCodeValue !== 'number') {
        countryName = phoneCodeValue ? phoneCodeValue.split(' ')[0] : null; // Dividir por espacio y tomar la primera parte
      }
    }

    let country;
    if(phoneCodeData) {
      country = phoneCodeData
    } else {
      let countryFilter;

      if(countryName) {
        countryFilter = this.filteredCountries.find(c => c.country_name === countryName);
      }
      if(countryId) {
        countryFilter = this.filteredCountries.find(c => c.country_code === countryId);
      }
      if(codeParent) {
        countryFilter = this.filteredCountries.find(c => c.country_code === this.formPaxesReservationData.paxList[0].phone_code);
      }

      if(countryFilter) {
        country = countryFilter.country_code;
      }
    }

    if(country) {
      if(type === 'phone_code') {
        this.phoneCodeCheck[index] = true;
        faControl.get('phone_code').setErrors(null);
        this.onPhoneBlur(index);
      }
      if(type === 'phone_2_code') {
        this.phoneCode2Check[index] = true;
          faControl.get('phone_2_code').setErrors(null);
      }

      if(this.data.typeAction) {
        this.cdr.detectChanges();
      }
    }
  }

  clearCountry(index: number, component?: any): void {
    const faControl = (<FormArray>this._form.controls["paxes"]).at(index);

    switch (component) {
      case 'country':
        faControl.get('country_id').setValue(null);

        this.selectedIsCountry[index] = null;
        this.clearCountry(index, 'state');
        this.clearCountry(index, 'city');
        this.countryCheck[index] = false;

        if(this.clientData.mainClient) {
          this.clientData.mainClient.state_id = null;
          this.clientData.mainClient.city = null;
        }

        if(this.clientData.assosiateClient) {
          this.clientData.assosiateClient.state_id = null;
          this.clientData.assosiateClient.city = null;
        }
        if(this.formPaxesReservationData.paxList) {
          this.formPaxesReservationData.paxList[index].country_id = null;
          this.formPaxesReservationData.paxList[index].state_id = null;
          this.formPaxesReservationData.paxList[index].city = null;
        }
        break;
      case 'state':
        faControl.get('state_id').setValue(null);
        this.selectedIsState[index] = null;
        this.clearCountry(index, 'city');
        this.stateCheck[index] = false;

        if(this.clientData.mainClient) {
          this.clientData.mainClient.city = null;
        }
        if(this.clientData.assosiateClient) {
          this.clientData.assosiateClient.city = null;
        }
        if(this.formPaxesReservationData.paxList && !this.data.typeAction) {
          this.formPaxesReservationData.paxList[index].state_id = null;
          this.formPaxesReservationData.paxList[index].city = null;
        }
        break;
      case 'city':
        faControl.get('city').setValue(null);
        this.selectedIsCity[index] = null;
        this.cityCheck[index] = false;
        break;
      case 'phone_code':
        faControl.get('phone_code').setValue(null);
        this.phone_code[index] = null;
        this.phoneCodeCheck[index] = false;
        break;
      case 'phone_2_code':
        faControl.get('phone_2_code').setValue(null);
        this.phone_2_code[index] = null;
        this.phoneCode2Check[index] = false;
        break;
    }
  }

//** LISTADO DE RELACIONES */

/**
 * Obtiene las relaciones disponibles para la reserva y las almacena en el formulario de paxes.
 */
getRelationShip() {
  // Realiza una solicitud GET para obtener las relaciones disponibles
  this._itineraryService._restService.doGet(routes.app, routes.relation_ship_catalogue).subscribe({
      next: (res: any) => { // Función que se ejecuta cuando se recibe una respuesta exitosa

          this.formPaxesReservationData.relationShips = res; // Almacena las relaciones disponibles en el formulario de paxes
          // Filtra las relaciones para encontrar las que no son 'Padre' ni 'Madre'
          const relationChild = res.filter(objeto => objeto.id !== 1 && objeto.id !== 2);
          // Verifica si se encontraron relaciones distintas de 'Padre' y 'Madre'
          if (relationChild.length > 0) {
              this.formPaxesReservationData.relationChild = relationChild; // Almacena las relaciones distintas de 'Padre' y 'Madre'
          } else { // Mensaje si no se encuentran relaciones distintas de 'Padre' y 'Madre'
          }

      },
      error: (error: Error) => { // Función que se ejecuta cuando ocurre un error en la solicitud
          console.error(error); // Imprime en la consola el error ocurrido
      }
  });
}



 //** VALIDACIÓN TIPO (POR HACER) Y NÚMERO DE DOCUMENTO */

  selectTypeDocument(event: any, index: number) {
    const typeDocumentSelect = event;

    if(typeDocumentSelect) {
      this.formPaxesReservationData.typeDocumentSelect = typeDocumentSelect;
      this.formPaxesReservationData.indexPaxTypeDocumentSelect = index;
    }
  }


consultClientId(document_number: number, index: number) {
  let clientAssociated;
if(this.formPaxesReservationData.clientArr['data'] && this.formPaxesReservationData.clientArr['data'].length > 0) {
  const client: any = this.formPaxesReservationData.clientArr['data'].find((client: any) => Number(client.document_number) === Number(document_number));

  if(this.formPaxesReservationData.clientsAssociated && Array.isArray(this.formPaxesReservationData.clientsAssociated)) {
    clientAssociated = this.formPaxesReservationData.clientsAssociated.find((client: any) => Number(client.document_number) === Number(document_number));
  }

  // Si se encuentra el cliente, guardar su ID en clientIdArr; de lo contrario, guardar null
  if (client && client.document_number !== null || clientAssociated && clientAssociated.document_number !== null) {
      client ? this.formPaxesReservationData.clientIdArr[index] = client.id
             : this.formPaxesReservationData.clientIdArr[index] = clientAssociated.client_id;
  } else {
      this.formPaxesReservationData.clientIdArr[index] = null;
  }

}
}



//** VALIDACIÓN FORMULARIO Y BOTON CONTINUAR */

/**
 * Verifica si los campos del formulario de confirmación de producto están completos y válidos.
 * @param event El índice del formulario de confirmación de producto en el arreglo de formularios.
 * @returns Devuelve true si todos los campos del formulario son válidos y están completos, de lo contrario devuelve false.
 */
checkProductConfirm(index: number): boolean {
  let checked = true;
  this.formPaxesReservationData.formInvalid = false;

  if (!this.data.typeAction) {
    // Si hay action type, retornar false o la lógica correspondiente
  if (this.data.typeAction) {
    return false;
  }

  // Obtener el formGroup
  const formGroup = (this._form.get('paxes') as FormArray).at(index) as FormGroup;

  // Si no hay formGroup, retornar false
  if (!formGroup) {
    return false;
  }

  if (this.hasServerPaxErrors(index)) {
    return false;
  }

  if(this.onlyTransports && index > 0) {
    const countryControl = formGroup.get('country_id');
    return countryControl ? countryControl.valid : true;
  }

  // Usar la función importada para obtener las validaciones
  const validations = getValidationsForIndex(
    index,
    this.formPaxesReservationData.paxList,
    this.onlyTransports
  );

  // Verificar cada campo según su configuración
  let isValid = true;
  validations.forEach(field => {
    const control = formGroup.get(field.key);
    // Si el campo es requerido
    if (field.required) {
      if (!control || !control.valid) {
        isValid = false;
      }
    } else {
      // Si el campo es opcional, solo validar si tiene valor
      const value = control?.value;
      if (value !== null && value !== undefined && value !== '') {
        if (!control || !control.valid) {
          isValid = false;
        }
      }
    }
  });

  // Limpiar errores de campos opcionales que no tienen valor
  const optionalFields = validations.filter(f => !f.required).map(f => f.key);
  optionalFields.forEach(fieldKey => {
    const control = formGroup.get(fieldKey);
    if (control && control.errors) {
      const value = control.value;
      // Si el campo opcional está vacío, limpiar errores
      if (value === null || value === undefined || value === '') {
        control.setErrors(null);
      }
    }
  });

  // Actualizar estado del formulario
  this.formPaxesReservationData.formInvalid = !isValid;

  return isValid;

    // const formGroup = (<FormArray>this._form.get("paxes")).at(index) as FormGroup;
    // const paxType = this.formPaxesReservationData.paxList[index]?.type;
    // const isFirstPax = index === 0;
    // const isSecondPax = index === 1;
    // const isChild = paxType === 'children';

    // if (formGroup) {

    //   if(this.onlyTransports) {
    //     if(isFirstPax) {

    //     if (isFirstPax) {
    //       const requiredFields = [
    //         'gender', 'first_name', 'last_name', 'email',
    //         'title', 'phone', 'phone_code'
    //       ];

    //       requiredFields.forEach(field => {
    //         if (!formGroup.get(field).valid) checked = false;
    //       });

    //       }
    //     }
    //   } else {

    //           if (isFirstPax) {
    //     const requiredFields = [
    //       'gender', 'first_name', 'last_name', 'email',
    //       'title', 'birth_date', 'document_type_id', 'document_number',
    //       'country_id', 'phone', 'phone_code'
    //     ];

    //     requiredFields.forEach(field => {
    //       if (!formGroup.get(field).valid) checked = false;
    //     });

    //      const optionalFields = [
    //       'state_id', 'city', 'address'
    //     ];

    //     optionalFields.forEach(field => {
    //       const control = formGroup.get(field);
    //       if (control && control.errors) {
    //         control.setErrors(null);
    //       }
    //     });

    //   }

    //   // 🔹 2do Pax (Adulto) - Solo campos básicos obligatorios
    //   else if (isSecondPax && !isChild) {
    //     const requiredFields = [
    //       'gender', 'first_name', 'last_name', 'title',
    //       'birth_date', 'document_type_id', 'document_number',
    //       'relation_ship', 'phone', 'phone_code'
    //     ];

    //     requiredFields.forEach(field => {
    //       if (!formGroup.get(field).valid) checked = false;
    //     });

    //     // Campos opcionales - no se verifican
    //     const optionalFields = [
    //       'email', 'country_id',
    //       'state_id', 'city', 'address'
    //     ];

    //     optionalFields.forEach(field => {
    //       const control = formGroup.get(field);
    //       if (control && control.errors) {
    //         control.setErrors(null);
    //       }
    //     });
    //   }

    //   // 🔹 3er Pax o Niños - Solo nombre y fecha obligatorios
    //   else if (isChild || index >= 2) {
    //     const requiredFields = ['first_name', 'last_name', 'birth_date', 'title'];

    //     requiredFields.forEach(field => {
    //       if (!formGroup.get(field).valid) checked = false;
    //     });

    //     // Limpiar errores de campos opcionales
    //     const optionalFields = [
    //       'gender', 'document_type_id', 'document_number',
    //       'email', 'phone', 'phone_code', 'country_id',
    //       'state_id', 'city', 'address', 'relation_ship'
    //     ];

    //     optionalFields.forEach(field => {
    //       const control = formGroup.get(field);
    //       if (control && control.errors) {
    //         control.setErrors(null);
    //       }
    //     });
    //   }

    //   }

    //   // 🔹 1er Pax (Adulto) - TODOS los campos obligatorios


    //   return checked;
    // }

    // return checked;
  } else {


    return false;
  }
}

clientExist(data): boolean {
  if(Array.isArray(data)) {
    return true;
  } else {
    return false;
  }
}

getValidationsForPax(index: number): any[] {
    const paxType = this.formPaxesReservationData.paxList[index]?.type;
    const isChild = paxType === 'children';

    if (this.onlyTransports) {

      if(index === 0) {
        return ValidateFormOnlyTransport;
      } else {
        return [{ key: 'country_id', required: true }];
      }

    }

    if (index === 0) {
      return ValidateFormFirstPaxes;
    }

    if (index === 1 && !isChild) {
      return ValidateFormSecondPaxes;
    }

    return ValidateFormThirdOrChildren;
  }

  // Verificar si un campo específico es requerido
  isFieldRequired(index: number, fieldKey: string): boolean {
    const validations = this.getValidationsForPax(index);
    const field = validations.find(v => v.key === fieldKey);
    return field?.required ?? false;
  }

// Verifica si el formulario es válido
isFormValid(): boolean {
  const paxesArray = this._form.get('paxes') as FormArray;
  const areSpecificControlsValid = paxesArray.controls.every((formGroup: FormGroup, index: number) => {
    const paxType = this.formPaxesReservationData.paxList[index]?.type;
    const isFirstPax = index === 0;
    const isSecondPax = index === 1;
    const isChild = paxType === 'children';

    if(this.onlyTransports) {
      if(isFirstPax) {
        return formGroup.get('title').valid &&
        formGroup.get('first_name').valid &&
             formGroup.get('last_name').valid &&
             formGroup.get('phone').valid &&
             formGroup.get('phone_code').valid &&
             formGroup.get('country_id').valid
      } else {
        const countryControl = formGroup.get('country_id');
        return countryControl ? countryControl.valid : true;
      }
    } else {
          if (isFirstPax) {
      return formGroup.get('gender').valid &&
             formGroup.get('title').valid &&
             formGroup.get('first_name').valid &&
             formGroup.get('last_name').valid &&
             formGroup.get('birth_date').valid &&
             formGroup.get('document_type_id').valid &&
             formGroup.get('document_number').valid &&
             formGroup.get('email').valid &&
             formGroup.get('country_id').valid &&
             formGroup.get('phone').valid &&
             formGroup.get('phone_code').valid &&
             // Campos opcionales para 1er pax
             (formGroup.get('postal_code').valid !== false) &&
             (formGroup.get('phone_2').valid !== false) &&
             (formGroup.get('phone_2_code').valid !== false);
    }

    // 🔹 2do Pax (Adulto) - Campos básicos obligatorios
    else if (isSecondPax && !isChild) {
      return formGroup.get('gender').valid &&
             formGroup.get('title').valid &&
             formGroup.get('first_name').valid &&
             formGroup.get('last_name').valid &&
             formGroup.get('birth_date').valid &&
             formGroup.get('document_type_id').valid &&
             formGroup.get('document_number').valid &&
             formGroup.get('phone_code').valid &&
             formGroup.get('phone').valid &&
             formGroup.get('country_id').valid &&
             // Campos opcionales - no se verifican
             (formGroup.get('relation_ship').valid !== false) &&
             (formGroup.get('postal_code').valid !== false) &&
             (formGroup.get('phone_2').valid !== false) &&
             (formGroup.get('phone_2_code').valid !== false);
    }

    // 🔹 3er Pax o Niños - Solo nombre y fecha obligatorios
    else if (isChild || index >= 2) {
      return formGroup.get('first_name').valid &&
             formGroup.get('last_name').valid &&
             formGroup.get('birth_date').valid &&
             formGroup.get('title').valid &&
             formGroup.get('country_id').valid &&
             // Campos opcionales - no se verifican
             (formGroup.get('relation_ship').valid !== false) &&
             (formGroup.get('postal_code').valid !== false) &&
             (formGroup.get('phone_2').valid !== false) &&
             (formGroup.get('phone_2_code').valid !== false);
    }
    }

    // 🔹 1er Pax (Adulto) - TODOS los campos obligatorios


    return false;
  });

  return areSpecificControlsValid;
}

/**
 * Valida si la cadena de correo electrónico proporcionada es válida según un patrón regex y utilizando la validación integrada de Angular para correos electrónicos.
 * @param email La cadena de correo electrónico a validar.
 * @returns Devuelve `null` si el correo electrónico es válido o un objeto `{ invalidEmail: true }` si es inválido.
 */
validateEmail(email: any) {
  // Expresión regular para validar el formato del correo electrónico
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[_a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  // Utiliza la validación integrada de Angular para verificar la validez del correo electrónico
  const isValid = Validators.email(email);

  // Verifica si el correo electrónico coincide con el patrón de la expresión regular
  const patternValid = regex.test(email.value);

  // Devuelve null si el correo electrónico es válido según la validación integrada de Angular o el patrón regex, de lo contrario devuelve un objeto { invalidEmail: true }
  return isValid || patternValid ? null : { invalidEmail: true };
}


// /**
//  * Bloquea la entrada de caracteres no deseados (`e`, `E`, `+`, `-`) en campos numéricos.
//  * @param event El evento de teclado.
//  */
// blockInvalidKeys(event: KeyboardEvent) {
//   if (['e', 'E', '+', '-'].includes(event.key)) {
//     event.preventDefault();
//   }
// }

blockInvalidKeys(event: KeyboardEvent, input?: string) {
    const key = event.key;

    switch (input) {
        case 'name':
            const inputElementName = event.target as HTMLInputElement;
            const currentValueName = inputElementName.value || '';
            const selectionStartName = inputElementName.selectionStart ?? 0;

            // Permitir teclas de control
            if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
                'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) {
                return;
            }

            // Validar espacio
            if (key === ' ') {
                if (selectionStartName === 0) {
                    event.preventDefault();
                    return;
                }
                if (selectionStartName > 0 &&
                    currentValueName.charAt(selectionStartName - 1) === ' ') {
                    event.preventDefault();
                    return;
                }
                return;
            }

            // Solo letras (con acentos y ñ)
            if (!/^[a-zA-ZÀ-ÿ\u00f1\u00d1]$/.test(key)) {
                event.preventDefault();
            }
            break;

        case 'number':
            const inputElementNumber = event.target as HTMLInputElement;
            const currentValueNumber = inputElementNumber.value || '';
            const selectionStartNumber = inputElementNumber.selectionStart ?? 0;

            // Permitir teclas de control
            if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
                'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) {
                return;
            }

            // Solo permitir dígitos
            if (!/^\d$/.test(key)) {
                event.preventDefault();
                return;
            }

            // Evitar 00 al inicio
            if (key === '0') {
                let newValue = currentValueNumber.substring(0, selectionStartNumber) +
                              key +
                              currentValueNumber.substring(inputElementNumber.selectionEnd ?? selectionStartNumber);

                if (newValue.startsWith('00')) {
                    event.preventDefault();
                    return;
                }

                if (selectionStartNumber === 1 && currentValueNumber.charAt(0) === '0') {
                    event.preventDefault();
                    return;
                }
            }
            break;

            case 'address':
            case 'alfanumerico':
                const inputElementAddress = event.target as HTMLInputElement;
                const currentValueAddress = inputElementAddress.value || '';
                const selectionStartAddress = inputElementAddress.selectionStart ?? 0;

                // Permitir teclas de control
                if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
                    'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) {
                    return;
                }

                // Validar espacio
                if (key === ' ') {
                    if (selectionStartAddress === 0) {
                        event.preventDefault();
                        return;
                    }
                    if (selectionStartAddress > 0 &&
                        currentValueAddress.charAt(selectionStartAddress - 1) === ' ') {
                        event.preventDefault();
                        return;
                    }
                    return;
                }

                // Crear string con TODOS los caracteres permitidos
                const letras = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
                const acentos = 'áéíóúÁÉÍÓÚüÜñÑ';
                const numeros = '0123456789';

                const todosPermitidos = letras + acentos + numeros;

                // Verificar si la tecla está permitida
                if (!todosPermitidos.includes(key)) {
                    event.preventDefault();
                }
                break;
                case 'DNI':
                    const inputElementDNI = event.target as HTMLInputElement;
                    const currentValueDNI = inputElementDNI.value || '';
                    const selectionStartDNI = inputElementDNI.selectionStart ?? 0;

                    // Permitir teclas de control
                    const controlKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
                                        'ArrowLeft', 'ArrowRight', 'Home', 'End'];
                    if (controlKeys.includes(key)) {
                        return;
                    }

                    // Solo permitir dígitos
                    if (!/^\d$/.test(key)) {
                        event.preventDefault();
                        return;
                    }

                    // Calcular nuevo valor
                    const newValueDNI = currentValueDNI.substring(0, selectionStartDNI) +
                                      key +
                                      currentValueDNI.substring(inputElementDNI.selectionEnd ?? selectionStartDNI);

                    // REGLAS DNI ARGENTINO:

                    // 1. No puede empezar con 0
                    if (newValueDNI.startsWith('0')) {
                        event.preventDefault();
                        return;
                    }

                    // 2. Máximo 8 dígitos (formato actual desde 2013)
                    if (newValueDNI.length > 8) {
                        event.preventDefault();
                        return;
                    }

                    // 3. Mínimo 6 dígitos (para DNIs antiguos)
                    // Pero permitir escritura desde 1 dígito hacia arriba
                    // La validación final se hace al enviar el formulario

                    // 4. No permitir más de 2 ceros seguidos en cualquier posición
                    // (protección adicional contra valores inválidos)
                    if (/0{3,}/.test(newValueDNI)) {
                        event.preventDefault();
                        return;
                    }

                    break;

              }
}



//** COPIA INPUT DE HOLDER A NIÑOS (EMAIL, DIRECCIÓN, CIUDAD, TIPO DE DOCUMENTO, PAÍS Y ESTADO) */

onChangeParentData(value: string, data: string): void {

  if(value && data) {
    let valueParent;
    let childArr;
    switch (data) {
      case 'email':
        this.formPaxesReservationData.email_parent = value;
        valueParent = this.formPaxesReservationData.email_parent;
        childArr = this.emailChildren;
        break;
      case 'country':
        this.formPaxesReservationData.country_parent = value['item']['country_name'];
        valueParent = this.formPaxesReservationData.country_parent;
        childArr = this.countryChildren;
        break;
      case 'destination':
        this.formPaxesReservationData.state_parent = value['item']['destination_name'];
        valueParent = this.formPaxesReservationData.state_parent;
        childArr = this.stateChildren;
        break;
      case 'city':
        this.formPaxesReservationData.city_parent = value['item']['city_name'];
        valueParent = this.formPaxesReservationData.city_parent;
        childArr = this.cityChildren;
        break;
      case 'address':
        this.formPaxesReservationData.address_parent = value;
        valueParent = this.formPaxesReservationData.address_parent;
        childArr = this.addressChildren;
        break;
      case 'phone_code':
        this.formPaxesReservationData.phone_code_parent = value['item']['displayValue'];
        valueParent = this.formPaxesReservationData.phone_code_parent;
        childArr = this.phoneChildren;
        break;
      case 'phone':
        break;
    }

    childArr.forEach((childInput: ElementRef, index: number) => {
      childInput.nativeElement.value = valueParent;
      childInput.nativeElement.dispatchEvent(new Event("value"));

    });

    const phoneCodeParent = this.formPaxesReservationData.paxList[0]?.phone_code;

    const paxesArray: any = this._form.get("paxes") as FormArray;

    // Configura los valores iniciales compartidos entre pasajeros
    // if(phoneCodeParent) {
    //   paxesArray.controls.forEach((control: FormGroup, index) => {
    //     if (index > 1) {
    //       control.get("email").setValue(email);
    //     }
    //   });
    // }

    this.formPaxesReservationData.paxList.forEach((pax: any, index: number) => {

      // Además de marcar el check, se setea el valor en el control: si solo se marca el check,
      // el input se reemplaza por el chip antes de que el ngModel llegue a escribir el control,
      // y el pax queda con el chip vacío, el control vacío (inválido) y sin poder editarlo.
      if((index > 1 || pax.type === 'children' ) && data === 'country') {
        this.countryCheck[index] = true;
        this.selectedIsCountry[index] = this.formPaxesReservationData.country_parent;
        this._form.get(['paxes', index, 'country_id'])?.setValue(valueParent);
        this._form.get(['paxes', index, 'country_id'])?.updateValueAndValidity();
      }
      if((index > 1 || pax.type === 'children' ) && data === 'destination') {
        this.stateCheck[index] = true;
        this.selectedIsState[index] = this.formPaxesReservationData.state_parent;
        this._form.get(['paxes', index, 'state_id'])?.setValue(valueParent);
      }
      if((index > 1 || pax.type === 'children' ) && data === 'city') {
        this.cityCheck[index] = true;
        this.selectedIsCity[index] = this.formPaxesReservationData.city_parent;
        this._form.get(['paxes', index, 'city'])?.setValue(valueParent);
      }
      if((index > 1 || pax.type === 'children' ) && data === 'phone_code') {
        this.phoneCodeCheck[index] = true;
        this.phoneCodeCheck[0] = true;
      }
      if ((index > 1 || pax.type === 'children' ) && data === 'address') {
        this._form.get(['paxes', index, 'address'])?.setValue(valueParent);
        this._form.get(['paxes', index, 'address'])?.updateValueAndValidity();
      }

      if ((index > 1 || pax.type === 'children' ) && data === 'email') {
        this._form.get(['paxes', index, 'email'])?.setValue(valueParent);
        this._form.get(['paxes', index, 'email'])?.updateValueAndValidity();
      }
     })

     if(this.formPaxesReservationData.paxList.length > 1 || this.typeAction) {
       this.cdr.detectChanges();
     }
  }
}

//* UTILS FORMULARIO */

/**
 * Actualiza el código de país en el formulario de acuerdo al tipo de número telefónico (principal o secundario).
 * @param code El código de país para actualizar en el formulario.
 * @param type El tipo de número telefónico ('phone' para principal, 'phone2' para secundario).
 * @param i El índice del formulario de paxes en el arreglo de formularios.
 */
getPhoneCode(code: any, type: any, i: any) {
  code = Number(code); // Convierte el código a número si no lo es
  const faControl = (<FormArray>this._form.controls["paxes"]).at(i); // Obtiene el control del formulario de paxes en la posición especificada


  // Actualiza el código de país en el formulario según el tipo de número telefónico
  if(type === 'phone') {
      this.formPaxesReservationData.phone_code = code; // Actualiza el código de país en los datos del formulario
      faControl["controls"]["phone_code"].setValue(this.formPaxesReservationData.phone_code); // Establece el nuevo código de país en el control del formulario
  }
  if(type === 'phone2') {
      this.formPaxesReservationData.phone_code_2 = code; // Actualiza el código de país en los datos del formulario
      faControl["controls"]["phone_2_code"].setValue(this.formPaxesReservationData.phone_code_2); // Establece el nuevo código de país en el control del formulario
  }
}


  setRelationShip(value: any) {
    // // console.log(this.paxes)
    this.clientData.relationId = value;
    this.formPaxesReservationData.relationShip = value;

    if(this.data.typeAction && this.data.fromAssociates) {
      const faControl = (<FormArray>this._form.controls["paxes"]).at(0);


          faControl["controls"]["email"].setValue(this.data.mainClient.email);
        faControl["controls"]["address"].setValue(this.data.mainClient.address);
       if(this.data.mainClient.phone_code) {
          this.changePhoneCode(0, this.data.mainClient.phone_code, 'phone_code');
            this.phoneCodeCheck[0] = true;
        }
        if(this.data.mainClient.phone_code_2) {
          this.changePhoneCode(0, this.data.mainClient.phone_code, 'phone_2_code');
          this.phoneCode2Check[0] = true;
        }

      // if(value === 2 || value === '2' || value === 3 || value === '3' ) {
      //   // faControl["controls"]["email"].setValue(this.data.mainClient.email);
      //   // faControl["controls"]["address"].setValue(this.data.mainClient.address);
      //   faControl["controls"]["phone_code"].setValue(this.data.mainClient.phone_code);
      //   faControl["controls"]["phone"].setValue(this.data.mainClient.phone);
      //   faControl["controls"]["phone_2_code"].setValue(this.data.mainClient.phone_code_2);
      //   faControl["controls"]["phone_2"].setValue(this.data.mainClient.phone_2);

      //   if(this.data.mainClient.phone_code) {
      //     this.changePhoneCode(0, this.data.mainClient.phone_code, 'phone_code');
      //       this.phoneCodeCheck[0] = true;
      //   }
      //   if(this.data.mainClient.phone_code_2) {
      //     this.changePhoneCode(0, this.data.mainClient.phone_code, 'phone_2_code');
      //     this.phoneCode2Check[0] = true;
      //   }
      // } else  {
      //   // faControl["controls"]["email"].setValue(null);
      //   // faControl["controls"]["address"].setValue(null);
      //   faControl["controls"]["phone_code"].setValue(null);
      //   faControl["controls"]["phone"].setValue(null);
      //   faControl["controls"]["phone_2_code"].setValue(null);
      //   faControl["controls"]["phone_2"].setValue(null);

      //    if(this.data.mainClient.phone_code) {
      //       this.phoneCodeCheck[0] = false;
      //   }
      //     if(this.data.mainClient.phone_code_2) {
      //     this.phoneCode2Check[0] = false;
      //   }

      // }
    }
  }


  getRandom() {
    return Math.floor(Math.random() * 20000000000000) + Date.now();
  }

  enableControlsBeforeSubmit() {
    const paxesArray = this._form.get('paxes') as FormArray;

    paxesArray.controls.forEach((control: FormGroup) => {
      const documentNumberControl = control.get("document_number");
      const documentTypeIdControl = control.get("document_type_id");

      // Reactiva los controles
      documentNumberControl.enable({ emitEvent: false });
      documentTypeIdControl.enable({ emitEvent: false });
    });



  }

  //** SUBMIT FORMULARIO PASAJEROS */

  async _onSubmit(autoSave?: boolean, event?: Event) {
    if(!autoSave) {
      this._loading.emit();
    }
    this.enableControlsBeforeSubmit();
        // Prevenir el comportamiento predeterminado del evento
        if (event) {
            event.preventDefault();
        }

        // Procesar los datos de los pasajeros
        const paxesData = await this.processPaxesData(autoSave);

        if(this.onlyTransports && paxesData.length > 1) {
          paxesData.forEach((pax: any, index: number) => {
              if(index > 0) {
                if(pax.first_name === null && pax.last_name === null && pax.title) {
                  paxesData.splice(index, 1);
                }
              }
          })
        }

        // Formatear los datos de los pasajeros
        const formattedPaxesData = await this.formatPaxesData(paxesData);
        let formattedPaxesDataAutoSave: any[] = [];
        formattedPaxesDataAutoSave = formattedPaxesData;
        if(formattedPaxesDataAutoSave && formattedPaxesDataAutoSave.length > 0 && autoSave === true) {
          formattedPaxesDataAutoSave = await this.formatPaxesDataAutoSave(formattedPaxesDataAutoSave);
        }


        if(!this.typeAction && !autoSave) {
         const validateValueForm = this.validValueFormatedPaxesData(formattedPaxesDataAutoSave);
          if(!validateValueForm) {
            return;
          }
        }

        // Crear el payload a enviar
        const payload = {
            paxList: formattedPaxesDataAutoSave,
        };



        // Mostrar el payload en la consola


        // Enviar los datos a la API para su procesamiento
        this._restService.doPutWithErrorBody(routes.app, routes.updatePaxlist + this.itineraryId, payload).subscribe(
            (response: any) => {
              if(autoSave === false) {
                // Si la solicitud es exitosa
                if (response.success) {
                    // Si se permite la configuración, actualizar la lista de pasajeros localmente
                    if (this.permitedConfiguration) {
                        this.itinerary.paxList = formattedPaxesData;
                        this.userService.itineraryActive[0].paxList = formattedPaxesData;
                         this.reloadPaxlist.emit();
                        this.userService.stepReservation = "three"; // Cambiar al paso tres de la reserva
                    } else {
                        // Si no se permite la configuración, iniciar el proceso de reserva
                        this.formPaxesReservationData.reserving = true;
                         this.reloadPaxlist.emit();
                        this.goReservation(formattedPaxesData, autoSave);
                    }


                } else {
                    this.handlePaxlistServerErrors(response);
                }
              } else {
                this.notificationService.success(`autoguardado finalizado`);
                // this.setForm();
                this.paxes.forEach((pax: any, index: number) => {

                  const faControl = (<FormArray>this._form.controls["paxes"]).at(index);

                  const country = this.filteredCountries.find(c => c.country_code === formattedPaxesDataAutoSave[index]?.country_id);
                  const state = this.stateFiltered.find(c => c.destination_id === formattedPaxesDataAutoSave[index]?.state_id);
                  const city = formPaxesReservationData?.cities[0]?.cities.find(c => c.city_id === formattedPaxesDataAutoSave[index]?.city);
                  let birth_date = formattedPaxesDataAutoSave[index].birth_date;

                  if(country) {
                    this.selectedIsCountry[index] = country.country_name
                    faControl.get('country_id').setValue(country.country_name);
                  }
                  if(state) {
                    this.selectedIsState[index] = state.destination_name;
                    faControl.get('state_id').setValue(state.destination_name);
                  }
                  if(city) {
                    this.selectedIsCity[index] = city.city_name;
                    faControl.get('city').setValue(city.city_name);
                  }
                  if(birth_date) {
                      // Convertir la fecha del payload a objeto Date
                      const dateObj = this.parseDateStringToDate(birth_date);

                      if (dateObj) {
                        const fixedAdult = pax.type === 'adult' && this.hasFixedAge(index);
                        faControl.get('birth_date').setValue(fixedAdult ? this.getFixedAgeBirthDate(index, dateObj) : dateObj);
                      }
                    }
                  // this.enterInputDocument(index);
                })

                // consulta de paxList
                this.reloadPaxlist.emit();
                this.getAssociatedClients(autoSave);
              }
            },
            (error: any) => {
                // console.log("Save-Error: " + error); // Manejar errores en caso de que la solicitud falle
                if(autoSave === false) {
                    // El backend puede devolver el mismo cuerpo { success, message, errors } con status 4xx
                    this.handlePaxlistServerErrors(error?.error);
                }
            }
        );
    // } catch (error) {
    //     // console.log("Save-Error: " + error); // Manejar errores en caso de que la solicitud falle
    // }
}

/**
 * Maneja el rechazo de update/paxlist (success: false). Ej.:
 * { message, errors: [{ pax_index, field, value, message, blocking }] }
 * Muestra el mensaje, marca en rojo los campos indicados, deja el pax en "Pendiente"
 * y despliega su formulario. Corta el loader que se abrió al enviar.
 */
handlePaxlistServerErrors(response: any): void {
  this._loading.emit(false);

  const errors: any[] = Array.isArray(response?.errors) ? response.errors : [];
  this.serverPaxErrors = {};

  errors.forEach((err: any) => {
    const index = Number(err?.pax_index);
    const field = err?.field;
    const control = this._form.get(['paxes', index, field]);
    if (isNaN(index) || !field || !control) {
      return;
    }

    if (!this.serverPaxErrors[index]) {
      this.serverPaxErrors[index] = {};
    }
    this.serverPaxErrors[index][field] = { message: err.message, value: control.value };
    control.markAsTouched();
    this.editDataPax[index] = true;
  });

  const message = errors.length > 0
    ? errors.map((err: any) => err.message).join(' ')
    : (response?.message || 'No se pudieron guardar los pasajeros. Intente nuevamente.');

  this.notificationService.error(message, 'No se pudieron guardar los pasajeros', 10000);
  this.cdr.detectChanges();
}

/**
 * Error del backend vigente para un campo. Se descarta en cuanto el usuario cambia el valor
 * que el backend rechazó.
 */
getServerPaxError(index: number, field: string): string | null {
  const error = this.serverPaxErrors[index]?.[field];
  if (!error) {
    return null;
  }

  const currentValue = this._form.get(['paxes', index, field])?.value;
  if (String(currentValue ?? '') !== String(error.value ?? '')) {
    delete this.serverPaxErrors[index][field];
    return null;
  }

  return error.message;
}

hasServerPaxErrors(index: number): boolean {
  const fields = Object.keys(this.serverPaxErrors[index] || {});
  return fields.some(field => this.getServerPaxError(index, field) !== null);
}

validValueFormatedPaxesData(paxes: any): boolean {
  const paxesArray = this._form.get('paxes') as FormArray;
  const validationErrors: Array<{
    passengerIndex: number;
    passengerType: string;
    missingFields: string[];
    ageWarning: string;
  }> = [];

  let allValid = true;

  // Mapeo de campos a nombres legibles
  const fieldLabels: { [key: string]: string } = {
    'gender': 'Género',
    'first_name': 'Nombre',
    'last_name': 'Apellido',
    'email': 'Email',
    'address': 'Dirección',
    'title': 'Título',
    'birth_date': 'Fecha de nacimiento',
    'document_type_id': 'Tipo de documento',
    'document_number': 'Número de documento',
    'country_id': 'País',
    'state_id': 'Provincia/Estado',
    'city': 'Ciudad',
    'phone': 'Teléfono',
    'phone_code': 'Código de teléfono',
    'relation_ship': 'Parentesco'
  };

  for (let i = 0; i < paxesArray.length; i++) {
    const formGroup = paxesArray.at(i) as FormGroup;


    const paxType = formGroup.get('type')?.value || 'adult';
    const birthDate = formGroup.get('birth_date')?.value;

    const isFirstPax = i === 0;
    const isSecondPax = i === 1;
    const isChild = paxType === 'children' || paxType === 'CH' || paxType === 'child';

    let requiredFields: string[] = [];
    const missingFields: string[] = [];
    let ageWarning = '';

    if(this.onlyTransports) {

       if (isFirstPax) {
          requiredFields = [
             'first_name', 'last_name', 'email', 'phone', 'phone_code', 'title', 'country_id'
          ];
        } else {
            requiredFields = ['country_id'];
        }


    } else {
        // Determinar campos requeridos según tipo de pasajero
        if (isFirstPax) {
          requiredFields = [
            'gender', 'first_name', 'last_name', 'email',
            'title', 'birth_date', 'document_type_id', 'document_number',
            'country_id', 'phone', 'phone_code'
          ];
        } else if (isSecondPax && !isChild) {
          requiredFields = [
            'gender', 'first_name', 'last_name', 'title',
            'birth_date', 'document_type_id', 'document_number',
            'relation_ship', 'phone', 'phone_code', 'country_id'
          ];
        } else if (isChild || i >= 2) {
          requiredFields = ['first_name', 'last_name', 'birth_date', 'title', 'country_id'];
        }
    }



    // Verificar cada campo requerido
    requiredFields.forEach(field => {
      const control = formGroup.get(field);
      if (!control?.value || control?.value === '' || control?.value === null) {
        missingFields.push(fieldLabels[field] || field);
      }
    });


    // ✅ Validar la edad según el tipo de pasajero
    if (birthDate) {
      // Obtener la edad como número directamente
      const numericAge = this.getAgeNumber(birthDate);

      // Validaciones específicas por tipo de pasajero
      if (!isChild) {
        // Es adulto
        if (numericAge < 18) {
          ageWarning = `El pasajero ${i + 1} es menor de 18 años (tiene ${numericAge}) pero está registrado como adulto`;
          console.warn(`⚠️ ${ageWarning}`);
        }
      } else {
        // Es niño
        if (numericAge >= 18) {
          ageWarning = `El pasajero ${i + 1} es mayor de 18 años (tiene ${numericAge}) pero está registrado como niño`;
          console.warn(`⚠️ ${ageWarning}`);
        }
      }
    }

    // Si hay campos faltantes o advertencias de edad, agregar a errores
    if (missingFields.length > 0 || ageWarning) {
      allValid = false;
      validationErrors.push({
        passengerIndex: i,
        passengerType: paxType,
        missingFields: missingFields,
        ageWarning: ageWarning
      });
    }
  }

  // Si hay errores, mostrar con notificationService
  if (!allValid) {
    this.showValidationErrorsWithNotification(validationErrors);
    return false;
  }

  return true;
}

/**
 * Calcula la edad como número a partir de una fecha de nacimiento
 */
getAgeNumber(birthDate: Date | string): number {
  if (!birthDate) return 0;

  const today = new Date();
  let birth = new Date(birthDate);

  // Si la fecha es inválida, intentar parsear
  if (isNaN(birth.getTime())) {
    birth = moment(birthDate, ['YYYY-MM-DD', 'DD-MM-YYYY', 'YYYY-DD-MM']).toDate();
  }

  if (isNaN(birth.getTime())) {
    console.warn('Fecha inválida:', birthDate);
    return 0;
  }

  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  const dayDiff = today.getDate() - birth.getDate();

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  return age;
}

private showValidationErrorsWithNotification(errors: Array<{
  passengerIndex: number;
  passengerType: string;
  missingFields: string[];
  ageWarning?: string;
}>): void {
  let errorMessage = 'Errores de validación:\n';

  errors.forEach(error => {
    errorMessage += `\nPasajero ${error.passengerIndex + 1} (${error.passengerType === 'adult' ? 'adulto' : 'niño'}):`;

    if (error.missingFields.length > 0) {
      errorMessage += `\nCampos faltantes: ${error.missingFields.join(', ')}`;
    }

    if (error.ageWarning) {
      errorMessage += `\n⚠️  ${error.ageWarning}`;
    }
  });

  this.notificationService.error(errorMessage);
}



  async processPaxesData(autoSave: boolean) {
    const clientIdArr: any[] = [];
    const paxesData = [];

    // clientIdArr[0] = this.clientOwner.id;
    const firstData = this._form.value.paxes[0];

    for (let index = 0; index < this._form.value.paxes.length; index++) {
        // Copia: abajo se reemplazan country_id/state_id/city por sus códigos (AR, 85, 442...) para
        // el payload. Sin copia se mutaba el _form.value que leen los chips del template, y si el
        // update fallaba el form quedaba mostrando los códigos en vez de los nombres.
        const i = { ...this._form.value.paxes[index] };


        if(this.onlyTransports) {
            if(index === 0) {
                // ===== VALIDACIÓN MEJORADA PARA COUNTRY =====
        let country = null;
        if (this.filteredCountries && this.filteredCountries.length > 0) {
            country = this.filteredCountries.find(c => c.country_name === i.country_id);
        }

        // ===== VALIDACIÓN MEJORADA PARA STATE =====
        let state = null;
        if (this.formPaxesReservationData?.states &&
            this.formPaxesReservationData.states.length > 0) {

            // Buscar en el índice correspondiente
            const stateData = this.formPaxesReservationData.states[index];

            if (stateData?.states && stateData.states.length > 0) {
                state = stateData.states.find(c => c.destination_name === i.state_id);
            }

            // Si no se encuentra en el índice específico, buscar en el primero
            if (!state && this.formPaxesReservationData.states[0]?.states) {
                state = this.formPaxesReservationData.states[0].states.find(c => c.destination_name === i.state_id);
            }
        }

        // ===== VALIDACIÓN MEJORADA PARA CITY =====
        let city = null;
        if (this.formPaxesReservationData?.cities &&
            this.formPaxesReservationData.cities.length > 0) {

            // Buscar en el índice correspondiente
            const cityData = this.formPaxesReservationData.cities[index];

            if (cityData?.cities && cityData.cities.length > 0) {
                city = cityData.cities.find(c => c.city_name === i.city);
            }

            // Si no se encuentra en el índice específico, buscar en el primero
            if (!city && this.formPaxesReservationData.cities[0]?.cities) {
                city = this.formPaxesReservationData.cities[0].cities.find(c => c.city_name === i.city);
            }
        }

        // ===== VALIDACIÓN PARA CLIENTES ASOCIADOS =====
        // if (index > 0) {

        if(i.clientId) {
          clientIdArr.push(i.clientId);
        } else {
          //  if (this.formPaxesReservationData?.clientsAssociated &&
          //       this.formPaxesReservationData.clientsAssociated.length > 0) {

          //       const client = this.formPaxesReservationData.clientsAssociated.find(
          //           c => c.document_number == i.document_number
          //       );
          //       clientIdArr.push(client?.id || null);
          //   } else {
                clientIdArr.push(null);
            // }
        }

        // }


        // ===== AUTO SAVE VALIDATIONS =====
        if (autoSave) {
            if (i.phone < 0) {
                i.phone = null;
            }
            if (i.phone_2 < 0) {
                i.phone_2 = null;
            }
            if (i.document_number < 0) {
                i.document_number = null;
            }
            if (i.first_name && !/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/.test(i.first_name)) {
                i.first_name = null;
            }
            if (i.last_name && !/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/.test(i.last_name)) {
                i.last_name = null;
            }
            if (i.email && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(i.email)) {
                i.email = null;
            }
        } else {


                  const isValidPhone = (phone: any) => {
                      if (!phone) return false;
                      const cleanPhone = phone.toString().replace(/^\+/, '').replace(/\D/g, '');
                      return /^\d{6,}$/.test(cleanPhone);
                  };

                  // Validación de nombre
                  const isValidName = (name: any) => {
                      return name && /^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/.test(name);
                  };

                  // Validación de email
                  const isValidEmail = (email: any) => {
                      return email && /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
                  };

                  // Validación de documento
                  const isValidDocument = (doc: any) => {
                      const documentTypeId = i.document_type_id;

                      if(!documentTypeId) {
                          return false;
                      }

                      // Convertir doc a string para validar
                      const docString = doc ? doc.toString() : '';

                      if(documentTypeId === 4 || documentTypeId === '4') {
                          // Solo números
                          return docString !== '' && /^[0-9]+$/.test(docString);
                      }

                      if(documentTypeId === 5 || documentTypeId === '5') {

                          // Alfanuméricos (letras y números)
                          return docString !== '' && /^[a-zA-Z0-9\-\s\.]+$/.test(docString);
                      }

                      // Para otros tipos de documento o si no coincide con 4 o 5
                      return false;
                  };

                  // Aplicar validaciones con fallback a firstData
                  if (!isValidPhone(i.phone) && firstData?.phone) {
                      i.phone = firstData.phone;
                  }

                  if (!isValidPhone(i.phone_2) && firstData?.phone_2) {
                      i.phone_2 = firstData.phone_2;
                  }

                  if (!isValidDocument(i.document_number) && firstData?.document_number) {
                      i.document_number = firstData.document_number;
                  }

                  if (!isValidName(i.first_name) && firstData?.first_name) {
                      i.first_name = firstData.first_name;
                  }

                  if (!isValidName(i.last_name) && firstData?.last_name) {
                      i.last_name = firstData.last_name;
                  }

                  if (!isValidEmail(i.email) && firstData?.email) {
                      i.email = firstData.email;
                  }

                  // También para otros campos que puedan necesitar validación
                  if (!i.address && firstData?.address) {
                      i.address = firstData.address;
                  }

                  if (!i.city && firstData?.city) {
                      i.city = firstData.city;
                  }

                  if (!i.country_id && firstData?.country_id) {
                      i.country_id = firstData.country_id;
                  }

                  if (!i.state_id && firstData?.state_id) {
                      i.state_id = firstData.state_id;
                  }

                  if (!i.birth_date && firstData?.birth_date) {
                      i.birth_date = firstData.birth_date;
                  }

                  if (!i.gender && firstData?.gender) {
                      i.gender = firstData.gender;
                  }

                  if (!i.title && firstData?.title) {
                      i.title = firstData.title;
                  }
        }

        if(this.productTransferInItinerary(index)) {
          i.phone = this.formPaxesReservationData.paxList[0].phone;
          i.phone_code = this.formPaxesReservationData.paxList[0].phone_code;
        }

        // ===== ASIGNACIÓN CON OPERADOR DE COALESCENCIA NULA =====
        i.country_id = country?.country_code ?? this.formPaxesReservationData.paxList[0].country_id;
        i.state_id = state?.destination_id ?? this.formPaxesReservationData.paxList[0].state_id;
        i.city = city?.city_id ?? this.formPaxesReservationData.paxList[0].city;
        i.type = this.paxes[index]?.type ?? null;
        i.clientId = clientIdArr[index] ?? null;
        i.paxListIndex = index;
        i.paxOptional = i.paxOptional;
        i.age = this.paxes[index]?.type === 'adult' ? parseInt(this.getAdultAge(i.birth_date), 10) : parseInt(this.getAge(i.birth_date, index).split(' ')[0], 10);
        paxesData.push(i);
            } else {

               if(i.first_name === null && i.last_name === null && i.title === null) {
                  paxesData.push(i);
                } else {

                          let country = null;
        if (this.filteredCountries && this.filteredCountries.length > 0) {
            country = this.filteredCountries.find(c => c.country_name === i.country_id);
        }

        // ===== VALIDACIÓN MEJORADA PARA STATE =====
        let state = null;
        if (this.formPaxesReservationData?.states &&
            this.formPaxesReservationData.states.length > 0) {

            // Buscar en el índice correspondiente
            const stateData = this.formPaxesReservationData.states[index];

            if (stateData?.states && stateData.states.length > 0) {
                state = stateData.states.find(c => c.destination_name === i.state_id);
            }

            // Si no se encuentra en el índice específico, buscar en el primero
            if (!state && this.formPaxesReservationData.states[0]?.states) {
                state = this.formPaxesReservationData.states[0].states.find(c => c.destination_name === i.state_id);
            }
        }

        // ===== VALIDACIÓN MEJORADA PARA CITY =====
        let city = null;
        if (this.formPaxesReservationData?.cities &&
            this.formPaxesReservationData.cities.length > 0) {

            // Buscar en el índice correspondiente
            const cityData = this.formPaxesReservationData.cities[index];

            if (cityData?.cities && cityData.cities.length > 0) {
                city = cityData.cities.find(c => c.city_name === i.city);
            }

            // Si no se encuentra en el índice específico, buscar en el primero
            if (!city && this.formPaxesReservationData.cities[0]?.cities) {
                city = this.formPaxesReservationData.cities[0].cities.find(c => c.city_name === i.city);
            }
        }

        // ===== VALIDACIÓN PARA CLIENTES ASOCIADOS =====
        // if (index > 0) {

        if(i.clientId) {
          clientIdArr.push(i.clientId);
        } else {
          //  if (this.formPaxesReservationData?.clientsAssociated &&
          //       this.formPaxesReservationData.clientsAssociated.length > 0) {

          //       const client = this.formPaxesReservationData.clientsAssociated.find(
          //           c => c.document_number == i.document_number
          //       );
          //       clientIdArr.push(client?.id || null);
          //   } else {
                clientIdArr.push(null);
            // }
        }

        // }

        if((index === 1 && i.type !== 'adult') || index > 1) {
          i.document_type_id = i?.document_type_id ?? this.formPaxesReservationData.paxList[0].document_type_id;
          i.document_number = i?.document_number ?? this.formPaxesReservationData.paxList[0].document_number;
        }

        // ===== AUTO SAVE VALIDATIONS =====
        if (autoSave) {
            if (i.phone < 0) {
                i.phone = null;
            }
            if (i.phone_2 < 0) {
                i.phone_2 = null;
            }
            if (i.document_number < 0) {
                i.document_number = null;
            }
            if (i.first_name && !/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/.test(i.first_name)) {
                i.first_name = null;
            }
            if (i.last_name && !/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/.test(i.last_name)) {
                i.last_name = null;
            }
            if (i.email && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(i.email)) {
                i.email = null;
            }
        } else {


                  const isValidPhone = (phone: any) => {
                      if (!phone) return false;
                      const cleanPhone = phone.toString().replace(/^\+/, '').replace(/\D/g, '');
                      return /^\d{6,}$/.test(cleanPhone);
                  };

                  // Validación de nombre
                  const isValidName = (name: any) => {
                      return name && /^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/.test(name);
                  };

                  // Validación de email
                  const isValidEmail = (email: any) => {
                      return email && /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
                  };

                  // Validación de documento
                  const isValidDocument = (doc: any) => {
                      const documentTypeId = i.document_type_id;

                      if(!documentTypeId) {
                          return false;
                      }

                      // Convertir doc a string para validar
                      const docString = doc ? doc.toString() : '';

                      if(documentTypeId === 4 || documentTypeId === '4') {
                          // Solo números
                          return docString !== '' && /^[0-9]+$/.test(docString);
                      }

                      if(documentTypeId === 5 || documentTypeId === '5') {

                          // Alfanuméricos (letras y números)
                          return docString !== '' && /^[a-zA-Z0-9\-\s\.]+$/.test(docString);
                      }

                      // Para otros tipos de documento o si no coincide con 4 o 5
                      return false;
                  };

                  // Aplicar validaciones con fallback a firstData
                  if (!isValidPhone(i.phone) && firstData?.phone) {
                      i.phone = firstData.phone;
                  }

                  if (!isValidPhone(i.phone_2) && firstData?.phone_2) {
                      i.phone_2 = firstData.phone_2;
                  }

                  if (!isValidDocument(i.document_number) && firstData?.document_number) {
                      i.document_number = firstData.document_number;
                  }

                  if (!isValidName(i.first_name) && firstData?.first_name) {
                      i.first_name = firstData.first_name;
                  }

                  if (!isValidName(i.last_name) && firstData?.last_name) {
                      i.last_name = firstData.last_name;
                  }

                  if (!isValidEmail(i.email) && firstData?.email) {
                      i.email = firstData.email;
                  }

                  // También para otros campos que puedan necesitar validación
                  if (!i.address && firstData?.address) {
                      i.address = firstData.address;
                  }

                  if (!i.city && firstData?.city) {
                      i.city = firstData.city;
                  }

                  if (!i.country_id && firstData?.country_id) {
                      i.country_id = firstData.country_id;
                  }

                  if (!i.state_id && firstData?.state_id) {
                      i.state_id = firstData.state_id;
                  }

                  if (!i.birth_date && firstData?.birth_date) {
                      i.birth_date = firstData.birth_date;
                  }

                  if (!i.gender && firstData?.gender) {
                      i.gender = firstData.gender;
                  }

                  if (!i.title && firstData?.title) {
                      i.title = firstData.title;
                  }
        }

        if(this.productTransferInItinerary(index)) {
          i.phone = this.formPaxesReservationData.paxList[0].phone;
          i.phone_code = this.formPaxesReservationData.paxList[0].phone_code;
        }

        // ===== ASIGNACIÓN CON OPERADOR DE COALESCENCIA NULA =====
        i.country_id = country?.country_code ?? this.formPaxesReservationData.paxList[0].country_id;
        i.state_id = state?.destination_id ?? this.formPaxesReservationData.paxList[0].state_id;
        i.city = city?.city_id ?? this.formPaxesReservationData.paxList[0].city;
        i.type = this.paxes[index]?.type ?? null;
        i.clientId = clientIdArr[index] ?? null;
        i.paxListIndex = index;
        i.paxOptional = i.paxOptional;
        i.age = this.paxes[index]?.type === 'adult' ? parseInt(this.getAdultAge(i.birth_date), 10) : parseInt(this.getAge(i.birth_date, index).split(' ')[0], 10);
        paxesData.push(i);

                }

            }
        } else {
            // ===== VALIDACIÓN MEJORADA PARA COUNTRY =====
        let country = null;
        if (this.filteredCountries && this.filteredCountries.length > 0) {
            country = this.filteredCountries.find(c => c.country_name === i.country_id);
        }

        // ===== VALIDACIÓN MEJORADA PARA STATE =====
        let state = null;
        if (this.formPaxesReservationData?.states &&
            this.formPaxesReservationData.states.length > 0) {

            // Buscar en el índice correspondiente
            const stateData = this.formPaxesReservationData.states[index];

            if (stateData?.states && stateData.states.length > 0) {
                state = stateData.states.find(c => c.destination_name === i.state_id);
            }

            // Si no se encuentra en el índice específico, buscar en el primero
            if (!state && this.formPaxesReservationData.states[0]?.states) {
                state = this.formPaxesReservationData.states[0].states.find(c => c.destination_name === i.state_id);
            }
        }

        // ===== VALIDACIÓN MEJORADA PARA CITY =====
        let city = null;
        if (this.formPaxesReservationData?.cities &&
            this.formPaxesReservationData.cities.length > 0) {

            // Buscar en el índice correspondiente
            const cityData = this.formPaxesReservationData.cities[index];

            if (cityData?.cities && cityData.cities.length > 0) {
                city = cityData.cities.find(c => c.city_name === i.city);
            }

            // Si no se encuentra en el índice específico, buscar en el primero
            if (!city && this.formPaxesReservationData.cities[0]?.cities) {
                city = this.formPaxesReservationData.cities[0].cities.find(c => c.city_name === i.city);
            }
        }

        // ===== VALIDACIÓN PARA CLIENTES ASOCIADOS =====
        // if (index > 0) {

        if(i.clientId) {
          clientIdArr.push(i.clientId);
        } else {
          //  if (this.formPaxesReservationData?.clientsAssociated &&
          //       this.formPaxesReservationData.clientsAssociated.length > 0) {

          //       const client = this.formPaxesReservationData.clientsAssociated.find(
          //           c => c.document_number == i.document_number
          //       );
          //       clientIdArr.push(client?.id || null);
          //   } else {
                clientIdArr.push(null);
            // }
        }

        // }

        if((index === 1 && i.type !== 'adult') || index > 1) {
          i.document_type_id = i?.document_type_id ?? this.formPaxesReservationData.paxList[0].document_type_id;
          i.document_number = i?.document_number ?? this.formPaxesReservationData.paxList[0].document_number;
        }

        // ===== AUTO SAVE VALIDATIONS =====
        if (autoSave) {
            if (i.phone < 0) {
                i.phone = null;
            }
            if (i.phone_2 < 0) {
                i.phone_2 = null;
            }
            if (i.document_number < 0) {
                i.document_number = null;
            }
            if (i.first_name && !/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/.test(i.first_name)) {
                i.first_name = null;
            }
            if (i.last_name && !/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/.test(i.last_name)) {
                i.last_name = null;
            }
            if (i.email && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(i.email)) {
                i.email = null;
            }
        } else {


                  const isValidPhone = (phone: any) => {
                      if (!phone) return false;
                      const cleanPhone = phone.toString().replace(/^\+/, '').replace(/\D/g, '');
                      return /^\d{6,}$/.test(cleanPhone);
                  };

                  // Validación de nombre
                  const isValidName = (name: any) => {
                      return name && /^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/.test(name);
                  };

                  // Validación de email
                  const isValidEmail = (email: any) => {
                      return email && /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
                  };

                  // Validación de documento
                  const isValidDocument = (doc: any) => {
                      const documentTypeId = i.document_type_id;

                      if(!documentTypeId) {
                          return false;
                      }

                      // Convertir doc a string para validar
                      const docString = doc ? doc.toString() : '';

                      if(documentTypeId === 4 || documentTypeId === '4') {
                          // Solo números
                          return docString !== '' && /^[0-9]+$/.test(docString);
                      }

                      if(documentTypeId === 5 || documentTypeId === '5') {

                          // Alfanuméricos (letras y números)
                          return docString !== '' && /^[a-zA-Z0-9\-\s\.]+$/.test(docString);
                      }

                      // Para otros tipos de documento o si no coincide con 4 o 5
                      return false;
                  };

                  // Aplicar validaciones con fallback a firstData
                  if (!isValidPhone(i.phone) && firstData?.phone) {
                      i.phone = firstData.phone;
                  }

                  if (!isValidPhone(i.phone_2) && firstData?.phone_2) {
                      i.phone_2 = firstData.phone_2;
                  }

                  if (!isValidDocument(i.document_number) && firstData?.document_number) {
                      i.document_number = firstData.document_number;
                  }

                  if (!isValidName(i.first_name) && firstData?.first_name) {
                      i.first_name = firstData.first_name;
                  }

                  if (!isValidName(i.last_name) && firstData?.last_name) {
                      i.last_name = firstData.last_name;
                  }

                  if (!isValidEmail(i.email) && firstData?.email) {
                      i.email = firstData.email;
                  }

                  // También para otros campos que puedan necesitar validación
                  if (!i.address && firstData?.address) {
                      i.address = firstData.address;
                  }

                  if (!i.city && firstData?.city) {
                      i.city = firstData.city;
                  }

                  if (!i.country_id && firstData?.country_id) {
                      i.country_id = firstData.country_id;
                  }

                  if (!i.state_id && firstData?.state_id) {
                      i.state_id = firstData.state_id;
                  }

                  if (!i.birth_date && firstData?.birth_date) {
                      i.birth_date = firstData.birth_date;
                  }

                  if (!i.gender && firstData?.gender) {
                      i.gender = firstData.gender;
                  }

                  if (!i.title && firstData?.title) {
                      i.title = firstData.title;
                  }
        }

        if(this.productTransferInItinerary(index)) {
          i.phone = this.formPaxesReservationData.paxList[0].phone;
          i.phone_code = this.formPaxesReservationData.paxList[0].phone_code;
        }

        // ===== ASIGNACIÓN CON OPERADOR DE COALESCENCIA NULA =====
        i.country_id = country?.country_code ?? this.formPaxesReservationData.paxList[0].country_id;
        i.state_id = state?.destination_id ?? this.formPaxesReservationData.paxList[0].state_id;
        i.city = city?.city_id ?? this.formPaxesReservationData.paxList[0].city;
        i.type = this.paxes[index]?.type ?? null;
        i.clientId = clientIdArr[index] ?? null;
        i.paxListIndex = index;
        i.paxOptional = i.paxOptional;
        i.age = this.paxes[index]?.type === 'adult' ? parseInt(this.getAdultAge(i.birth_date), 10) : parseInt(this.getAge(i.birth_date, index).split(' ')[0], 10);
        paxesData.push(i);
        }




    }

    return paxesData;
}

/**
 * Calcula la edad de un adulto usando la fecha actual
 * @param date - Fecha de nacimiento
 * @returns String con formato "X años"
 */
getAdultAge(date: any): string {
  if (!date) return 'Seleccionar fecha';

  const birthDate = moment(date);
  if (!birthDate.isValid()) {
    console.warn('Fecha inválida:', date);
    return 'Fecha inválida';
  }

  const age = moment().diff(birthDate, 'years');
  return `${age} ${age === 1 ? 'año' : 'años'}`;
}

async formatPaxesData(paxesData: any[]) {
  return paxesData.map((pax) => {
    const { relation_ship, ...rest } = pax;

    // CORREGIDO: DD-MM-YYYY primero
    const birthDateFormatted = moment(pax.birth_date, ['DD-MM-YYYY', 'YYYY-MM-DD', 'YYYY-DD-MM']).format('YYYY-MM-DD');


    return {
      ...rest,
      birth_date: birthDateFormatted,
      relation_ship_catalogue_id: relation_ship,
    };
  });
}

formatPaxesDataAutoSave(formattedPaxesData: any): any {
  let formatPaxesDataAuto: any;

  formatPaxesDataAuto = formattedPaxesData.map((paxes: any) => {
    paxes.first_name = cleanString(paxes.first_name)
    paxes.last_name = cleanString(paxes.last_name)
    paxes.address = cleanString(paxes.address)
    // paxes.idUnique = null;

    // Función auxiliar para convertir string a Date
    const parseDateString = (dateStr: string): Date | null => {
      if (!dateStr || typeof dateStr !== 'string') return null;

      let dateObj: Date | null = null;

      if (dateStr.includes('-')) {
        const parts = dateStr.split('-');
        if (parts.length === 3) {
          const yearPart = parts[2];
          const monthPart = parts[1];
          const dayPart = parts[0];

          const day = parseInt(dayPart, 10);
          const month = parseInt(monthPart, 10);
          const year = parseInt(yearPart, 10);

          if (yearPart.length === 4 && !isNaN(year) && !isNaN(month) && !isNaN(day)) {
            dateObj = new Date(year, month - 1, day, 12, 0, 0);
          }
          else if (parts[0].length === 4 && !isNaN(year) && !isNaN(month) && !isNaN(day)) {
            dateObj = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10), 12, 0, 0);
          }
        }
      }

      if (!dateObj) {
        dateObj = new Date(dateStr);
        if (isNaN(dateObj.getTime())) return null;
      }

      return dateObj;
    };

    const compareDatesOnly = (date1: Date, date2: Date): boolean => {
      return date1.getFullYear() === date2.getFullYear() &&
             date1.getMonth() === date2.getMonth() &&
             date1.getDate() === date2.getDate();
    };

    // Función para formatear Date a YYYY-MM-DD sin usar toISOString
    const formatDateToYMD = (date: Date): string => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    if (paxes.type === 'adult') {
      if (!paxes.birth_date) {
        paxes.birth_date = null;
        return paxes;
      }

      let birth_date_obj: Date | null = null;

      if (paxes.birth_date instanceof Date) {
        birth_date_obj = paxes.birth_date;
      } else if (typeof paxes.birth_date === 'string') {
        birth_date_obj = parseDateString(paxes.birth_date);
      }

      if (!birth_date_obj || isNaN(birth_date_obj.getTime())) {
        paxes.birth_date = null;
        return paxes;
      }

      if (this.formPaxesReservationData.minDateAdult &&
          this.formPaxesReservationData.minDateAdult instanceof Date &&
          !isNaN(this.formPaxesReservationData.minDateAdult.getTime())) {

        if (compareDatesOnly(birth_date_obj, this.formPaxesReservationData.minDateAdult)) {
          paxes.birth_date = null;
        } else {
          // ✅ CORREGIDO: usar formato manual en lugar de toISOString
          paxes.birth_date = formatDateToYMD(birth_date_obj);
        }
      } else {
        // ✅ CORREGIDO: usar formato manual en lugar de toISOString
        paxes.birth_date = formatDateToYMD(birth_date_obj);
      }
    } else {
      // CÓDIGO PARA NIÑOS
      if (!paxes.birth_date) {
        paxes.birth_date = null;
        return paxes;
      }

      let birth_date_obj: Date | null = null;

      if (paxes.birth_date instanceof Date) {
        birth_date_obj = paxes.birth_date;
      } else if (typeof paxes.birth_date === 'string') {
        birth_date_obj = parseDateString(paxes.birth_date);
      }

      if (!birth_date_obj || isNaN(birth_date_obj.getTime())) {
        paxes.birth_date = null;
        return paxes;
      }

      if (this.formPaxesReservationData.maxDateChild &&
          this.formPaxesReservationData.maxDateChild instanceof Date &&
          !isNaN(this.formPaxesReservationData.maxDateChild.getTime())) {

        if (compareDatesOnly(birth_date_obj, this.formPaxesReservationData.maxDateChild)) {
          paxes.birth_date = null;
        } else {
          // ✅ CORREGIDO
          paxes.birth_date = formatDateToYMD(birth_date_obj);
        }
      } else {
        // ✅ CORREGIDO
        paxes.birth_date = formatDateToYMD(birth_date_obj);
      }
    }

    return paxes;
  });

  return formatPaxesDataAuto;
}
  goReservation(paxes: any, autoSave?: boolean) {
    // Reiniciar el arreglo de resultados de la reserva
    this.formPaxesReservationData.resultReserve = [];

    // Agregar un objeto de reserva inicial al arreglo resultReserve
    this.formPaxesReservationData.resultReserve.push({
      itinerary_id: this.itineraryId, // ID del itinerario
      starDate: moment(), // Fecha de inicio (momento actual)
      endDate: moment(), // Fecha de finalización (momento actual)
      status_id: 4, // ID del estado de la reserva (4 para "En proceso")
      qtyReservedProduct: 0, // Cantidad de productos reservados (inicialmente 0)
      totalNetPrice: 0, // Precio neto total de la reserva (inicialmente 0)
    });

    // Iterar sobre cada elemento del itinerario
    this.itineraryItems.forEach((item) => {
      // Generar el payload para la reserva
      let _payload = this._payload(item, paxes);
      // Realizar la reserva del elemento actual del itinerario
      this.makeReserve(_payload, item, paxes, autoSave);
    });

    return true; // Retorna verdadero como indicación de que la función se ejecutó correctamente
}



_payload(item: any, paxes: any): any {
  // Inicializar las variables necesarias para el payload
  let productId =
    item.categoryName == "INSURANCE" && item.nameAdapter == "Universal_Assistance"
      ? item.title
      : item.categoryName == "DISNEY"
      ? item.id
      : item.idProduct;
  let searchId = item.categoryName == "DISNEY" ? item.arrayResults[0]["searchId"] : item.searchId;
  let providerId = item.categoryName == "DISNEY" ? item.arrayResults[0]["providerId"] : item.providerId;
  let _id: string = item.id;

  // Ajustar el ID del producto en caso de que sea un seguro
  if (item.categoryName == "INSURANCE") {
    let idProduct = _id.split("/-/");
    _id = idProduct[0];
  }

  // Construir el payload de reserva
  const payload = [
    {
      product: {
        searchId: searchId, // ID de búsqueda del producto
        id: _id, // ID del producto
        providerId: providerId, // ID del proveedor
        providerName: item.providerName, // Nombre del proveedor
        title: item.title, // Título del producto
        description: item.description, // Descripción del producto
        categoryId: item.category_id, // ID de la categoría del producto
        productId: productId, // ID del producto específico
        origin:
          item.categoryName != "DISNEY" ? (item.payloadUpdate.products[0].origin ? item.payloadUpdate.products[0].origin : null) : null, // Origen del producto
        destination:
          item.categoryName != "DISNEY"
            ? item.payloadUpdate.products[0].destination
              ? item.payloadUpdate.products[0].destination
              : "KOA"
            : item.destination.iata_code, // Destino del producto
        dateIni:
          item.categoryName == "DISNEY"
            ? new DatePipe("es-ES").transform(item.destination.destination_info.arrival, "yyyy-MM-dd")
            : item.arrivalDate, // Fecha de inicio del producto
        dateEnd:
          item.categoryName == "DISNEY"
            ? new DatePipe("es-ES").transform(item.destination.destination_info.departure, "yyyy-MM-dd")
            : item.departureDate, // Fecha de finalización del producto
        serviceResponse: null, // Respuesta del servicio (inicialmente nula)
        nameAdapter: item.categoryName != "DISNEY" ? item.payloadUpdate.products[0].nameAdapter : "Majestic_Disney", // Adaptador de nombre del producto
        // Información adicional dependiente de cada categoría para reservar
        additionalInfo: this.setAdditionalInfo(item, paxes), // Información adicional para la reserva
      },
      id: null, // ID de la reserva (inicialmente nulo)
      serviceResponse: null, // Respuesta del servicio (inicialmente nula)
    },
  ];
  return payload; // Retorna el payload construido
}

setAdditionalInfo(item: any, paxes: any): any {
  let additionalInfo; // Variable para almacenar la información adicional

  // Selecciona el tipo de información adicional según la categoría del ítem
  switch (item.categoryName) {
      case "HOTELS": // Caso para hoteles
          additionalInfo = {
              hotelId: item.hotelId, // ID del hotel
              roomQty: 1, // Cantidad de habitaciones
              arrival: item.arrivalDate, // Fecha de llegada
              departure: item.departureDate, // Fecha de salida
              rooms: [
                  {
                      roomCode: item.RoomCode,
                      bookParam: item.bookParam,
                      roomId: item.roomId ? item.roomId : item.hotelId,
                      optionId: item.optionId ? item.optionId : null,
                      accomodationId: item.accomodationId ? item.accomodationId : null,
                      maxPax: 1,
                      refPrice: item.refPrice,
                      paxList: {
                          pax: this.setPaxesReserve(paxes),
                      },
                  },
              ],
          };
          break;
      case "TOURS": // Caso para tours
          additionalInfo = {
              tours: [
                  {
                      company: item.company ? item.company : "Agencia de pruebas",
                      optionId: item.optionId,
                      paxAdults: item.paxAdults,
                      paxChildren: item.paxChildren,
                      bookingCode: item.bookingCode ? item.bookingCode : null,
                      paxList: this.setPaxesReserve(paxes),
                      answers: item.questions.length > 0 ? [] : [],
                      sessionCode: item.questions.length > 0 ? [] : null,
                      languageCode: item.questions.length > 0 ? [] : null,
                  },
              ],
          };
          break;
      case "TRANSPORTS": // Caso para transportes
          additionalInfo = {
              transfers: [
                  {
                      oneWay: item.payload.others.transfers.oneWay,
                      contractList: item.contractList,
                      pickupTime: item.pickupTime,
                      dropoffTime: item.dropoffTime,
                      pickupLocation: {
                          id: item.payload.others.transfers.pickupLocation.id,
                          type: item.payload.others.transfers.pickupLocation.type,
                      },
                      dropoffLocation: {
                          id: item.payload.others.transfers.dropoffLocation.id,
                          type: item.payload.others.transfers.dropoffLocation.type,
                      },
                      goingWay: {
                          transfersTypeLeg: item.vehicles[0].transfersTypeLeg ? item.vehicles[0].transfersTypeLeg : "IN",
                          transferCode: item.vehicles[0].transferCode ? item.vehicles[0].transferCode : "0|0|0",
                          transferType: item.vehicles[0].transferType ? item.vehicles[0].transferType : "P",
                          vehicleType: item.vehicles[0].transferType ? item.vehicles[0].transferType : 9,
                          travelInfo: "xyz",
                          travelCompanyName: "avior airline",
                          travelDate: item.pickupTime,
                          travelTime: item.pickupTime,
                      },
                      returnWay: {
                          transfersTypeLeg: item.vehicles[1].transfersTypeLeg ? item.vehicles[1].transfersTypeLeg : "OUT",
                          transferCode: item.vehicles[1].transferCode ? item.vehicles[1].transferCode : "1|0|0",
                          transferType: item.vehicles[1].transferType ? item.vehicles[1].transferType : "P",
                          vehicleType: item.vehicles[1].transferType ? item.vehicles[1].transferType : 9,
                          travelInfo: "abc",
                          travelCompanyName: "avianca",
                          travelDate: item.dropoffTime,
                          travelTime: item.dropoffTime,
                      },
                      paxList: this.setPaxesReserve(paxes),
                  },
              ],
          };
          break;
      case "INSURANCE": // Caso para seguros
          additionalInfo = {
              insurance: {
                  price: item.totalPrice,
                  paxList: this.setPaxesReserve(paxes, true),
              },
          };
          break;
      case "PTHEMES": // Caso para temas de parques
          additionalInfo = {
              arrival: item.arrivalDate,
              departure: item.departureDate,
              paxList: {
                  pax: this.setPaxesReserve(paxes),
              },
              optionId: item.optionId,
          };
          break;
      case "DISNEY": // Caso para Disney
          additionalInfo = {
              searchId: item.hotel["additionalInfo"]["searchId"],
              hotelId: item.hotel.id,
              roomId: item.room.roomId,
              accId: item.room.accomodationId,
              rateId: item.plan.rateId,
              ticketTypeId: item.ticket !== undefined ? item.ticket.id : 0,
              mealPlanId: item.mealPlan !== null ? item.mealPlan.id : 0,
              arrivalDate: item.destination.destination_info.arrival,
              departureDate: item.destination.destination_info.departure,
              days: item.days,
              noExpiration: false,
              paxList: this.setPaxesReserve(paxes, true),
          };
          break;
      default:
          break;
  }
  return additionalInfo
}


makeReserve(payload: any, item: any, paxes: any, autoSave?: boolean) {
  // Realiza una solicitud POST para realizar una reserva utilizando el servicio REST

  this._restService.doPost(routes.app, routes.reservation, payload).subscribe(
    (response: any) => { // Maneja la respuesta de la solicitud
      if (response !== null && response.results !== null && response.status !== false) { // Verifica si la respuesta es válida
        // Guarda los resultados de la reserva en la variable resultReserve
        this.formPaxesReservationData.resultReserve.push({
          status_id: response[0].status === true ? 1 : 0, // Estado de la reserva (1: éxitosa, 0: fallida)
          resultReserve: response[0].status === true ? response[0].result : response[0].message, // Resultado de la reserva
          category_id: item.category_id, // ID de la categoría del elemento del itinerario
          providerId: item.categoryName === "DISNEY" ? item.arrayResults[0]["providerId"] : item.providerId, // ID del proveedor
          netPrice: response[0].status === true ? item.totalPrice : 0, // Precio neto de la reserva (si la reserva fue exitosa)
          paxList: this.setPaxesReserve(paxes), // Lista de pasajeros asociados a la reserva
          uid: item.id, // ID único del elemento del itinerario
        });
        if (this.formPaxesReservationData.resultReserve.length - 1 >= this.itineraryItems.length) {
          // Guarda la reserva en la API si se han procesado todas las reservas
          this.saveReservation(this.formPaxesReservationData.resultReserve, autoSave);
        }
      } else { // Si la respuesta no es válida
        // Agrega la información de la reserva fallida a resultReserve
        this.formPaxesReservationData.resultReserve.push({
          status_id: 0, // Estado de la reserva fallida
          resultReserve: response.message, // Mensaje de error de la reserva
          category_id: item.category_id, // ID de la categoría del elemento del itinerario
          netPrice: 0, // Precio neto de la reserva (0 en caso de falla)
          providerId: item.categoryName === "DISNEY" ? item.arrayResults[0]["providerId"] : item.providerId, // ID del proveedor
          paxList: this.setPaxesReserve(paxes), // Lista de pasajeros asociados a la reserva
          uid: item.id, // ID único del elemento del itinerario
        });

        if (this.formPaxesReservationData.resultReserve.length - 1 >= this.itineraryItems.length) {
          // Guarda la reserva en la API si se han procesado todas las reservas
          this.saveReservation(this.formPaxesReservationData.resultReserve, autoSave);
        }
      }

    },
    (error) => { // Maneja los errores de la solicitud
      // Agrega la información de la reserva fallida a resultReserve
      this.formPaxesReservationData.resultReserve.push({
        status_id: 0, // Estado de la reserva fallida
        resultReserve: error, // Mensaje de error de la reserva
        category_id: item.category_id, // ID de la categoría del elemento del itinerario
        netPrice: 0, // Precio neto de la reserva (0 en caso de falla)
        paxList: this.setPaxesReserve(paxes), // Lista de pasajeros asociados a la reserva
        uid: item.id, // ID único del elemento del itinerario
      });

      if (this.formPaxesReservationData.resultReserve.length - 1 >= this.itineraryItems.length) {
        // Guarda la reserva en la API si se han procesado todas las reservas
        this.saveReservation(this.formPaxesReservationData.resultReserve, autoSave);
      }
      // console.log(error); // Imprime el error en la consola
    }
  );
}

/**
 * Genera un arreglo de objetos que representan a los pasajeros para una reserva, con la información proporcionada.
 * @param pax Arreglo que contiene la información de los pasajeros.
 * @param insurance Indica si la reserva es para un seguro.
 * @returns Un arreglo de objetos que representan a los pasajeros para la reserva.
 */
setPaxesReserve(pax: any, insurance: boolean = false): any {
  let paxes = []; // Arreglo para almacenar la información de los pasajeros
  let i = 0; // Variable para llevar el conteo de pasajeros
  pax.forEach((pax) => { // Itera sobre cada pasajero
      let Age = moment().diff(pax.birth_date, "years"); // Calcula la edad del pasajero
      if (insurance == true) { // Si la reserva es para un seguro
          // Agrega la información del pasajero al arreglo de pasajeros
          paxes.push({
              gender: pax.gender, // Género del pasajero
              first_name: pax.first_name, // Nombre del pasajero
              last_name: pax.last_name, // Apellido del pasajero
              identificationType: pax.document_type_id, // Tipo de documento de identificación del pasajero
              identification: pax.document_number, // Número de documento de identificación del pasajero
              birthDate: moment(pax.birth_date, ['YYYY-DD-MM', 'DD-MM-YYYY', 'YYYY-MM-DD', 'MM-DD-YYYY']).format('dd-MM-yyyy'), // Fecha de nacimiento del pasajero
              age: Age, // Edad del pasajero
              email: "agency@demo.com", // Correo electrónico del pasajero (predeterminado)
              phone: "7236229081", // Número de teléfono del pasajero (predeterminado)
              address: "Agencia de prueba AR", // Dirección del pasajero (predeterminado)
              country_id: "AR", // ID del país del pasajero (predeterminado)
              city: "BUENOS AIRES", // Ciudad del pasajero (predeterminado)
              state_id: "MENDOZA", // ID del estado/provincia del pasajero (predeterminado)
              holder: i == 0 ? "holder" : "", // Indica si el pasajero es el titular de la reserva
          });
      } else { // Si la reserva no es para un seguro
          // Agrega la información del pasajero al arreglo de pasajeros
          paxes.push({
              title: pax.title, // Título del pasajero
              first_name: pax.first_name, // Nombre del pasajero
              last_name: pax.last_name, // Apellido del pasajero
              birthDate: moment(pax.birth_date, ['YYYY-DD-MM', 'DD-MM-YYYY', 'YYYY-MM-DD', 'MM-DD-YYYY']).format('dd-MM-yyyy'), // Fecha de nacimiento del pasajero
              age: Age, // Edad del pasajero
              email: pax.email, // Correo electrónico del pasajero
              phone: pax.phone, // Número de teléfono del pasajero
              phone_2: pax.phone_2, // Segundo número de teléfono del pasajero
              address: pax.address, // Dirección del pasajero
              country_id: pax.county, // ID del país del pasajero
              city: pax.city, // Ciudad del pasajero
              state_id: pax.state_id, // ID del estado/provincia del pasajero
              holder: i == 0 ? "holder" : "", // Indica si el pasajero es el titular de la reserva
          });
      }
      i = i + 1; // Incrementa el contador de pasajeros
  });
  return paxes; // Retorna el arreglo de pasajeros
}



saveReservation(reserve: any, autoSave?: boolean) {
  // Agrega el ID del itinerario al objeto de reserva
  reserve["itinerario_id"] = this.itineraryId;

  // Realiza una solicitud POST para guardar la reserva en la API
  this._restService.doPost("app", "reservations", reserve).subscribe(
    (response: any) => { // Maneja la respuesta de la solicitud
      if (response.success == true) { // Verifica si la reserva se guardó correctamente
        // Redirecciona a la confirmación de la reserva
        if(autoSave === false) {
          this.confirmationRedirect(response.data.reservation_id);
        }
      }
    },
    (error) => { // Maneja los errores de la solicitud
      // console.log("error en API: ", error); // Imprime el error en la consola
    }
  );
}

 /**
 * Redirige a la página de confirmación de reserva, pasando parámetros adicionales en la URL.
 * @param reservationId El ID de la reserva que se pasa como parámetro en la URL.
 */
confirmationRedirect(reservationId: number) {
  let navigationExtras: NavigationExtras = {
      queryParams: {
          id: this.itineraryId, // ID del itinerario que se pasa como parámetro en la URL
          stat: "true", // Estado de la reserva que se pasa como parámetro en la URL
          screen: "reservation", // Pantalla de reserva que se pasa como parámetro en la URL
          reservationId: reservationId, // ID de la reserva que se pasa como parámetro en la URL
      },
  };
  // Redirige a la página de confirmación de reserva con los parámetros adicionales en la URL
  this.router.navigate([routes.reservation_confirmation], navigationExtras);
}




  /**
   * Metodo donde se obtiene el valor maximo de paxAdults y paxChi
   */
  checkAmountPaxes() {
    let adultsArr = [];
    let childrenArr = [];

    for (let i = 0; i < this.itineraryItems.length; i++) {
      let paxAdults = this.itineraryItems[i].paxAdults;
      let paxChildren = this.itineraryItems[i].paxChildren;
      // // console.log('paxadults -->', paxAdults);
      // // console.log('paxChildren -->', paxFChildren);

      adultsArr.push(paxAdults);
      childrenArr.push(paxChildren);
    }

    // // console.log('adultsArr ->', adultsArr);
    // // console.log('childrenArr ->', childrenArr);

    let adultsValueMax = Math.max(...adultsArr);
    // // console.log('value max adults -->', adultsValueMax);
    let childrenValueMax = Math.max(...childrenArr);
    // // console.log('value max adults -->', childrenValueMax);

    this.itineraryItems.forEach((element: any) => {
      // // console.log('elemento del forEach -->', element);
      if (element.paxAdults == adultsValueMax && element.paxChildren == childrenValueMax) {
        let holder = "";
      }
    });
    this.formPaxesReservationData.adultsPax = adultsArr;
  }

//** -------------=== Formulario de cliente ===------------ */


/**
 * Configura los datos del cliente cuando se crea un nuevo cliente.
 *
 * @param clientData - Objeto que contiene información sobre el cliente.
 *
 * Este método se utiliza para configurar los datos iniciales de un cliente cuando se está creando
 * un nuevo registro. Configura el tipo de cliente como "adulto", inicializa el formulario del cliente,
 * obtiene la lista de países y establece varias propiedades en `clientData` relacionadas con la acción
 * y el estado del cliente asociado.
 */
private setDataClientNew(clientData: any): void {
  this.clientData.type = "adult";
  this.setFormClient();
  this.clientData.typeAction = clientData.typeAction;
  this.clientData.clientAssociated = true;
  this.data.fromAssociates = clientData.fromAssociates;
}


/**
 * Configura los datos del cliente cuando se crea un nuevo cliente asociado.
 *
 * @param clientData - Objeto que contiene información sobre el cliente.
 *
 * Este método se utiliza para configurar los datos iniciales de un cliente cuando se está creando
 * un nuevo registro asociado. Configura el tipo de cliente como "adulto", inicializa el formulario
 * del cliente, obtiene la lista de países y establece varias propiedades en `clientData` relacionadas
 * con la acción, el estado del cliente principal y los clientes asociados.
 */
private setDataClientNewAssociated(clientData: any): void {
  this.clientData.type = "adult";
  this.clientData.clientAssociated = false;
  this.clientData.typeAction = clientData.typeAction;
  this.data.fromAssociates = clientData.fromAssociates;
  this.clientData.mainClient = clientData.mainClient;
  this.clientData.clients = clientData.clients;
  this.clientData.clientAssociatedArr = clientData.clientAssociatedArr;
  this.setFormClient();
  this.associatedSelectFilter();
}


/**
 * Configura los datos del cliente cuando se edita un cliente existente.
 *
 * @param clientData - Objeto que contiene información sobre el cliente.
 *
 * Este método se utiliza para configurar los datos de un cliente cuando se está editando
 * un registro existente. Inicializa el formulario del cliente, establece varias propiedades
 * en `clientData` relacionadas con la acción, el estado del cliente principal, los clientes
 * asociados y su información. También determina si el cliente es un "adulto" o un "niño" basado
 * en su fecha de nacimiento y configura el formulario en consecuencia.
 */
private setDataClientEdit(clientData: any): void {
  this.clientData.type = "adult";
  this.clientData.styleFormDisable = false;
  this.data.fromAssociates = clientData.fromAssociates;
  this.clientData.typeAction = clientData.typeAction;
  this.clientData.mainClient = clientData.mainClient;
  this.clientData.index = clientData.index;
  if (this.data.fromAssociates === true) {

      this.clientData.client = clientData.client;
      this.clientData.clientAssociated = false;
      this.clientData.assosiateClient = clientData.assosiateClient;
      // this.clientData.countriesData = clientData.countriesData.Countrys;
      this.setFormClient();
      this.setEditAssosiateForm();
  } else {
      this.clientData.clientAssociated = true;
      this.setFormClient();
      this.setEditForm();
  }

}


numberValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (value == null || value === '') {
    return null; // No se realiza la validación si el valor es nulo o una cadena vacía
  }
  return isNaN(value) ? { notANumber: true } : null;
}


/**
 * Configura el formulario del cliente.
 *
 * Este método se utiliza para inicializar y configurar el formulario del cliente,
 * creando un FormArray de pasajeros (paxes) y añadiendo los controles necesarios
 * para capturar la información del cliente. También configura ciertos controles
 * basados en las propiedades de `clientData`.
 */
private setFormClient(): void {

  // Añade el tipo de cliente al array de pasajeros
  this.paxes.push({type: this.clientData.type});

  // Inicializa el formulario principal con un FormArray vacío llamado 'paxes'
  this._form = this.fb.group({
      paxes: this.fb.array([]), // FormArray para los datos de los pasajeros
  });

  // Obtiene el FormArray 'paxes'
  let guest = this._form.get("paxes") as FormArray;

  // Añade un nuevo FormGroup al FormArray 'paxes' con los controles necesarios
  guest.push(this.fb.group({
      // ✅ Cambiar null por '' en TODOS los controles
      // Excepto en los <select> (gender, title, document_type_id): necesitan null para que
      // Angular seleccione la opción placeholder value="null". Con '' no queda ninguna opción
      // seleccionada y, al cargar las opciones async, el navegador muestra la primera (DNI)
      // sin actualizar el control, que sigue vacío e inválido.
      gender: new FormControl(null, Validators.required),
      title: new FormControl(null, Validators.required),
      first_name: new FormControl('', [Validators.required, Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]),
      last_name: new FormControl('', [Validators.required, Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]),
      birth_date: new FormControl('', Validators.required),
      country_id: new FormControl('', [Validators.required, this.selectedTypeHeadValidForm(0, 'country')]),
      document_type_id: new FormControl(null, Validators.required),
      document_number: new FormControl('', [Validators.required, this.nonNegativeValidator(), this.documentMinLengthValidator()]),
      email: new FormControl('', [Validators.required, Validators.email, this.validateEmail.bind(this)]),
      phone: new FormControl('', [Validators.required, Validators.pattern(/^\d{6,}$/)]),
      phone_code: new FormControl('', [Validators.required, this.selectedTypeHeadValidForm(0, 'phone_code')]),
      phone_code_selected: new FormControl(''),
      phone_2: new FormControl('', Validators.pattern(/^\d{6,}$/)),
      phone_2_code: new FormControl('', this.selectedTypeHeadValidForm(0, 'phone_code_2')),
      phone_2_code_selected: new FormControl(''),
      city: new FormControl(''),
      state_id: new FormControl(''),
      address: new FormControl('', Validators.minLength(5)),
      postal_code: new FormControl('', Validators.minLength(4)),
      relation_ship: new FormControl(''),
      selectClientExist: new FormControl(''),
      type: new FormControl(this.clientData.type)
    }));

  // Accede al primer FormGroup dentro del FormArray 'paxes'
  const paxGroup = guest.at(0) as FormGroup;

  // Deshabilita el control 'selectClientExist'
  paxGroup.get('selectClientExist').disable();

  // Deshabilita el control 'relation_ship' si el cliente no es asociado
  if (this.data.fromAssociates === false) {
      paxGroup.get('relation_ship').setErrors(null);
      paxGroup.get('relation_ship').disable();
  }

  // Configura la fecha mínima para adultos si el cliente es asociado y la acción es 'New'
  if (this.data.fromAssociates === true && (this.data.typeAction === 'New' || this.data.typeAction === 'Edit')) {
      this.formPaxesReservationData.minDateAdult = new Date();
  }

  if(this.data.mainClient && this.data.typeAction === 'New' && this.data.fromAssociates) {
    paxGroup.get('email')?.setValue(this.data.mainClient.email);
    this.phone_code[0] = this.data.mainClient.phone_code;
    paxGroup.get('phone_code')?.setValue(this.data.mainClient.phone_code);
    this.changePhoneCode(0, this.phone_code[0] , 'phone_code');
    paxGroup.get('phone')?.setValue(this.data.mainClient.phone);
    paxGroup.get('relation_ship')?.setValue(7);
  }

}



/**
 * Configura el formulario para la edición de un cliente existente.
 *
 * Este método se utiliza para rellenar los campos del formulario con los datos de
 * un cliente existente cuando se está en modo de edición. Accede al FormArray 'paxes'
 * y actualiza los valores del primer FormGroup con la información del cliente principal.
 */
private setEditForm(): void {
  // console.log('document id mainclient ->', this.clientData.mainClient);


  if (this.clientData.mainClient) {
      // Encuentra el país correspondiente al código telefónico secundario
      if(this.formPaxesReservationData.countries){
        const countryOfPhoneCode_2 = this.formPaxesReservationData.countries.find(c => c.phonecode === this.clientData.mainClient.phone_2_code);
      }

      // Formatea la fecha de nacimiento del cliente principal
      const birth_date = new DatePipe("es-ES").transform(this.clientData.mainClient.birth_date, "dd-MM-yyyy");

      // Accede al FormArray llamado 'paxes'
      const paxesArray = this._form.get('paxes') as FormArray;

      // Asegúrate de que el FormArray no está vacío
      if (paxesArray.length > 0) {
          // Accede al primer FormGroup dentro del FormArray
          const paxGroup = paxesArray.at(0) as FormGroup;
          this.selectedIsCountry[0] = this.clientData.mainClient.country_id;
          this.selectedIsState[0] = this.clientData.mainClient.state_id;
          this.selectedIsCity[0] = this.clientData.mainClient.city;
          this.phone_code[0] = this.clientData.mainClient.phone_code;
          this.phone_2_code[0] = this.clientData.mainClient.phone_2_code;
          // // console.log(countryCode.displayValue)
          // Rellena los valores del FormGroup con los datos del cliente principal
          paxGroup.patchValue({
              gender: this.clientData.mainClient.gender,
              title: this.clientData.mainClient.title,
              first_name: this.clientData.mainClient.first_name,
              last_name: this.clientData.mainClient.last_name,
              birth_date: birth_date,
              country_id: this.clientData.mainClient.country_id,
              document_type_id: this.clientData.mainClient.document_type_id,
              document_number: this.clientData.mainClient.document_number,
              email: this.clientData.mainClient.email,
              phone: this.clientData.mainClient.phone,
              phone_code: this.clientData.mainClient.phone_code,
              phone_code_selected: this.clientData.mainClient.phone_code,
              phone_2: this.clientData.mainClient.phone_2,
              phone_2_code: this.clientData.mainClient.phone_2_code,
              city: Number(this.clientData.mainClient.city),
              state_id: Number(this.clientData.mainClient.state_id),
              address: this.clientData.mainClient.address,
              postal_code: this.clientData.mainClient.postal_code,
              type: '',
          });
          // Obtiene la lista de países y establece el país del cliente principal


            if (this.clientData.mainClient.document_number) {
              this.clientData.styleFormDisable = false;
            }
      }

  }

  this.loadedClientInfoForm = true;
  this.ngxSpinner.hide();
}


/**
 * Filtra las listas de clientes asociados para excluir el cliente principal y otros
 * clientes ya asociados.
 *
 * Esta función se asegura de que los clientes asociados y las listas de clientes no contengan
 * duplicados o el cliente principal.
 */
private associatedSelectFilter(): void {
  // Si la lista de clientes no está indefinida y no está vacía
  if (this.clientData.clients !== undefined && this.clientData.clients.length > 0) {
      // Filtra los clientes para excluir el cliente principal
      this.clientData.clients = this.clientData.clients.filter(c => c.id !== this.clientData.mainClient.id);
  }

  // Si la lista de clientes asociados no está indefinida y no está vacía
  if (this.clientData.clientAssociatedArr !== undefined && this.clientData.clientAssociatedArr.length > 0) {
      // Aplana la matriz de matrices de clientes asociados
      const arrayOfObjects = [].concat(...this.clientData.clientAssociatedArr);

      // Filtra los objetos que tienen el mismo id que el cliente principal
      this.clientData.arrayAssociated = arrayOfObjects.filter(c => c.clientId === this.clientData.mainClient.id);

      // Para cada cliente asociado encontrado, filtra los clientes en la lista principal para excluir los ya asociados
      this.clientData.arrayAssociated.forEach(associatedItem => {
          associatedItem.response.forEach(associatedRes => {
              this.clientData.clients = this.clientData.clients.filter(client => client.document_number !== associatedRes.document_number);
          });
      });
  }
}


/**
 * Habilita o deshabilita el campo de selección del cliente existente basado en el estado del checkbox.
 *
 * Esta función gestiona la activación o desactivación del control 'selectClientExist' dentro del formulario
 * dependiendo del estado del checkbox proporcionado.
 *
 * @param checkbox - El checkbox HTML que controla la selección del cliente existente.
 */
public toggleSelect(checkbox: HTMLInputElement): void {
  this.clientData.styleFormDisable = false;
  // Accede al FormArray llamado 'paxes'
  const paxesArray = this._form.get('paxes') as FormArray;

  // Asegúrate de que el FormArray no está vacío
  if (paxesArray.length > 0) {
      // Accede al primer FormGroup dentro del FormArray
      const paxGroup = paxesArray.at(0) as FormGroup;

      // Obtén el control 'selectClientExist' del FormGroup
      const selectControl = paxGroup.get('selectClientExist');

      // Si el checkbox no está marcado, reinicia y desactiva el control de selección
      if (!checkbox.checked) {
          selectControl.reset();
          selectControl.disable();
          this.clientData.styleFormDisable = false;
          this.clientData.checkboxChecked = false;
      } else {
          // Si el checkbox está marcado, habilita el control de selección
          selectControl.enable();
          this.clientData.checkboxChecked = true;
      }

      // Alterna el estado de 'clientSelectedForm' para reflejar el cambio
      this.clientData.clientSelectedForm = !this.clientData.clientSelectedForm;
  }
}

/**
 * Selecciona un cliente basado en su ID y actualiza el formulario con los datos del cliente seleccionado.
 *
 * Esta función busca un cliente en la lista de clientes usando el ID proporcionado, luego rellena
 * los campos del formulario con los datos del cliente seleccionado.
 *
 * @param clientId - El ID del cliente a seleccionar.
 */
public clientSelect(clientId: any): void {
  // Convierte el ID del cliente a número entero
  const clientIdNumber = parseInt(clientId, 10);
  // Busca el cliente en la lista de clientes usando el ID
  const clientSelected = this.clientData.clients.find(client => client.id === clientIdNumber);
  this.newClientSelectedList = clientSelected;
  // Si se encuentra el cliente y el objeto no está vacío
  if (clientSelected && Object.keys(clientSelected).length > 0) {
      // Busca el código de país del teléfono principal y secundario del cliente
      const countryOfPhoneCode = this.clientData.countriesData.find(c => c.phonecode === clientSelected.phone_code);
      const countryOfPhoneCode_2 = this.clientData.countriesData.find(c => c.phonecode === clientSelected.phone_2_code);

      // Formatea la fecha de nacimiento del cliente
      const date = new Date();
      const birth_date = new DatePipe("es-ES").transform(clientSelected.birth_date, "dd-MM-yyyy");

      // Asigna el ID del cliente asociado
      this.clientData.client_associated_id = clientSelected.id;

      // Accede al FormArray llamado 'paxes'
      const paxesArray = this._form.get('paxes') as FormArray;

      // Asegúrate de que el Fo rmArray no está vacío
      if (paxesArray.length > 0) {
          // Accede al primer FormGroup dentro del FormArray
          const paxGroup = paxesArray.at(0) as FormGroup;
          this.selectedIsCountry[0] = clientSelected.country_id ? clientSelected.country_id : null;
          this.selectedIsState[0] = clientSelected.state_id ? clientSelected.state_id : null;
          this.selectedIsCity[0] = clientSelected.city ? clientSelected.city : null;
          this.phone_code[0] = clientSelected.phone_code ? clientSelected.phone_code : null;
          this.phone_2_code[0] = clientSelected.phone_2_code ? clientSelected.phone_2_code : null;
          // Reinicia los valores del FormGroup
          paxGroup.reset();

            // if (date > clientSelected.birth_date) {
            paxGroup.get('relation_ship').setValue(7);
            this.formPaxesReservationData.relationShips = this.formPaxesReservationData.relationShips.filter(c => c.id !== 1 && c.id !== 2);
            // }

          // Actualiza los valores del FormGroup con los datos del cliente seleccionado
          paxGroup.patchValue({
              gender: clientSelected.gender ? clientSelected.gender : null,
              title: clientSelected.title ? clientSelected.title : null,
              first_name: clientSelected.first_name ? clientSelected.first_name : null,
              last_name: clientSelected.last_name ? clientSelected.last_name : null,
              birth_date: birth_date ? birth_date : null,
              country_id: clientSelected.country_id ? clientSelected.country_id : null,
              document_type_id: clientSelected.document_type_id ? clientSelected.document_type_id : null,
              document_number: clientSelected.document_number ? clientSelected.document_number : null,
              email: clientSelected.email ? clientSelected.email : null,
              phone: clientSelected.phone ? clientSelected.phone : null,
              phone_code: clientSelected.phone_code ? clientSelected.phone_code : null,
              selectPhoneCode: clientSelected.phone_code ? clientSelected.phone_code : null,
              phone2: clientSelected.phone_2 ? clientSelected.phone_2 : null,
              phone_2_code: clientSelected.phone_2_code ? clientSelected.phone_2_code : null,
              selectPhoneCode_2: clientSelected.phone_2_code ? clientSelected.phone_2_code : null,
              city: clientSelected.city ? Number(clientSelected.city) : null,
              state_id: clientSelected.state_id ? Number(clientSelected.state_id) : null,
              address: clientSelected.address ? clientSelected.address : null,
              postal_code: clientSelected.postal_code ? clientSelected.postal_code : null
          });
          this.selectedClientAssociated = true;
          // Obtiene los países para actualizar la selección del país en el formulario
            this.getCountriesData(0, false, clientSelected.country_id);
            this.changeCity(0, this.selectedIsCity[0]);

            if(!clientSelected.country_id) {
              this.countryCheck[0] = false;
            }
            if(!clientSelected.state_id) {
              this.stateCheck[0] = false;
            }
            if(!clientSelected.city) {
              this.cityCheck[0] = false;
            }


          this.changePhoneCode(0, this.phone_code[0] , 'phone_code');
          this.changePhoneCode(0, this.phone_2_code[0], 'phone_2_code');
          // Marca el campo de fecha de nacimiento como tocado
          paxGroup.controls['birth_date'].markAsTouched({ onlySelf: true });


          if(clientSelected.document_number !== null && clientSelected.email !== null) {
            this.clientData.styleFormDisable = true;
          } else {
            this.clientData.styleFormDisable = false;
          }
      }

  }
}

/**
 * Configura el formulario de edición para el cliente asociado.
 *
 * Esta función establece los valores del formulario con los datos del cliente asociado,
 * incluyendo los campos relacionados con el país, el documento, el teléfono y la fecha de nacimiento.
 */
private setEditAssosiateForm(): void {

  if (this.clientData.assosiateClient) {
      // Determina el tipo de relación en función de la edad del cliente asociado
      if (this.associatedAge(this.clientData.assosiateClient.birth_date) > this.formPaxesReservationData.maxDateChild) {
          this.getRelationShipAssociated('children');
      } else {
          this.getRelationShipAssociated('adult');
      }

      // Accede al FormArray llamado 'paxes'
      const paxesArray = this._form.get('paxes') as FormArray;

      // Asegúrate de que el FormArray no está vacío
      if (paxesArray.length > 0) {
          // Accede al primer FormGroup dentro del FormArray
          const paxGroup = paxesArray.at(0) as FormGroup;


          // Busca el código de país del teléfono principal y secundario del cliente asociado
          this.selectedIsCountry[0] = this.clientData.assosiateClient.country_id;
          this.selectedIsState[0] = this.clientData.assosiateClient.state_id;
          this.selectedIsCity[0] = this.clientData.assosiateClient.city;
          this.phone_code[0] = this.clientData.assosiateClient.phone_code;
          this.phone_2_code[0] = this.clientData.assosiateClient.phone_2_code;
          // Formatea la fecha de nacimiento del cliente asociado
          const birth_date = new DatePipe("es-ES").transform(this.clientData.assosiateClient.birth_date, "dd-MM-yyyy");

          // Actualiza la lista de países para la selección de país en el formulario
          // this.getCountriesData(0, false, this.clientData.assosiateClient.country_id);

          // Actualiza los valores del FormGroup con los datos del cliente asociado
          paxGroup.patchValue({
              gender: this.clientData.assosiateClient.gender,
              title: this.clientData.assosiateClient.title,
              first_name: this.clientData.assosiateClient.first_name,
              last_name: this.clientData.assosiateClient.last_name,
              birth_date: birth_date,
              country_id: this.clientData.assosiateClient.country_id ? this.clientData?.assosiateClient?.country_id : this.clientData.assosiateClient.country,
              document_type_id: this.clientData.assosiateClient.document_type_id ? this.clientData?.assosiateClient?.document_type_id : this.clientData.assosiateClient.document,
              document_number: this.clientData.assosiateClient.document_number,
              email: this.clientData.assosiateClient.email,
              phone: this.clientData.assosiateClient.phone,
              phone_code: this.clientData.assosiateClient.phone_code,
              selectPhoneCode: Number(this.clientData.assosiateClient.phone_code),
              phone2: this.clientData.assosiateClient.phone_2,
              phone_2_code: this.clientData.assosiateClient.phone_2_code ? this.clientData?.assosiateClient?.phone_2_code : null,
              selectPhoneCode_2: this.clientData.assosiateClient.phone_2_code ? Number(this.clientData?.assosiateClient?.phone_2_code) : null,
              city: Number(this.clientData.assosiateClient.city),
              state_id: this.clientData.assosiateClient.state_id ? Number(this.clientData?.assosiateClient?.state_id) : Number(this.clientData.assosiateClient.state),
              address: this.clientData.assosiateClient.address,
              postal_code: this.clientData.assosiateClient.postal_code
          });



          // Asigna el ID de la relación
          this.clientData.relationId = this.clientData.assosiateClient.relation_ship_catalogue_id;
          this.phone_code[0] = this.clientData.assosiateClient.phone_code;
          this.changeCity(0, this.selectedIsCity[0]);
          this.changePhoneCode(0, this.phone_code[0] , 'phone_code');
          this.changePhoneCode(0, this.phone_2_code[0], 'phone_2_code');

          // Marca el campo de fecha de nacimiento como tocado
          paxGroup.controls['birth_date'].markAsTouched({ onlySelf: true });
      }
  }

  this.loadedClientInfoForm = true;
  // this.ngxSpinner.hide();
}

/**
 * Calcula la fecha de nacimiento del cliente asociado.
 *
 * @param birth_date La fecha de nacimiento en formato string.
 * @returns La fecha de nacimiento como un objeto Date.
 */
private associatedAge(birth_date: string): Date {
  return new Date(birth_date);
}


/**
 * Obtiene las relaciones asociadas basadas en la edad del cliente.
 *
 * @param age La edad del cliente o tipo ('children' o 'adult').
 */
private getRelationShipAssociated(age: any): void {
  this._itineraryService._restService.doGet('app', 'relationShips').subscribe({
    next: (res: any) => {
      this.clientData.relationShips = res;
      if (this.data.fromAssociates && this.clientData.typeAction === 'Edit') {
        if (age === 'children') {
          this.clientData.relationShips = this.clientData.relationShips.filter(c => c.id !== 1 && c.id !== 2);
        }
      }
    },
    error: (error: Error) => {
      console.error(error);
    }
  });
}

/**
 * Cambia la fecha del cliente asociado y ajusta la relación en función de la fecha.
 *
 * @param date La nueva fecha seleccionada.
 */
public changeDateClientAssociated(date: any): void {
  if (this.data.fromAssociates === true) {

      // Accede al FormArray llamado 'paxes'
      const paxesArray = this._form.get('paxes') as FormArray;

      // Asegúrate de que el FormArray no está vacío
      if (paxesArray.length > 0) {
          // Accede al primer FormGroup dentro del FormArray
          const paxGroup = paxesArray.at(0) as FormGroup;
          var currentDate = new Date();
          const dateValue = new Date(currentDate.getFullYear() - 18, currentDate.getMonth(), currentDate.getDate());

          if(paxGroup.get('relation_ship').value !== 7) {
            if (date > dateValue) {
              paxGroup.get('relation_ship').setValue(null);
              this.formPaxesReservationData.relationShips = this.formPaxesReservationData.relationShips.filter(c => c.id !== 1 && c.id !== 2);
            } else {
                paxGroup.get('relation_ship').setValue(null);
                this.getRelationShip();
            }
          }


          if (this.clientData.typeAction === 'Edit') {
              // Accede al FormArray llamado 'paxes'
              const paxesArray = this._form.get('paxes') as FormArray;

              // Asegúrate de que el FormArray no está vacío
              if (paxesArray.length > 0) {
                  // Accede al primer FormGroup dentro del FormArray
                  const paxGroup = paxesArray.at(0) as FormGroup;
                  paxGroup.get('relation_ship').setValue(null);
                  paxGroup.get('relation_ship').setValue(this.clientData.assosiateClient.relation_ship_catalogue_id);
                  // Forzar la detección de cambios
                  this.cdRef.detectChanges();
              }
          }
      }
  }
}

  _onSubmitClient(event: Event) {

    if(this._form.invalid) {
      this._form.markAllAsTouched();
      this.notificationService.warning("Por favor, complete los campos requeridos correctamente.");
      return;
    }

    // this.ngxSpinner.show();
    if (event) {
      event.preventDefault();
    }

    let selectedValue = this._form.value.paxes[0].document_number;

    const rawBirthDate = this._form.value.paxes[0].birth_date;
    const formattedBirthDate = moment(rawBirthDate, 'DD-MM-YYYY').format('YYYY-MM-DD');

    const birthDate = new DatePipe("es-ES").transform(formattedBirthDate, "yyyy-MM-dd");

    const country = this.filteredCountries.find(c => c.country_name === this.selectedIsCountry[0]);
    const state = this.stateFiltered.find(c => c.destination_name === this.selectedIsState[0]);
    const city = this.citiesFiltered.find(c => c.city_name === this.selectedIsCity[0]);
    const payload = {
      id: null,
      first_name: cleanString(this._form.value.paxes[0].first_name),
      last_name: cleanString(this._form.value.paxes[0].last_name),
      email: cleanString(this._form.value.paxes[0].email),
      phone: this._form.value.paxes[0].phone ? String(this._form.value.paxes[0].phone).trim() : null,
      phone_code: this.phone_code[0],
      country: country.country_code,
      birth_date: birthDate,
      title: this._form.value.paxes[0].title ? this._form.value.paxes[0].title.trim() : null,
      document_type_id: Number(this._form.value.paxes[0].document_type_id),
      document_number: this._form.value.paxes[0].document_number ? this._form.value.paxes[0].document_number : null,
      gender: this._form.value.paxes[0].gender,
      relation_ship_catalogue_id: this.clientData.relationId >= 0 ? Number(this.clientData.relationId) : Number(this._form.value.paxes[0].relation_ship),
      address: cleanString(this._form.value.paxes[0].address) ? this._form.value.paxes[0].address.trim() : null,
      city: city?.city_id ? String(city?.city_id) : null,
      phone2: this._form.value.paxes[0].phone_2 ? this._form.value.paxes[0].phone_2 : null,
      phone_2_code: this._form.value.paxes[0].phone_2_code ? this._form.value.paxes[0].phone_2_code : null,
      postal_code: this._form.value.paxes[0].postal_code ? this._form.value.paxes[0].postal_code : null,
      state: state?.destination_id ?? null,
      client_id: this.data.fromAssociates === true && this.data.typeAction === 'Edit' ? this.data.mainClient?.id : null,
    };

    //this.fromAssociates ? (this.mainClient.client_id ? this.mainClient.client_id : this.mainClient.id) :  this.mainClient.id,

    if (this.data.typeAction == "New" && this.data.fromAssociates === false) {
      this._restService.doPost("app", "clients", payload).subscribe({
        next: (responseNew: any) => {
          if(responseNew.men === 'Client Exists') {
            this.ngxSpinner.hide();
            this.notificationService.info("Este email y/o número de documento ya fueron registrados");
            this.data.typeAction = '';
          }
          if(responseNew.men === 'Created successfully') {
          if (responseNew.success) {
            this.ngxSpinner.hide();
            let data = {
              type: "_clientNewEmitter",
              client: responseNew.client,
            };
            this.notificationService.success("Cliente Creado Satisfactoriamente");
            this.closeModal(data);
            const client = {
              client_id: responseNew.id,
              agency_id: this.userService._agencyID,
              agent_create: this.userService._agentID,
            };
            this._itineraryService.addClientToAgency(client).subscribe({
              next: (response: any) => {
              },
              error: (error: HttpErrorResponse) => {
                // console.log(error);
              }
            });
          } else {
            this.ngxSpinner.hide();
            this.notificationService.info("Ocurrio un problema al crear el cliente. Intentelo nuevamente por favor");
          }
         }
        },
        error: (error: HttpErrorResponse) => {
          // console.log(error)
        }
      });
    }

    if (this.data.typeAction == "New" && this.data.fromAssociates === true) {
      if(this.clientData.checkboxChecked === true) {
        const payload = {
          id: this.clientData.mainClient.id,
          client_associated_id: this.clientData.client_associated_id,
          relation_ship_catalogue_id: this._form.value.paxes[0].relation_ship,
        }
        this._restService.doPost("app", "clients/associateClient", payload).subscribe({
          next: (res: any) => {
            this.ngxSpinner.hide();
            const client = {
              canMod: true,
            }
            let data: any = {
              type: "_clientNewEmitter",
              client: client
            };
            this.notificationService.success("Cliente Asociado Satisfactoriamente");
            this.closeModal(data);
          },
          error: (error: any) => {
            console.error(error);
          }
        })
      } else {

          payload.relation_ship_catalogue_id = this._form.value.paxes[0].relation_ship;
          if(!this.clientData.checkboxChecked) {
            const country = this.filteredCountries.find(c => c.country_name === this.selectedIsCountry[0]);
            const state = this.stateFiltered.find(c => c.destination_name === this.selectedIsState[0]);
            payload.country = country?.country_code ?? null;
            payload.state = state?.destination_id ?? null;
          }
          payload.id = this.clientData.mainClient.id;
          // // console.log("crea cliente nuevo y asocia");
          // // console.log("clientsassociateClient");
          this._restService.doPost("app", "clients/associateClient", payload).subscribe(
            (responseNew) => {
              if (responseNew.success) {
                this.ngxSpinner.hide();
                if(responseNew.message === 'Client Exist') {
                  this.notificationService.info("Este email y/o número de documento ya fueron registrados");
                } else {
                  let data = {
                    type: "_clientNewEmitter",
                    client: responseNew.client,
                  };
                  this.notificationService.success("Cliente Creado Satisfactoriamente")
                  this.closeModal(data);
                  const client = {
                    client_id: responseNew.client.original.id,
                    agency_id: this.userService._agencyID,
                    agent_create: this.userService._agentID,
                  };
                  this._itineraryService.addClientToAgency(client).subscribe((response: any) => {

                  });
                }
              } else {
                this.ngxSpinner.hide();
                this.notificationService.info('Ocurrio un problema al crear el cliente. Intentelo nuevamente por favor');
              }
            },
            (error) => {
              // console.log(error);
            }
          );
      }
    }

    if (this.data.typeAction == "Edit") {
      payload.id = this.data.fromAssociates === true ? this.clientData.assosiateClient.client_id : this.clientData.mainClient.id;
      // payload.country = this._form.value.paxes[0].country_id;
      // payload.state = this._form.value.paxes[0].state_id;

      payload.relation_ship_catalogue_id = this.clientData.relationId;

      if(this.data.fromAssociates === true) {
        payload.relation_ship_catalogue_id = this.clientData.relationId ? this.clientData.relationId : this.clientData.assosiateClient.relation_ship_catalogue_id;
      }
      // console.log(JSON.stringify(payload))
      //save to itinerary
      this._restService.doPut("app", "clients/" + payload.id, payload).subscribe(
        (response: any) => {
          // console.log(response)
          this.ngxSpinner.hide();
          if (response.men === 'Updated successfully') {
            const client: any = this.clientEdit(payload, this.clientData, this._form, birthDate);
            this.notificationService.success("Cliente Actualizado Satisfactoriamente")

            if (!this.data.fromAssociates) {
              client.itineraries = this.clientData.mainClient.itineraries;
              let data = {
                type: "_clientNewEmitter",
                client: client,
              };
              this.closeModal(data);
              //this._clientNewEmitter.emit(client);
            } else {
              let data = {
                type: "_clientEmitter",
                client: client,
              };
              this.closeModal(data);
            }
          } else {
            this.ngxSpinner.hide();
            this.notificationService.success("Cliente Creado Satisfactoriamente")
            this.closeModal()
            // this.dialog.open(MaterialModalAlertComponent, {
            //   width: "500px",
            //   data:  "Ocurrio un problema AL Modificar el Cliente",
            //   disableClose: true,
            // });
          }
        },
        (error) => {
       //   this.ngxSpinner.hide();
          // console.log("Update-Error: " + error);
        }
      );
    }
  }

  clientEdit(payload: any, client: any, form: any,birthDate: any) {
    return {
      id: payload.id,
      index: client.index,
      first_name: form.value.paxes[0].first_name,
      last_name: form.value.paxes[0].last_name,
      email: form.value.paxes[0].email,
      phone: form.value.paxes[0].phone,
      phone_code: form.value.paxes[0].phone_code,
      phone2: form.value.paxes[0].phone_2,
      phone2_code: form.value.paxes[0].phone_2_code,
      country: form.value.paxes[0].country_id ? this._form.value.paxes[0].country_id : null,
      state: form.value.paxes[0].state_id ? this._form.value.paxes[0].state_id : null,
      city: form.value.paxes[0].city ? this._form.value.paxes[0].city : null,
      address: form.value.paxes[0].address,
      birth_date: birthDate,
      title: form.value.paxes[0].title,
      document: form.value.paxes[0].document_type_id,
      document_number: form.value.paxes[0].document_number,
      gender: form.value.paxes[0].gender,
      postal_code: form.value.paxes[0].postal_code,
      relation_ship: this.clientData.relationId,
    }
  }

  closeModal(data?): void {
    // this.resetData();
   this.bsModalRef.hide();

     // Emitir el resultado
  this.confirmResult.emit(data);
  }

  resetData(): void {
    this.clientData.clientsAssociatedArr = [];
    this.selectedIsCity = [];
    this.selectedIsCountry = [];
    this.selectedIsState = [];
    this.clientData.mainClient = [];
    this.clientData.assosiateClient = [];
    this.data.fromAssociates = false;
    this._form.reset();
  }


  formClientValid(): boolean {
    return false;
  }

onPhoneBlur(index: number, country_code?: any): void {
  if (this.data.typeAction) return;

  if (!this.itineraryItems.some(c => c.category_id === 8)) return;

  const controlValues = this._form.controls.paxes as FormArray;

  const phoneControl = controlValues.controls[index]?.get('phone');

  if(controlValues.controls[index]?.get('type').value !== 'adult') return;

  if (!phoneControl) return;

  // // 1. Iniciar validación
  // this.isPhoneValidating[index] = true;

  phoneControl.setErrors({
    ...phoneControl.errors,
    validating: true
  }, { emitEvent: false });

  // 2. Preparar payload
  const phoneData = this.preparePhonePayload(index);

  if (!phoneData) {
    this.handlePhoneValidationComplete(index, phoneControl, false);
    return;
  }

  // 3. Llamar API
  this._itineraryService.phoneValidator(phoneData.payload).subscribe({
    next: (res) => {

      if(res !== undefined) {
        this.handlePhoneValidationComplete(index, phoneControl, res.success);
      }
    },
    error: (err) => {
      console.error(`Índice ${index}: Error API`, err);
      this.handlePhoneValidationComplete(index, phoneControl, false);
    }
    });
}

private preparePhonePayload(index: number): { payload: any } | null {
  const controlValues = this._form.controls.paxes as FormArray;
  const phoneCode = controlValues.value[index].phone_code;
  const phoneValue = controlValues.value[index].phone;

  if (!phoneValue || !phoneCode) return null;

  let code: string = '';
  if (/^\d+$/.test(phoneCode)) {
    code = phoneCode;
  } else {
    const match = phoneCode?.match(/\((\+\d+)\)/);
    code = match ? match[1].replace('+', '') : '';
  }

  const country = this.formPaxesReservationData?.countries.find(c =>
    c.phone_code === code.toString()
  );

  if (!country?.country_code) return null;

  return {
    payload: {
      phoneNumber: `+${code}${phoneValue}`,
      country: country.country_code
    }
  };
}

hasPhoneError(index: number): boolean {
    const phoneControl = this._form.get(['paxes', index, 'phone']);
    const phoneValue = phoneControl?.value;
    const errors = phoneControl?.errors;

    // Si está validando, no mostrar error
    if (this.isPhoneValidating[index]) {
        return false;
    }

    // Si está vacío
    if (phoneValue == null || phoneValue === '') {
        return true;
    }

    // Si tiene errores
    return !!(errors?.pattern || errors?.invalidPhone);
}

hasPhoneValid(index: number): boolean {
    const phoneControl = this._form.get(['paxes', index, 'phone']);
    const phoneValue = phoneControl?.value;
    const errors = phoneControl?.errors;
    // Solo válido si: tiene valor + no tiene errores + no está validando
    return !!(
        phoneValue &&
        phoneValue !== '' &&
        !errors?.pattern &&
        !errors?.invalidPhone &&
        !this.isPhoneValidating[index]
    );
}

private handlePhoneValidationComplete(
  index: number,
  phoneControl: AbstractControl,
  isValid: boolean
): void {

  // Deshabilitar validadores temporalmente
  const originalValidators = phoneControl.validator;
  phoneControl.clearValidators();

  const currentErrors = phoneControl.errors;
  let newErrors = currentErrors ? { ...currentErrors } : {};

  delete newErrors.validating;

  if (isValid) {
    delete newErrors.invalidPhone;
  } else {
    newErrors.invalidPhone = true;
  }

  const finalErrors = Object.keys(newErrors).length > 0 ? newErrors : null;


  phoneControl.setErrors(finalErrors, { emitEvent: false });

  // Restaurar validadores
  if (originalValidators) {
    phoneControl.setValidators(originalValidators);
  }

  // Usar markAsDirty() en lugar de markAsTouched() si es posible
  phoneControl.markAsDirty();
  console.groupEnd();

  this.isPhoneValidating[index] = false;

  // Forzar detección de cambios SIN markForCheck
  setTimeout(() => {
    this.cdr.detectChanges();
  });
}

/**
 * Maneja el evento keydown para validar las teclas permitidas según el tipo de documento
 * @param event - Evento de teclado
 * @param i - Índice del pasajero
 */
onDocumentKeyDown(event: KeyboardEvent, i: number): void {
  const documentTypeId = this._form?.get(`paxes.${i}.document_type_id`)?.value;
  const isDNI = documentTypeId === '4' || documentTypeId === 4;

  if (isDNI) {
    this.blockInvalidKeys(event, 'DNI');
  } else {
    this.blockInvalidKeys(event, 'alfanumerico');
  }
}

blockInvalidKeysDocumentNumber(event: KeyboardEvent) {
  const input = event.target as HTMLInputElement;
  const isSymbolAtStart = ['-', '.'].includes(event.key) && input.selectionStart === 0;
  const isAllowedKey = /^[a-zA-Z0-9\-.]$/.test(event.key) ||
                      ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(event.key);

  if (!isAllowedKey || isSymbolAtStart) {
    event.preventDefault();
  }
}

getNamePaxes(index: number, type: string): string {
    const paxesArray = this._form.get('paxes') as FormArray;
    if (!paxesArray || !paxesArray.at(index)) return '';

    const formGroupAtIndex = paxesArray.at(index) as FormGroup;
    const firstName = formGroupAtIndex.get('first_name')?.value || '';
    const lastName = formGroupAtIndex.get('last_name')?.value || '';

    return firstName || lastName ? (`${firstName} ${lastName}`.trim()) : 'NOMBRE';
}

inputValueName(index: number): void {
    const paxesArray = this._form.get('paxes') as FormArray;
    if (!paxesArray || !paxesArray.at(index)) return;
    const formGroupAtIndex = paxesArray.at(index) as FormGroup;
    const firstName = formGroupAtIndex.get('first_name')?.value || '';
    const lastName = formGroupAtIndex.get('last_name')?.value || '';

    this.namesPaxes[index] = firstName || lastName ? (`${firstName} ${lastName}`.trim()) : '';

}

/**
 * Agrega un nuevo formulario de pasajero al FormArray
 * @param type Tipo de pasajero ('adult' o 'children')
 */
addForm(type: string): void {

  // Obtener el FormArray 'paxes'
  const paxesArray = this._form.get('paxes') as FormArray;

  let age = null;
  let arrivalDate = null;
  let arrivalDateString = null;

  // Crear índice para el nuevo pasajero
  const newIndex = paxesArray.length;

  // Agregar objetos vacíos para estados y ciudades
  this.formPaxesReservationData.states.push({ states: [] });
  this.formPaxesReservationData.cities.push({ cities: [] });
  this.associatedFilterView.push(this.associatedClients.length > 0 ? true : false);

  // Configurar fecha de nacimiento según el tipo
  let birthDate: any;
  let childIndexToAdd: number | null = null;
  let adultIndexToAdd: number | null = null;

  if (type === 'adult') {
    // ✅ Si alguna asistencia todavía requiere una edad de adulto, este adulto la toma
    adultIndexToAdd = this.getNextMissingAgeIndex('adult');
    const adultData = adultIndexToAdd !== null ? this.totalPasajeros.adultsWithDates[adultIndexToAdd] : null;

    if (adultData && adultData.arrivalDate) {
      age = adultData.age;
      arrivalDate = adultData.arrivalDate;
      arrivalDateString = adultData.arrivalDateString;
      birthDate = this.parseDateStringToDate(this.getBirthDateFromAge(age, new Date(arrivalDate)));
    } else {
      adultIndexToAdd = null;
      const minDate = new Date(this.formPaxesReservationData.minDateAdult);
      minDate.setFullYear(minDate.getFullYear() - 50);
      const day = String(minDate.getDate()).padStart(2, '0');
      const month = String(minDate.getMonth() + 1).padStart(2, '0');
      const year = minDate.getFullYear();
      birthDate = `${day}-${month}-${year}`;
    }
  } else {
    // ✅ PARA NIÑOS: Obtener el próximo índice de niño que falta
    childIndexToAdd = this.getNextMissingChildIndex();
    if (childIndexToAdd === null) {
      this.notificationService.warning('Todos los niños ya han sido agregados');
      return;
    }

    // ✅ Obtener la edad y fecha de llegada de ese índice
    const childData = this.totalPasajeros.childrenWithDates[childIndexToAdd];
    age = childData?.age,
    arrivalDate = childData?.arrivalDate,
    arrivalDateString = childData?.arrivalDateString;

    if (childData && childData.arrivalDate) {
      const age = childData.age;
      const arrivalDate = new Date(childData.arrivalDate);
      const birthYear = arrivalDate.getFullYear() - age;
      const birthMonth = arrivalDate.getMonth();
      const birthDay = arrivalDate.getDate();

      const birthDateObj = new Date(Date.UTC(birthYear, birthMonth, birthDay, 12, 0, 0));

      const day = String(birthDateObj.getDate()).padStart(2, '0');
      const month = String(birthDateObj.getMonth() + 1).padStart(2, '0');
      const year = birthDateObj.getFullYear();
      birthDate = `${day}-${month}-${year}`;
    } else {
      const currentDate = new Date();
      const day = String(currentDate.getDate()).padStart(2, '0');
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const year = currentDate.getFullYear();
      birthDate = `${day}-${month}-${year}`;
    }


    const birthDateTypeDate: any = this.parseDateStringToDate(birthDate);
    birthDate = birthDateTypeDate;
  }

  // Crear nuevo objeto de pasajero
  const newPax = {
    ...this.paxEmpty,
    birth_date: birthDate,
    type: type
  };

  // Agregar a la lista de pasajeros
  this.formPaxesReservationData.paxList.push(newPax);

  // Crear y agregar el FormGroup al FormArray
  const newFormGroup = this.fb.group({
    gender: [null],
    title: [null],
    first_name: [null, [Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]],
    last_name: [null, [Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]],
    birth_date: [birthDate],
    document_type_id: [null],
    document_number: [null, [this.nonNegativeValidator(), this.documentMinLengthValidator()]],
    email: [null, [Validators.email, this.validateEmail.bind(this)]],
    phone: [null, Validators.pattern(/^\d{6,}$/)],
    phone_code: [null],
    phone_code_selected: [null],
    phone_2: [null, Validators.pattern(/^\d{6,}$/)],
    phone_2_code: [null],
    phone_2_code_selected: [null],
    country_id: [null],
    state_id: [null],
    city: [null],
    address: [null],
    relation_ship: [7],
    postal_code: [null, Validators.pattern("^[0-9]*$")],
    clientSelected: [null],
    clientId: [null],
    idUnique: this.getRandom(),
    type: [type],
    paxOptional: true,
  });

  // ✅ Guardar el índice del niño en el FormGroup si es children
  if (type === 'children' && childIndexToAdd !== null) {
    newFormGroup.addControl('_childIndex', this.fb.control(childIndexToAdd));
  }

  paxesArray.push(newFormGroup);

  this.initializeSearchControlForIndex(newIndex);

  // ✅ CALCULAR EL NÚMERO CORRECTO PARA EL NUEVO PAX
  const newNumber = this.calculateNextPaxNumber(type);


  // age/arrivalDate quedan en null para un adulto sin edad de asistencia pendiente
  this.paxes.push({
    type: type,
    number: newNumber,
    title: type === 'adult' ? `Adulto ${newNumber}` : `Niño ${newNumber}`,
    age: age,
    arrivalDate: arrivalDate,
    arrivalDateString: arrivalDateString,
    ageIndex: type === 'adult' ? adultIndexToAdd : childIndexToAdd
  });



  // Configurar valores compartidos si es un niño o si es un adulto pax mayor a dos
  if (type === 'children' || newIndex > 1) {
    this.setSharedValuesForChild(newIndex);
  }

  // Actualizar contadores
  this.formPaxesReservationData.contadorBirthDate++;

  this.generateEditDataPaxes();

  this.valueQtyPaxModified.emit({ type: type, sum: true });

  this._onSubmit(true);
}

// ✅ MÉTODOS AUXILIARES PARA ÍNDICES

/**
 * Obtiene el próximo índice de niño que falta por agregar
 * @returns El índice de la edad faltante o null si todas están agregadas
 */
private getNextMissingChildIndex(): number | null {
  return this.getNextMissingAgeIndex('children');
}

/**
 * Obtiene el próximo índice de childrenWithDates / adultsWithDates que todavía
 * no tiene un pax asignado. Se toma de this.paxes[].ageIndex, que incluye tanto
 * los pax iniciales (asignados en el padre) como los agregados con addForm.
 * @returns El índice de la edad faltante o null si todas están cubiertas
 */
private getNextMissingAgeIndex(type: 'adult' | 'children'): number | null {
  const agesWithDates = type === 'adult' ? this.totalPasajeros?.adultsWithDates : this.totalPasajeros?.childrenWithDates;
  const total = agesWithDates?.length || 0;

  const existingIndices = (this.paxes || [])
    .filter(pax => pax.type === type && pax.ageIndex !== null && pax.ageIndex !== undefined)
    .map(pax => pax.ageIndex);

  for (let i = 0; i < total; i++) {
    if (!existingIndices.includes(i)) {
      return i;
    }
  }

  return null; // Todas las edades están cubiertas
}

/**
 * Verifica si se puede agregar otro niño
 */
canAddChild(): boolean {
  return this.getNextMissingChildIndex() !== null;
}

/**
 * Obtiene el total de niños que deberían existir
 */
getTotalChildrenCount(): number {
  return this.totalPasajeros.childrenWithDates?.length || 0;
}

/**
 * Obtiene el total de niños ya agregados
 */
getAddedChildrenCount(): number {
  return (this.paxes || [])
    .filter(pax => pax.type === 'children' && pax.ageIndex !== null && pax.ageIndex !== undefined)
    .length;
}

/**
 * Inicializa los controles de búsqueda para un índice específico
 */
private initializeSearchControlForIndex(index: number): void {
  // Crear control de búsqueda para el nuevo índice
  const searchControl = new FormControl('');
  this.clientSearchControls[index] = searchControl;

  // Configurar filtrado para el autocomplete
  this.filteredClients[index] = searchControl.valueChanges.pipe(
    startWith(''),
    map(value => this.filterClients(value, index))
  );
}

/**
 * Calcula el siguiente número consecutivo para el tipo de pasajero
 */
private calculateNextPaxNumber(type: string): number {
  // Contar cuántos pasajeros del mismo tipo ya existen
  const sameTypeCount = this.paxes.filter(pax => pax.type === type).length;

  // El nuevo número es la cantidad existente + 1
  return sameTypeCount + 1;
}

/**
 * Configura valores compartidos para pasajeros niños
 * @param index Índice del nuevo pasajero niño
 */
private setSharedValuesForChild(index: number): void {
  const paxesArray = this._form.get('paxes') as FormArray;
  const parentControl = paxesArray.at(0); // Asume que el primer pasajero es el padre

  if (!parentControl) return;

  const childControl = paxesArray.at(index);

  // Campos a compartir
  const sharedFields = [
    'email', 'phone_code', 'phone', 'country_id',
    'state_id', 'city', 'address'
  ];

  sharedFields.forEach(field => {
    const parentValue = parentControl.get(field)?.value;
    if (parentValue) {
      childControl.get(field)?.setValue(parentValue);

      // Manejo especial para campos con lógica adicional
      if (field === 'country_id') {
        this.getCountriesData(index, true, parentValue, 'child');
      } else if (field === 'state_id') {
        setTimeout(() => {
          this.getStatesData(index, parentControl.get('country_id')?.value);
        }, 100);
      } else if (field === 'city') {
        setTimeout(() => {
          this.getCitiesData(index, parentValue, true);
        }, 500);
      } else if (field === 'phone_code') {
        setTimeout(() => {
          this.changePhoneCode(index, parentValue, 'phone_code');
        }, 100);
      }
    }
  });
}

setPaxAdults(): void {
  const paxesArray = this._form.get('paxes') as FormArray;
  const parentControl = paxesArray.at(0); // Asume que el primer pasajero es el padre

  if (!parentControl) return;

  const control = paxesArray.at(1);

  // Campos a compartir
  const sharedFields = [
    'phone_code', 'phone', 'country_id',
    'state_id', 'city', 'address'
  ];

    sharedFields.forEach(field => {
    const parentValue = parentControl.get(field)?.value;
    if (parentValue) {
      control.get(field)?.setValue(parentValue);

      // Manejo especial para campos con lógica adicional
      if (field === 'country_id') {
        this.getCountriesData(1, true, parentValue, 'adult');
      } else if (field === 'state_id') {
        setTimeout(() => {
          const iata_country = this.formPaxesReservationData.countries.find(c => c.country_name === parentControl.get('country_id')?.value);
          this.getStatesData(1, iata_country.country_code);
        }, 100);
      } else if (field === 'city') {
        setTimeout(() => {
          this.getCitiesData(1, parentValue, true);
        }, 500);
      }
      else if (field === 'phone_code') {
        setTimeout(() => {
          this.changePhoneCode(1, parentValue, 'phone_code');
        }, 100);
      }
    }

  });


  this.notificationService.info('Datos copiados del titular');
}

removeOptionalForm(index: number): void {
  // Obtener el FormArray 'paxes'
  const paxesArray = this._form.get('paxes') as FormArray;

  // Verificar que el índice existe
  if (index < 0 || index >= paxesArray.length) {
    console.error('Índice inválido:', index);
    return;
  }

  this.valueQtyPaxModified.emit({type: paxesArray.at(index).get('type').value, sum: false});
  this.clientSearchControls.splice(index, 1);
  this.filteredClients.splice(index, 1);

  // Remover el formulario del FormArray
  paxesArray.removeAt(index);

  // Remover los datos correspondientes de los arrays auxiliares
  if (this.formPaxesReservationData.states[index]) {
    this.formPaxesReservationData.states.splice(index, 1);
  }

  if (this.formPaxesReservationData.cities[index]) {
    this.formPaxesReservationData.cities.splice(index, 1);
  }

  // Remover de la lista de pasajeros
  if (this.formPaxesReservationData.paxList[index]) {
    this.formPaxesReservationData.paxList.splice(index, 1);
  }

  // Actualizar el array de paxes (si lo usas para mostrar)
  if (this.paxes[index]) {
    this.paxes.splice(index, 1);
    // this.formPaxesReservationData.clientIdArr.splice(index, 1);
    // Re-numerar los títulos de los paxes restantes
    this.renumberPaxesTitles();
  }

  if(this.associatedFilterView[index]) {
    this.associatedFilterView.splice(index, 1);
  }

  this.generateEditDataPaxes();

  // Actualizar contador
  if (this.formPaxesReservationData.contadorBirthDate > 0) {
    this.formPaxesReservationData.contadorBirthDate--;
  }

  // Forzar la actualización de la vista
  this._form.updateValueAndValidity();

  this._onSubmit(true);

  this.cdr.detectChanges();

}

/**
 * Re-numerar los títulos de los pasajeros después de eliminar uno
 */
private renumberPaxesTitles(): void {
  let adultCount = 1;
  let childCount = 1;

  this.paxes.forEach(pax => {
    if (pax.type === 'adult') {
      pax.title = `Adulto ${adultCount}`;
      pax.number = adultCount;
      adultCount++;
    } else if (pax.type === 'children') {
      pax.title = `Niño ${childCount}`;
      pax.number = childCount;
      childCount++;
    }
  });
}

getAge(date: any, paxIndex: number): string {

  if (!date) return 'Seleccionar fecha';

  // Obtener el arrivalDateString del niño desde this.paxes
  const arrivalDateString = this.paxes[paxIndex]?.arrivalDateString;

  if (!arrivalDateString) {
    return 'Fecha de servicio no disponible';
  }

  // Parsear fecha de nacimiento
  const birthDate = moment(date);

  if (!birthDate.isValid()) {
    console.warn('Fecha inválida:', date);
    return 'Fecha inválida';
  }

  // Parsear arrivalDate desde el string
  const arrivalDate = moment(arrivalDateString, 'YYYY-MM-DD');

  // Calcular edad usando el arrivalDate como referencia
  const age = arrivalDate.diff(birthDate, 'years');

  return `${age} ${age === 1 ? 'año' : 'años'}`;
}

editDataPassenger(index: number): void {
  this.editDataPax[index] = !this.editDataPax[index];



}

  /**
 * Función de display para mostrar el valor seleccionado en campos de autocompletado
 *
 * Este método determina qué propiedad del objeto seleccionado mostrar en el input
 * después de la selección, con soporte para múltiples estructuras de datos.
 *
 * @param {any} name - Objeto seleccionado del autocompletado
 * @returns {string} - Valor a mostrar en el campo de input
 *
 * @logic
 * - Prioridad 1: name.name (para objetos con propiedad name)
 * - Prioridad 2: name.city_name (para objetos con propiedad city_name)
 * - Retorna undefined si el objeto no tiene propiedades válidas
 *
 * @supportedStructures
 * - { name: "Hotel Name" } → "Hotel Name"
 * - { city_name: "New York" } → "New York"
 *
 * @usage
 * Utilizado por componentes mat-autocomplete para display del valor seleccionado
 */
  displayFn(name: any) {

    if (name) {
      const client = this.formPaxesReservationData.clientsAssociated.find(c => c.id === name);

      return `${client.fisrt_name} ${client.last_name} (${client.email} ${client.document_type_id === 4 ? '- DNI: ' : '- Pasaporte: '} ${client.document_number})`;
    }
  }

// Método para normalizar el email
normalizeEmail(email: string, index: number): void {
    if (!email) return;

    const normalizedEmail = email
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '');

    const control = this._form.get('paxes').get(index.toString()).get('email');
    control.setValue(normalizedEmail, { emitEvent: false });

}

sortClientsByLastName(clients: any[]): any[] {
  return [...clients].sort((a, b) => {
    // Caso 1: Ambos sin last_name
    if (!a.last_name && !b.last_name) return 0;

    // Caso 2: Solo a sin last_name → va al final
    if (!a.last_name) return 1;

    // Caso 3: Solo b sin last_name → b va al final, a antes
    if (!b.last_name) return -1;

    // Caso 4: Ambos tienen last_name → orden alfabético
    return a.last_name.localeCompare(b.last_name);
  });
}

changeViewsClientsSelected(index): void {
  this.associatedFilterView[index] = !this.associatedFilterView[index];

  const currentValue = this.clientSearchControls[index]?.value;
  if (this.clientSearchControls[index]) {
    // Forzar emisión del mismo valor para que se re-ejecute el filtro
    this.clientSearchControls[index].setValue(currentValue || '');
  }
}
/**
 * Obtiene la fecha máxima para un niño según su edad y fecha de llegada
 * @param age - Edad del niño en años
 * @param arrivalDate - Fecha de llegada del item (opcional, se usa como respaldo)
 * @param arrivalDateString - String original de la fecha (YYYY-MM-DD)
 * @returns Fecha máxima (referencia - age años - 1 día). Se excluye a quien cumple años
 * justo en la referencia para no depender de la hora con que se compare la fecha.
 */
getChildMaxDate(age: number, arrivalDate: Date, arrivalDateString?: string): Date | null {
  const reference = this.getAgeReferenceDate(arrivalDate, arrivalDateString);
  if (!reference) {
    console.warn('Fecha de llegada no disponible para calcular maxDate');
    return null;
  }

  return reference.clone().subtract(age, 'years').subtract(1, 'day').startOf('day').toDate();
}

/**
 * Fecha contra la que se calcula la edad (arrivalDateString, YYYY-MM-DD).
 * Sin el string se usa arrivalDate, que el padre guarda un día antes de la referencia.
 */
private getAgeReferenceDate(arrivalDate: Date, arrivalDateString?: string): moment.Moment | null {
  if (arrivalDateString) {
    return moment(arrivalDateString, 'YYYY-MM-DD');
  }
  if (!arrivalDate || isNaN(new Date(arrivalDate).getTime())) {
    return null;
  }
  return moment(arrivalDate).add(1, 'day');
}

/**
 * Obtiene la fecha mínima para un niño según su edad y fecha de llegada
 * @param age - Edad del niño en años
 * @param arrivalDate - Fecha de llegada del item (opcional, se usa como respaldo)
 * @param arrivalDateString - String original de la fecha (YYYY-MM-DD)
 * @returns Fecha mínima (referencia - (age + 1) años + 1 día): quien nació el día anterior ya cumple age + 1
 */
getChildMinDate(age: number, arrivalDate: Date, arrivalDateString?: string): Date | null {
  const reference = this.getAgeReferenceDate(arrivalDate, arrivalDateString);
  if (!reference) {
    console.warn('Fecha de llegada no disponible para calcular minDate');
    return null;
  }

  return reference.clone().subtract(age + 1, 'years').add(1, 'day').startOf('day').toDate();
}
/**
 * "Datos de contacto a enviar al proveedor" (aplica a toda la reserva).
 * Pasar a datos de la agencia pide confirmación; si se cancela, vuelve a datos del pasajero.
 * @param passengerRadio radio "Datos del pasajero", para re-marcarlo si se cancela
 */
onContactProviderDataChange(useAgencyData: boolean, passengerRadio: HTMLInputElement): void {
  if (!useAgencyData) {
    this.saveContactProviderData(false);
    return;
  }

  const modalConfig: any = {
    initialState: {
      icon: 'assets/icons/itinerary-detail/04-01.svg',
      title: 'Datos de la agencia',
      message: 'Si continúa, se enviarán al proveedor los <b>datos de contacto de la agencia</b> ' +
               'en lugar de los del pasajero.<br />' +
               'Los datos personales de los pasajeros no se modifican. ¿Desea continuar?',
      confirmText: 'Sí',
      cancelText: 'No',
    },
    ...this.config,
  };

  this.bsModal = this.modalService.show(ConfirmationModalComponent, modalConfig);
  const confirmSubscription = this.bsModal?.content?.confirmResult?.subscribe((result: boolean) => {
    if (result === true) {
      this.saveContactProviderData(true);
    } else if (passengerRadio) {
      passengerRadio.checked = true;
    }
    confirmSubscription?.unsubscribe();
  });

}

/**
 * Guarda en los items de la reserva (contact_agency_data) qué datos de contacto se envían
 * al proveedor y persiste el itinerario, para recuperar la elección si se recarga la reserva.
 * Se lee luego desde el primer item (ver ItineraryReservationComponent).
 */
private saveContactProviderData(useAgencyData: boolean): void {
  const previous = this.userService.contactAgencyData;
  this.userService.contactAgencyData = useAgencyData;

  if (previous === useAgencyData || !this.itinerary?.items?.length) {
    return;
  }

  const reservedIds = new Set((this.itineraryItems || []).map((reservedItem: any) => reservedItem.id));
  this.itinerary.items.forEach((item: any) => {
    if (reservedIds.has(item.id)) {
      item.contact_agency_data = useAgencyData;
    }
  });
  (this.itineraryItems || []).forEach((reservedItem: any) => {
    reservedItem.contact_agency_data = useAgencyData;
  });

  this.itinerary.clientId = this.itinerary.client_id;
  this._itineraryService.updateItinerary(this.itinerary);
}

getPlaceholderClients(i): string{


  if(i === 0) {
    return 'Seleccionar clientes';
  }

  if(this.associatedFilterView[i] && this.associatedClients && this.associatedClients.length > 0) {
    return 'Seleccionar asociados';
  } else {
     return  'Seleccionar clientes';
  }


}

/**
 * Obtiene las clases de validación para un campo
 * Solo muestra validación si el campo existe en la configuración para ese índice
 */
getFieldValidationClass(index: number, fieldName: string): any {
  const control = this._form.get(['paxes', index, fieldName]);
  const value = this._form.value.paxes[index]?.[fieldName];
  if (!control) {
    console.log('❌ No hay control');
    return {};
  }

  // Rechazo del backend al guardar (email/documento ya registrado, etc.): tiene prioridad
  if (this.getServerPaxError(index, fieldName)) {
    return { 'is-invalid': true, 'is-valid': false };
  }

  // Si es onlyTransports y NO es el primer pasajero: solo el país es obligatorio.
  // No limpiar los errores del país: este método corre en cada change detection y, al
  // borrarlos, el país vacío (p. ej. tras eliminar el cliente) quedaba válido y el pax en "Listo".
  if (this.onlyTransports && index !== 0 && fieldName !== 'country_id') {
    if (control.errors) {
      control.setErrors(null);
    }
    return {};
  }

  const config = this.getValidationConfig(index);
  const fieldConfig = config[fieldName];
  if (!fieldConfig) {
    if (control.errors) {
      control.setErrors(null);
    }
    return {};
  }

  // 🔹 Si el campo existe pero NO es requerido y está vacío, no mostrar validación
  if (!fieldConfig.required && (value === '' || value === null || value === undefined)) {
    return {};
  }

  // Verificar si es inválido
  const isInvalid = control.invalid ||
                    (fieldConfig.required && (value === '' || value === null || value === undefined));

  // Verificar si es válido
  const isValid = control.valid &&
                  value !== '' &&
                  value !== null &&
                  value !== undefined;

  return {
    'is-invalid': isInvalid,
    'is-valid': isValid
  };
}

// Función para obtener la configuración según el índice
getValidationConfig(index: number): PaxValidationConfig {
  const paxList = this.formPaxesReservationData?.paxList || [];
  const paxType = paxList[index]?.type;
  const isChild = paxType === 'children';

  if(this.data.typeAction) {
  return ClientMainValidation;
  }

  // Solo transporte
   if (this.onlyTransports) {
    if (index === 0) {
      return OnlyTransportValidation;
    }
    return { country_id: { required: true, validators: [Validators.required] } };
  }

  // Primer pasajero
  if (index === 0) {
    return FirstPaxValidation;
  }

  // Segundo pasajero (adulto)
  if (index === 1 && !isChild) {
    return SecondPaxValidation;
  }

  // Tercero o niños
  return ChildOrThirdPaxValidation;
}


  //  (!associatedFilterView[i] && associatedClients && associatedClients.length > 0) || i == 0 ? 'Seleccionar asociados' :  'Seleccionar clientes'}}"

}

